package com.havn.app.core.localization

// Generated from composeResources/values*/strings.xml. Do not edit by hand.
object HavnStringCatalog {
    fun stringsFor(language: HavnLanguage): HavnStrings = when (language) {
        HavnLanguage.English -> english
        HavnLanguage.Slovak -> slovak
        HavnLanguage.German -> german
        HavnLanguage.French -> french
        HavnLanguage.Czech -> czech
        HavnLanguage.Spanish -> spanish
        HavnLanguage.Italian -> italian
    }

    private val english: HavnStrings = object : HavnStrings {
        override val navToday: String = "Today"
        override val navProperties: String = "Properties"
        override val navLeads: String = "Leads"
        override val navReports: String = "Reports"
        override val navSettings: String = "Settings"
        override val navAuth: String = "Agent access"
        override val navOpenHouses: String = "Openings"
        override val navTours: String = "Openings"
        override val navFollowUps: String = "Contacts"
        override val navFollow: String = "Contacts"
        override val back: String = "Back"
        override val settingsEyebrow: String = "Workspace"
        override val settingsTitle: String = "Settings"
        override val settingsSubtitle: String = "Brokerage profile, invite policy, Supabase configuration, storage buckets, and team roles."
        override val agentProfileTitle: String = "Agent profile"
        override val agentPhoto: String = "Agent photo"
        override val uploading: String = "Uploading..."
        override val saving: String = "Saving..."
        override val validAgentPhotoRequired: String = "Choose a valid agent photo."
        override val signOut: String = "Sign out"
        override val signOutQuestion: String = "Sign out?"
        override val signOutConfirmation: String = "Are you sure you want to sign out of HAVN?"
        override val upgrade: String = "Upgrade"
        override val premiumThemesTitle: String = "Premium themes"
        override val premiumThemesUpgradePrompt: String = "Upgrade to Pro to unlock premium themes."
        override val appearanceTitle: String = "Appearance"
        override val appearanceBody: String = "Choose a curated HAVN theme. Premium themes unlock with Pro."
        override val previewComponents: String = "Preview components"
        override val themeShowcaseTitle: String = "Theme showcase"
        override val showcaseButtons: String = "Buttons"
        override val showcasePrimaryAction: String = "Primary action"
        override val showcaseSecondaryAction: String = "Secondary action"
        override val showcaseGhostAction: String = "Ghost action"
        override val showcaseTextField: String = "Text field"
        override val showcaseFocusedBorder: String = "Focused accent border"
        override val showcaseSearchPreview: String = "Search preview"
        override val showcaseOpeningCheckedIn: String = "Opening checked in today"
        override val showcaseSentAt: String = "Sent at 10:30 AM"
        override val themeObsidianGoldName: String = "Obsidian Gold"
        override val themeObsidianGoldDescription: String = "Luxury black, graphite, and warm gold."
        override val themeMidnightSapphireName: String = "Midnight Sapphire"
        override val themeMidnightSapphireDescription: String = "Deep navy, sapphire blue, and silver accents."
        override val themeEmeraldEstateName: String = "Emerald Estate"
        override val themeEmeraldEstateDescription: String = "Dark emerald, charcoal, and champagne gold."
        override val themePlatinumStoneName: String = "Platinum Stone"
        override val themePlatinumStoneDescription: String = "Stone gray, platinum, and soft white."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Dark wine, graphite, and copper accents."
        override val commonChange: String = "Change"
        override val agentPlanTitle: String = "Agent plan"
        override val agentPlanBody: String = "Upgrade your experience, choose the plan that fits how you work best."
        override val currentPlan: String = "Current plan"
        override val transferPlan: String = "Transfer plan"
        override val restorePurchase: String = "Restore purchase"
        override val agencySettingsProBody: String = "Solo agency is active by default. Pro lets you create or select a shared agency workspace."
        override val agencySettingsLockedBody: String = "Solo agency is active. Agency changes unlock with Pro."
        override val soloAgency: String = "Solo agency"
        override val defaultPrivateAgencyWorkspace: String = "Default private agency workspace"
        override val noAgenciesAvailableYet: String = "No agency invitations or owned agencies are available yet."
        override val oneOwnedAgencyHint: String = "Your owned agency is listed above. One agent can own one agency."
        override val createAgency: String = "Create agency"
        override val createYourAgency: String = "Create your agency"
        override val createAgencyBody: String = "Build your team, manage properties together, and grow your business."
        override val agencyName: String = "Agency name"
        override val agencyEmail: String = "Agency email"
        override val logoOptional: String = "Logo (optional)"
        override val upgradeExperienceTitle: String = "Upgrade your experience"
        override val upgradeExperienceSubtitle: String = "Run your first Open House free. Upgrade when you need more listings, openings, and Pro workflows."
        override val soloAgentPlan: String = "Solo agent"
        override val proAgentPlan: String = "Pro agent"
        override val soloBenefitActiveProperties: String = "Up to 100 active properties"
        override val soloBenefitAiFollowUps: String = "AI follow-ups (basic)"
        override val soloBenefitSellerReports: String = "Luxury seller reports (basic)"
        override val soloBenefitPersonalOnly: String = "Personal workspace only"
        override val proBenefitUnlimitedProperties: String = "Unlimited properties"
        override val proBenefitUnlimitedAi: String = "AI follow-ups (unlimited)"
        override val proBenefitAdvancedReports: String = "Advanced seller reports"
        override val proBenefitAgencyCreation: String = "Agency creation and management"
        override val proBenefitInviteAgents: String = "Invite agents and collaborate"
        override val proBenefitSharedLeads: String = "Shared leads and team workflows"
        override val proBenefitAgencyBranding: String = "Agency branding"
        override val proBenefitAdvancedAnalytics: String = "Advanced analytics"
        override val startFreeTrial7Day: String = "Subscribe now"
        override val restorePurchases: String = "Restore purchases"
        override val comparePlans: String = "Compare plans"
        override val startFreeTrial: String = "Choose plan"
        override val noCommitmentCancelAnytime: String = "Run your first Open House free. Upgrade when you need more."
        override val monthly: String = "Monthly"
        override val yearly: String = "Yearly"
        override val yearlySave20: String = "Yearly - save 20%"
        override val yearlySavings20: String = "Yearly saves 20% compared to monthly."
        override val perYear: String = "/ year"
        override val loadingPlans: String = "Loading plans..."
        override val selectedPlanUnavailable: String = "This plan is not available yet. Check RevenueCat offerings and product identifiers."
        override val signInRequiredForPurchase: String = "Sign in before starting a purchase."
        override val compareActiveProperties: String = "Active properties"
        override val compareAiFollowUps: String = "AI follow-ups"
        override val compareSellerReports: String = "Seller reports"
        override val compareAdvancedAnalytics: String = "Advanced analytics"
        override val compareAgencyCreation: String = "Agency creation"
        override val compareJoinAgencies: String = "Join agencies"
        override val compareInviteAgents: String = "Invite agents"
        override val compareSharedLeads: String = "Shared leads"
        override val compareAgencyBranding: String = "Agency branding"
        override val comparePrioritySupport: String = "Priority support"
        override val unlimited: String = "Unlimited"
        override val basic: String = "Basic"
        override val advanced: String = "Advanced"
        override val perMonth: String = "/ month"
        override val members: String = "members"
        override val upgradeToProForAgencyTools: String = "Upgrade to Pro to use agency tools"
        override val languageTitle: String = "Language"
        override val languageBody: String = "Choose the app language for this device."
        override val english: String = "English"
        override val slovak: String = "Slovak"
        override val unitsTitle: String = "Units and currency"
        override val unitsBody: String = "Choose how prices and property dimensions are shown across the app."
        override val measurementSystemTitle: String = "Measurement"
        override val metric: String = "Metric"
        override val imperial: String = "Imperial"
        override val currencyTitle: String = "Currency"
        override val notificationsTitle: String = "Notifications"
        override val notificationsBody: String = "Control push alerts, quiet hours, and the types of updates HAVN can send."
        override val notificationSettings: String = "Notification settings"
        override val notificationsSubtitle: String = "Only important updates, filtered by your preferences."
        override val quietHoursTitle: String = "Quiet hours"
        override val quietHoursBody: String = "HAVN skips non-critical pushes during quiet hours. Billing and account issues still stay concise."
        override val enableQuietHours: String = "Enable quiet hours"
        override val quietHoursStart: String = "Start"
        override val quietHoursEnd: String = "End"
        override val timezoneLabel: String = "Timezone"
        override val notificationTypesTitle: String = "Notification types"
        override val notificationNewLeadCapturedTitle: String = "New lead captured"
        override val notificationNewLeadCapturedBody: String = "When an opening or QR flow captures a lead."
        override val notificationHotLeadTitle: String = "Lead marked as hot"
        override val notificationHotLeadBody: String = "Only when a lead becomes high intent."
        override val notificationOpeningStartsSoonTitle: String = "Opening starts soon"
        override val notificationOpeningStartsSoonBody: String = "A single reminder 30 minutes before start."
        override val notificationOpeningSummaryReadyTitle: String = "Opening summary ready"
        override val notificationOpeningSummaryReadyBody: String = "When the post-event summary is ready."
        override val notificationSellerReportGeneratedTitle: String = "Seller report generated"
        override val notificationSellerReportGeneratedBody: String = "When a seller report has been created."
        override val notificationAiFollowUpReadyTitle: String = "AI follow-up ready"
        override val notificationAiFollowUpReadyBody: String = "When a follow-up draft is ready to review."
        override val notificationAgentInvitedTitle: String = "Agent invited to agency"
        override val notificationAgentInvitedBody: String = "Agency invitations and membership changes."
        override val notificationLeadAssignedTitle: String = "Lead assigned to you"
        override val notificationLeadAssignedBody: String = "When a teammate assigns a lead to you."
        override val notificationLeadTransferredTitle: String = "Lead transferred to you"
        override val notificationLeadTransferredBody: String = "When ownership of a lead moves to you."
        override val notificationSubscriptionIssueTitle: String = "Subscription issue"
        override val notificationSubscriptionIssueBody: String = "Renewal failures and billing problems."
        override val kioskSecurityTitle: String = "Kiosk security"
        override val kioskSecurityBody: String = "Use this PIN to leave kiosk mode and return to the agent app."
        override val kioskPinLabel: String = "Kiosk PIN"
        override val kioskFeaturedProperty: String = "Featured property"
        override val kioskPrivateShowing: String = "Private showing"
        override val kioskLuxuryListing: String = "Luxury listing"
        override val kioskFastCheckIn: String = "Fast check-in"
        override val kioskExitContentDescription: String = "Exit kiosk"
        override val kioskWelcome: String = "Welcome"
        override val kioskGladHere: String = "We’re glad you’re here."
        override val kioskScanToCheckIn: String = "Scan to check in"
        override val kioskReceivePropertyDetails: String = "and receive property details"
        override val kioskOr: String = "Or"
        override val kioskStartCheckInManually: String = "Start check-in manually"
        override val kioskSecureInfo: String = "Your information is secure and will never be shared."
        override val kioskExitTitle: String = "Exit kiosk"
        override val kioskExitBody: String = "Enter the kiosk PIN to return to the agent app."
        override val kioskIncorrectPin: String = "Incorrect PIN."
        override val kioskUnlock: String = "Unlock"
        override val kioskTellUsTitle: String = "Tell us about yourself"
        override val kioskTellUsBody: String = "Your information goes only to the hosting agent."
        override val kioskFullName: String = "Full name"
        override val kioskContinue: String = "Continue"
        override val kioskQuestionsTitle: String = "A couple quick questions"
        override val kioskQuestionsBody: String = "This helps the agent follow up with the right context."
        override val kioskWorkingWithAgentQuestion: String = "Are you working with an agent?"
        override val kioskYes: String = "Yes"
        override val kioskNo: String = "No"
        override val kioskInterestQuestion: String = "What are you interested in?"
        override val kioskInterestBuying: String = "Buying"
        override val kioskInterestInvesting: String = "Investing"
        override val kioskInterestBrowsing: String = "Just browsing"
        override val kioskInterestRelocating: String = "Relocating"
        override val kioskFinish: String = "Finish"
        override val kioskThankYou: String = "Thank you"
        override val kioskEnjoyVisitPrefix: String = "Enjoy your visit at"
        override val kioskResetAutomatically: String = "This kiosk will reset automatically."
        override val environmentTitle: String = "Environment"
        override val environmentBody: String = "Local Supabase is configured for development. Production values should move behind build-time configuration."
        override val secure: String = "Secure"
        override val brokerageProfileTitle: String = "Brokerage profile"
        override val brokerageProfileBody: String = "Team branding, agent invites, and notification preferences will live here."
        override val logout: String = "Log out"
        override val languageChanged: String = "Language changed"
        override val commonAdd: String = "Add"
        override val commonEdit: String = "Edit"
        override val commonDelete: String = "Delete"
        override val commonCancel: String = "Cancel"
        override val commonSave: String = "Save"
        override val commonCreate: String = "Create"
        override val commonDismiss: String = "Dismiss"
        override val commonAll: String = "All"
        override val commonDone: String = "Done"
        override val commonTime: String = "Time"
        override val commonHour: String = "Hour"
        override val commonMinute: String = "Minute"
        override val commonAgency: String = "Agency"
        override val commonSettings: String = "Settings"
        override val commonOpening: String = "Opening"
        override val commonPropertyName: String = "Property"
        override val commonToday: String = "Today"
        override val agencyToolsAvailable: String = "Agency tools are available."
        override val agencySetupSubtitle: String = "Every HAVN account has a default agency. Pro lets you manage invites, shared leads, and branding."
        override val agencyRecentActivity: String = "Recent activity"
        override val agencyActivityNewLead: String = "New lead added"
        override val agencyActivityInvitationAccepted: String = "Agent invitation accepted"
        override val agencyActivityAgentJoined: String = "Agent joined the agency"
        override val agencyActivitySellerReport: String = "Seller report created"
        override val agencyWorkspaceTitle: String = "Agency workspace"
        override val agencyWorkspaceBody: String = "Choose which agency you are working with."
        override val agencySoloActiveTitle: String = "Solo agency is active"
        override val agencyProRequiredTitle: String = "Pro plan required"
        override val agencyCreateOrAcceptInviteBody: String = "Create your agency workspace or accept an invite to collaborate with another agency."
        override val agencyProUnlockBody: String = "Agency changes, invites, shared leads, and shared branding unlock with Pro."
        override val realEstate: String = "Real estate"
        override val proAgency: String = "Pro agency"
        override val agencyBrandingTitle: String = "Agency branding"
        override val agencyBrandingBody: String = "Set the agency name and logo shown in the app, kiosk, and shared workspace."
        override val uploadLogo: String = "Upload logo"
        override val saveAgency: String = "Save agency"
        override val yourAgencyRole: String = "Your agency role"
        override val agencyAgentsTitle: String = "Agency agents"
        override val agencyAgentsBody: String = "People eligible to work with this agency."
        override val inviteAgent: String = "Invite agent"
        override val loadingAgents: String = "Loading agents..."
        override val noAgencyAgentsYet: String = "No agency agents yet."
        override val changeRole: String = "Change role"
        override val updating: String = "Updating..."
        override val deleting: String = "Deleting..."
        override val deleteInvite: String = "Delete invite"
        override val chooseAgencyRoleFor: String = "Choose the agency role for"
        override val removeAccess: String = "Remove access"
        override val inviteAgentBody: String = "Send an agency invitation by email. The agent accepts after signing in with the same email."
        override val agentEmail: String = "Agent email"
        override val role: String = "Role"
        override val inviting: String = "Inviting..."
        override val invite: String = "Invite"
        override val agents: String = "Agents"
        override val ok: String = "Ok"
        override val personalActivePropertyLimit: String = "Personal active property limit"
        override val personalAccountAgencyToolsLocked: String = "Personal account is active. Agency tools unlock with Pro."
        override val selected: String = "Selected"
        override val activeMembers: String = "active members"
        override val agencySharedWorkspaceBody: String = "Shared properties, contacts, openings, leads, follow-ups, and reports use this agency workspace."
        override val agencyRoleOwner: String = "Owner"
        override val agencyRoleAdmin: String = "Admin"
        override val agencyRoleAgent: String = "Agent"
        override val agencyRoleAssistant: String = "Assistant"
        override val agencyRoleViewer: String = "Viewer"
        override val agencyRoleOwnerDescription: String = "Full agency control, including members, branding, assignments, listings, leads, and reports."
        override val agencyRoleAdminDescription: String = "Full agency management except deleting the agency."
        override val agencyRoleAgentDescription: String = "Works assigned listings, openings, leads, follow-ups, notes, and seller reports."
        override val agencyRoleAssistantDescription: String = "Supports assigned listings by editing leads, preparing follow-ups, and drafting reports."
        override val agencyRoleViewerDescription: String = "Read-only access to dashboards and reports."
        override val agencyCapabilityInviteRemoveMembers: String = "Invite and remove members"
        override val agencyCapabilityChangeRoles: String = "Change member roles"
        override val agencyCapabilityManageAllProperties: String = "Create, edit, and delete all properties"
        override val agencyCapabilityAssignAgents: String = "Assign agents"
        override val agencyCapabilitySeeAllLeads: String = "See all leads"
        override val agencyCapabilityExportReports: String = "Export reports"
        override val agencyCapabilityChangeBranding: String = "Change agency branding and settings"
        override val agencyCapabilityDeleteAgency: String = "Delete agency"
        override val agencyCapabilityViewAssignedProperties: String = "View assigned properties"
        override val agencyCapabilityHostAssignedOpenings: String = "Host assigned openings"
        override val agencyCapabilitySeeAssignedLeads: String = "See leads from assigned properties and openings"
        override val agencyCapabilityAddNotes: String = "Add notes"
        override val agencyCapabilitySendFollowUps: String = "Send follow-ups"
        override val agencyCapabilityCreateSellerReports: String = "Create seller reports for assigned listings"
        override val agencyCapabilityEditAssignedLeads: String = "Edit assigned leads"
        override val agencyCapabilityPrepareFollowUps: String = "Prepare follow-ups"
        override val agencyCapabilityCreateDraftReports: String = "Create draft reports"
        override val agencyCapabilityCannotDeleteProperties: String = "Cannot delete properties"
        override val agencyCapabilityCannotInviteAgents: String = "Cannot invite agents unless allowed"
        override val agencyCapabilityViewDashboards: String = "View dashboards"
        override val agencyCapabilityViewReports: String = "View reports"
        override val agencyCapabilityCannotEdit: String = "Cannot edit anything"
        override val commonVisitors: String = "Leads"
        override val commonHot: String = "Hot"
        override val commonWarm: String = "Warm"
        override val commonCold: String = "Cold"
        override val commonActive: String = "Active"
        override val commonPlanned: String = "Planned"
        override val commonArchived: String = "Archived"
        override val commonPast: String = "Past"
        override val commonFollowUps: String = "Follow-ups"
        override val commonProperty: String = "Property"
        override val commonAddress: String = "Address"
        override val commonOpenHouse: String = "Opening"
        override val commonCheckedIn: String = "Checked in"
        override val commonNotScheduled: String = "not scheduled"
        override val todayTitle: String = "Today"
        override val todaySubtitle: String = "Your daily workspace for openings, leads, follow-ups, and seller-ready momentum."
        override val todayOpenHousesMetric: String = "openings"
        override val capturedMetric: String = "captured"
        override val priorityMetric: String = "priority"
        override val noActivePropertiesTitle: String = "No active properties"
        override val noActivePropertiesBody: String = "Add or activate a property to make it appear on Today."
        override val checkIns: String = "Check-ins"
        override val allOpenHouses: String = "all openings"
        override val pendingDrafts: String = "pending drafts"
        override val priorityLead: String = "Priority lead"
        override val nextOpenHouseAt: String = "Next opening at"
        override val noOpenHouseScheduled: String = "No opening scheduled"
        override val personalAccount: String = "Personal account"
        override val accountReady: String = "Your account is ready"
        override val realEstateApp: String = "Real estate app"
        override val needHelp: String = "Need help?"
        override val contactSupport: String = "Contact support"
        override val upgradePlan: String = "Upgrade plan"
        override val planSuffix: String = "Plan"
        override val todayActionsTitle: String = "Today's priorities"
        override val whatOpeningNext: String = "What opening is next?"
        override val whoCheckedIn: String = "Who checked in?"
        override val whoNeedsFollowUp: String = "Who needs follow-up?"
        override val whatShouldIDoNow: String = "What should I do now?"
        override val noCheckInsYet: String = "No contacts have checked in yet."
        override val noPendingFollowUps: String = "No pending follow-ups right now."
        override val openKioskForNextOpening: String = "Open the kiosk for the next opening."
        override val reviewNewLeads: String = "Review new leads and send follow-ups."
        override val createOpeningToStart: String = "Create an opening from a property to start collecting leads."
        override val addFirstPropertyToStart: String = "Add your first property to get started."
        override val nextOpening: String = "Next opening"
        override val quickSignIn: String = "Quick sign-in"
        override val scanQrCode: String = "Scan QR code"
        override val newLead: String = "New lead"
        override val myProperties: String = "My properties"
        override val manageListings: String = "Manage listings"
        override val todaysOverview: String = "Today's overview"
        override val seeAll: String = "See all"
        override val propertiesEyebrow: String = "Portfólio"
        override val propertiesSubtitle: String = "Manage active, planned, and archived listings with Supabase-backed media and performance intelligence."
        override val propertiesLiveMetric: String = "live"
        override val propertiesPipelineMetric: String = "pipeline"
        override val propertiesAllTimeMetric: String = "all time"
        override val addProperty: String = "Add property"
        override val editProperty: String = "Edit property"
        override val propertyFallback: String = "Property"
        override val propertyUnavailableTitle: String = "Property unavailable"
        override val propertyUnavailableBody: String = "Refresh the portfolio to reload this listing."
        override val backToProperties: String = "Back to properties"
        override val deletePropertyTitle: String = "Delete property?"
        override val deletePropertyBody: String = "This will permanently delete the property and its related local records. This cannot be undone."
        override val loadingProperties: String = "Loading properties"
        override val noPropertiesTitle: String = "No properties yet"
        override val noPropertiesBody: String = "Add your first property, then create an opening to start collecting leads and seller-ready feedback."
        override val openHouseButton: String = "Create opening"
        override val photosTitle: String = "Photos"
        override val photosBody: String = "The first photo is used as the main property image across Portfolio."
        override val uploadPhoto: String = "Upload photo"
        override val noPhotosYet: String = "No photos uploaded yet."
        override val mainPhoto: String = "Main"
        override val propertyTitleLabel: String = "Property name"
        override val propertyAddressLine1Label: String = "Street address"
        override val propertyAddressLine2Label: String = "Address line 2"
        override val propertyCityLabel: String = "City"
        override val propertyRegionLabel: String = "Region"
        override val propertyPostalCodeLabel: String = "Postal code"
        override val propertyCountryLabel: String = "Country"
        override val propertyAskingPriceLabel: String = "Asking price"
        override val propertyBedsLabel: String = "Beds"
        override val propertyBathsLabel: String = "Baths"
        override val propertyInteriorLabel: String = "Interior"
        override val propertyDescriptionLabel: String = "Description"
        override val createPropertyButton: String = "+ Create property"
        override val locateProperty: String = "Locate property"
        override val findLocation: String = "Find location"
        override val find: String = "Find"
        override val navigate: String = "Navigate"
        override val propertyLocationMarkerTitle: String = "Property location"
        override val mapKitJsMissingToken: String = "Add HAVN_MAPKIT_JS_TOKEN to local.properties for the web map."
        override val mapKitJsLoading: String = "Loading MapKit JS..."
        override val generateSellerReport: String = "Generate seller report"
        override val deleteProperty: String = "Delete property"
        override val conversionMetric: String = "Conversion"
        override val propertyPhotoContentDescription: String = "Property photo"
        override val deletePhoto: String = "Delete photo"
        override val movePhotoLeft: String = "Move photo left"
        override val movePhotoRight: String = "Move photo right"
        override val propertyTitleRequired: String = "Property name is required."
        override val propertyStreetRequired: String = "Street address is required."
        override val propertyCityRequired: String = "City is required."
        override val propertyRegionRequired: String = "Region is required."
        override val propertyPostalRequired: String = "Postal code is required."
        override val propertyAskingPriceInvalid: String = "Enter a valid asking price."
        override val propertyOwnerContactTitle: String = "Property owner contact"
        override val propertyOwnerSelectContact: String = "Select an existing contact as the property owner."
        override val propertyOwnerSelected: String = "Selected owner"
        override val propertyOwnerNoContacts: String = "No contacts yet. Add the owner in Contacts, then select them here."
        override val propertyOwnerChooseContact: String = "Choose contact"
        override val propertyOwnerChangeContact: String = "Change contact"
        override val propertyOwnerRemoveContact: String = "Remove"
        override val propertyOwnerPickerTitle: String = "Choose property owner"
        override val propertyOwnerSearchContact: String = "Search contacts"
        override val propertyOwnerSearchHint: String = "Start typing a name, email, or phone number."
        override val propertyOwnerNoMatches: String = "No matching contacts."
        override val propertyOpeningsTitle: String = "Openings"
        override val propertyNoOpenings: String = "No openings scheduled for this property."
        override val teamAccessTitle: String = "Team access"
        override val onlyListingOwner: String = "Only the listing owner"
        override val assignTeam: String = "Assign team"
        override val assignPropertyTitle: String = "Assign property"
        override val assignPropertyBody: String = "Choose who can work this property. Select the whole team or specific agents."
        override val wholeTeam: String = "Whole team"
        override val leadsEyebrow: String = "Leads"
        override val leadFallback: String = "Lead"
        override val leadsSubtitle: String = "Search, filter, and qualify leads captured across every opening."
        override val leadDetailSubtitle: String = "Source, qualification, notes, and follow-up history for this opening lead."
        override val totalMetric: String = "Total"
        override val loggedMetric: String = "logged"
        override val searchLeads: String = "Search leads"
        override val searchLeadsPlaceholder: String = "Name, phone, or email"
        override val allProperties: String = "All properties"
        override val loadingLeads: String = "Loading opening leads"
        override val noLeadsFoundTitle: String = "Leads will appear here when contacts check in to an opening."
        override val noLeadsEmptyBody: String = "Use kiosk check-in or add contacts manually from an opening."
        override val noLeadsFilteredBody: String = "Try a different property, status, or search term."
        override val backToLeads: String = "Back to leads"
        override val leadUnavailableTitle: String = "Lead unavailable"
        override val leadUnavailableBody: String = "This lead is no longer available in the current lead list."
        override val leadTemperature: String = "Lead status"
        override val leadLabelSuffix: String = "Lead"
        override val greetingHi: String = "Hi"
        override val leadActionCall: String = "Call"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "Email"
        override val leadFollowUp: String = "Follow-up"
        override val leadNoFollowUpScheduled: String = "No follow-up scheduled"
        override val leadIntentScore: String = "Intent score"
        override val leadInterestedIn: String = "Interested in"
        override val leadGenericGreetingName: String = "there"
        override val followUpMessageTypeThankYou: String = "Thank you"
        override val followUpMessageTypePropertyInfo: String = "Property info"
        override val followUpMessageTypeFollowUp: String = "Follow up"
        override val followUpMessageTypeCheckIn: String = "Check in"
        override val followUpMessageTypePriceUpdate: String = "Price update"
        override val followUpMessageTypePropertyBrochure: String = "Photos"
        override val followUpPreview: String = "Preview"
        override val followUpSubject: String = "Subject"
        override val followUpMessage: String = "Message"
        override val followUpSendViaEmail: String = "Send via email"
        override val followUpSendViaSms: String = "Send via SMS"
        override val followUpAiAssistantTitle: String = "AI assistant"
        override val followUpAiAssistantBody: String = "Generate a personalized message in seconds."
        override val followUpGenerateWithAi: String = "Generate with AI"
        override val followUpUpgradeForAi: String = "Upgrade for AI"
        override val followUpDefaultSubject: String = "Following up on"
        override val privateAgentNotes: String = "Private agent notes"
        override val notes: String = "Notes"
        override val notesPlaceholder: String = "Motivation, preferences, objections, next move"
        override val saveNotes: String = "Save notes"
        override val followUpHistory: String = "Follow-up history"
        override val noFollowUpsLogged: String = "No follow-ups logged yet."
        override val openHousesEyebrow: String = "Showings"
        override val scheduleOpenHouse: String = "Create opening"
        override val openingDetails: String = "Opening details"
        override val editOpening: String = "Edit opening"
        override val deleteOpening: String = "Delete opening"
        override val deleteOpeningBody: String = "Are you sure you want to delete this opening? This cannot be undone."
        override val openingName: String = "Opening name"
        override val startsAt: String = "Starts at"
        override val endsAt: String = "Ends at"
        override val chooseStartDateTime: String = "Choose start date and time"
        override val chooseEndDateTime: String = "Choose end date and time"
        override val accessNotes: String = "Access notes"
        override val privateNotes: String = "Private notes"
        override val addPrivateNote: String = "Add private note"
        override val liveDashboard: String = "Live dashboard"
        override val visitorKiosk: String = "Lead kiosk"
        override val openHousesSubtitle: String = "Create openings for properties, review leads, and launch kiosk sessions."
        override val liveMetric: String = "Live"
        override val upcomingMetric: String = "Upcoming"
        override val inProgressMetric: String = "in progress"
        override val scheduledMetric: String = "scheduled"
        override val loadingOpenHouses: String = "Loading openings"
        override val addPropertyFirstTitle: String = "Add a property first"
        override val addPropertyFirstBody: String = "Create an opening from a property to start collecting leads."
        override val noOpenHousesTitle: String = "No openings scheduled"
        override val noOpenHousesBody: String = "Create an opening from a property to start collecting leads."
        override val noSignInsTitle: String = "No sign-ins yet"
        override val noSignInsBody: String = "Leads checked in through kiosk mode will appear here in real time."
        override val dashboard: String = "Dashboard"
        override val start: String = "Start"
        override val end: String = "End"
        override val endOpenHouse: String = "End opening"
        override val reportsEyebrow: String = "Owners"
        override val sellerReportsTitle: String = "Seller reports"
        override val createReport: String = "Create report"
        override val reportPreview: String = "Property Report"
        override val reportsSubtitle: String = "Generate premium post-opening recaps with lead quality, buyer intent, and seller-ready narrative."
        override val reportsMetricSaved: String = "saved"
        override val reportedMetric: String = "reported"
        override val leadsMetric: String = "leads"
        override val createSellerReport: String = "Create seller report"
        override val attendance: String = "Attendance"
        override val savedReports: String = "saved reports"
        override val buyerHeat: String = "Buyer heat"
        override val hotLeads: String = "hot leads"
        override val loadingSellerReports: String = "Loading seller reports"
        override val noSellerReportsTitle: String = "No seller reports yet"
        override val noSellerReportsBody: String = "Choose an opening, add agent notes, preview an export-ready recap, then save it."
        override val chooseOpenHouse: String = "Choose opening"
        override val noOpenHousesAvailable: String = "No openings available yet."
        override val agentNotes: String = "Agent notes"
        override val notesForSeller: String = "Notes for seller"
        override val sellerNotesPlaceholder: String = "Buyer objections, pricing signals, showing feedback, recommended next move"
        override val generatePreview: String = "Generate preview"
        override val noPreviewReadyTitle: String = "No preview ready"
        override val noPreviewReadyBody: String = "Generate a seller report preview before saving."
        override val saveReport: String = "Save report"
        override val reportSaved: String = "Report saved"
        override val sellerOpenHouseReport: String = "Seller opening report"
        override val mostCommonBuyerInterest: String = "Most common buyer interest"
        override val followUpsSent: String = "Follow-ups sent"
        override val summary: String = "Summary"
        override val noPrivateNotesAdded: String = "No private notes added."
        override val openHouseReport: String = "Opening report"
        override val searchProperties: String = "Search properties"
        override val searchOpenings: String = "Search openings"
        override val noOpeningsFoundTitle: String = "No openings found"
        override val noOpeningsFoundBody: String = "Try another search or opening status filter."
        override val noMatchingPropertiesTitle: String = "No matching properties"
        override val noMatchingPropertiesBody: String = "Try another search or status filter."
        override val clientsTitle: String = "Contacts"
        override val clientFallback: String = "Contact"
        override val addClient: String = "Add contact"
        override val editClient: String = "Edit contact"
        override val newClient: String = "New contact"
        override val saveClient: String = "Save contact"
        override val createClient: String = "Create contact"
        override val deleteClientTitle: String = "Delete contact?"
        override val deleteClientBody: String = "This will permanently delete the contact. This cannot be undone."
        override val firstName: String = "First name"
        override val lastName: String = "Last name"
        override val email: String = "Email"
        override val phone: String = "Phone"
        override val comments: String = "Comments"
        override val addPhoto: String = "Add photo"
        override val sendQr: String = "Send QR"
        override val photo: String = "Photo"
        override val clientDetailSubtitle: String = "QR identity, contact details, comments, and openings connected through leads."
        override val clientFormEditSubtitle: String = "Update contact details, delivery info, and comments."
        override val clientFormNewSubtitle: String = "Register a buyer/contact and generate a reusable QR identity for openings."
        override val searchClients: String = "Search contacts"
        override val noClientsYetTitle: String = "No contacts yet"
        override val noClientsYetBody: String = "Register contacts first, then send their QR code by email or SMS before an opening."
        override val noClientsFoundTitle: String = "No contacts found"
        override val noClientsFoundBody: String = "Try another name, phone, or email."
        override val clientUnavailableTitle: String = "Contact unavailable"
        override val clientUnavailableBody: String = "Refresh the contacts list and open this record again."
        override val noCommentsAdded: String = "No comments added."
        override val openingsTitle: String = "Openings"
        override val clientOpeningsEmpty: String = "No openings connected yet. Leads connect a contact to an opening."
        override val clientPassLabel: String = "Pass"
        override val clientNoEmail: String = "No email"
        override val visitorsBody: String = "Open kiosk mode, scan a contact QR, or add existing contacts as leads for this opening."
        override val openKiosk: String = "Open kiosk"
        override val addQrClient: String = "Add QR contact"
        override val addManually: String = "Add manually"
        override val selectClients: String = "Select contacts"
        override val selectClientsBody: String = "Choose contacts from your list. Each selected contact becomes a lead for this opening."
        override val kioskCheckIn: String = "Kiosk check-in"
        override val kioskCheckInBody: String = "Use the rear camera to scan the contact's HAVN Wallet QR. When the code is recognized, HAVN creates the lead for this opening automatically."
        override val scanWithCamera: String = "Scan with rear camera"
        override val clientQrImage: String = "Contact QR image"
        override val clientQrImageBody: String = "Keep the contact's QR inside the gold square. HAVN collects each scan below."
        override val scanMultipleQrBody: String = "Scan one or more HAVN contact QR codes, then tap Add QR contact."
        override val scannedQrReady: String = "contact QR ready to add"
        override val createLeadFromQr: String = "Create lead from QR"
        override val noClientsFoundShort: String = "No contacts found."
        override val remove: String = "Remove"
    }

    private val slovak: HavnStrings = object : HavnStrings {
        override val navToday: String = "Dnes"
        override val navProperties: String = "Nehnuteľnosti"
        override val navLeads: String = "Leady"
        override val navReports: String = "Reporty"
        override val navSettings: String = "Nastavenia"
        override val navAuth: String = "Prístup agenta"
        override val navOpenHouses: String = "Obhliadky"
        override val navTours: String = "Obhliadky"
        override val navFollowUps: String = "Kontakty"
        override val navFollow: String = "Kontakty"
        override val back: String = "Späť"
        override val settingsEyebrow: String = "Pracovný priestor"
        override val settingsTitle: String = "Nastavenia"
        override val settingsSubtitle: String = "Profil kancelárie, pozvánky, konfigurácia Supabase, úložisko a tímové roly."
        override val agentProfileTitle: String = "Profil agenta"
        override val agentPhoto: String = "Fotka agenta"
        override val uploading: String = "Nahrávam..."
        override val saving: String = "Ukladám..."
        override val validAgentPhotoRequired: String = "Vyberte platnú fotku agenta."
        override val signOut: String = "Odhlásiť sa"
        override val signOutQuestion: String = "Odhlásiť sa?"
        override val signOutConfirmation: String = "Naozaj sa chcete odhlásiť z HAVN?"
        override val upgrade: String = "Vylepšiť"
        override val premiumThemesTitle: String = "Prémiové motívy"
        override val premiumThemesUpgradePrompt: String = "Vylepšite na Pro a odomknite prémiové motívy."
        override val appearanceTitle: String = "Vzhľad"
        override val appearanceBody: String = "Vyberte si prémiový motív HAVN. Prémiové motívy odomkne Pro."
        override val previewComponents: String = "Ukážka komponentov"
        override val themeShowcaseTitle: String = "Ukážka motívu"
        override val showcaseButtons: String = "Tlačidlá"
        override val showcasePrimaryAction: String = "Hlavná akcia"
        override val showcaseSecondaryAction: String = "Vedľajšia akcia"
        override val showcaseGhostAction: String = "Nenápadná akcia"
        override val showcaseTextField: String = "Textové pole"
        override val showcaseFocusedBorder: String = "Zvýraznený okraj"
        override val showcaseSearchPreview: String = "Ukážka vyhľadávania"
        override val showcaseOpeningCheckedIn: String = "Príchod na otvorenie dnes"
        override val showcaseSentAt: String = "Odoslané o 10:30"
        override val themeObsidianGoldName: String = "Obsidian Gold"
        override val themeObsidianGoldDescription: String = "Luxusná čierna, grafit a teplé zlato."
        override val themeMidnightSapphireName: String = "Midnight Sapphire"
        override val themeMidnightSapphireDescription: String = "Hlboká námornícka modrá, zafír a strieborné akcenty."
        override val themeEmeraldEstateName: String = "Emerald Estate"
        override val themeEmeraldEstateDescription: String = "Tmavý smaragd, charcoal a šampanské zlato."
        override val themePlatinumStoneName: String = "Platinum Stone"
        override val themePlatinumStoneDescription: String = "Kamenná sivá, platina a jemná biela."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Tmavé víno, grafit a medené akcenty."
        override val commonChange: String = "Zmeniť"
        override val agentPlanTitle: String = "Plán agenta"
        override val agentPlanBody: String = "Vylepšite si prácu. Vyberte plán, ktorý najlepšie sedí vášmu spôsobu predaja."
        override val currentPlan: String = "Aktuálny plán"
        override val transferPlan: String = "Preniesť plán"
        override val restorePurchase: String = "Obnoviť nákup"
        override val agencySettingsProBody: String = "Solo agency je aktívna predvolene. Pro umožňuje vytvoriť alebo vybrať zdieľanú agentúru."
        override val agencySettingsLockedBody: String = "Solo agency je aktívna. Zmeny agentúry odomkne Pro."
        override val soloAgency: String = "Solo agency"
        override val defaultPrivateAgencyWorkspace: String = "Predvolená súkromná agentúra"
        override val noAgenciesAvailableYet: String = "Zatiaľ nie sú dostupné žiadne pozvánky ani vlastnené agentúry."
        override val oneOwnedAgencyHint: String = "Vaša agentúra je uvedená vyššie. Jeden agent môže vlastniť jednu agentúru."
        override val createAgency: String = "Vytvoriť agentúru"
        override val createYourAgency: String = "Vytvorte svoju agentúru"
        override val createAgencyBody: String = "Budujte tím, spravujte nehnuteľnosti spolu a rozvíjajte svoje podnikanie."
        override val agencyName: String = "Názov agentúry"
        override val agencyEmail: String = "E-mail agentúry"
        override val logoOptional: String = "Logo (voliteľné)"
        override val upgradeExperienceTitle: String = "Vylepšite svoj zážitok"
        override val upgradeExperienceSubtitle: String = "Vyberte plán, ktorý najlepšie sedí vášmu spôsobu práce."
        override val soloAgentPlan: String = "Solo agent"
        override val proAgentPlan: String = "Pro agent"
        override val soloBenefitActiveProperties: String = "Až 5 aktívnych nehnuteľností"
        override val soloBenefitAiFollowUps: String = "AI pripomienky (základné)"
        override val soloBenefitSellerReports: String = "Luxusné reporty pre predávajúcich (základné)"
        override val soloBenefitPersonalOnly: String = "Iba osobný účet"
        override val proBenefitUnlimitedProperties: String = "Neobmedzené nehnuteľnosti"
        override val proBenefitUnlimitedAi: String = "AI pripomienky (neobmedzené)"
        override val proBenefitAdvancedReports: String = "Pokročilé reporty pre predávajúcich"
        override val proBenefitAgencyCreation: String = "Vytvorenie a správa agentúry"
        override val proBenefitInviteAgents: String = "Pozývanie agentov a spolupráca"
        override val proBenefitSharedLeads: String = "Zdieľané leady a tímové workflow"
        override val proBenefitAgencyBranding: String = "Branding agentúry"
        override val proBenefitAdvancedAnalytics: String = "Pokročilá analytika"
        override val startFreeTrial7Day: String = "Predplatiť teraz"
        override val restorePurchases: String = "Obnoviť nákupy"
        override val comparePlans: String = "Porovnať plány"
        override val startFreeTrial: String = "Vybrať plán"
        override val noCommitmentCancelAnytime: String = "Bez záväzku. Zrušiť môžete kedykoľvek."
        override val monthly: String = "Monthly"
        override val yearly: String = "Yearly"
        override val yearlySave20: String = "Yearly - save 20%"
        override val yearlySavings20: String = "Yearly saves 20% compared to monthly."
        override val perYear: String = "/ year"
        override val loadingPlans: String = "Loading plans..."
        override val selectedPlanUnavailable: String = "This plan is not available yet. Check RevenueCat offerings and product identifiers."
        override val signInRequiredForPurchase: String = "Sign in before starting a purchase."
        override val compareActiveProperties: String = "Aktívne nehnuteľnosti"
        override val compareAiFollowUps: String = "AI pripomienky"
        override val compareSellerReports: String = "Reporty pre predávajúcich"
        override val compareAdvancedAnalytics: String = "Pokročilá analytika"
        override val compareAgencyCreation: String = "Vytvorenie agentúry"
        override val compareJoinAgencies: String = "Pripojenie k agentúram"
        override val compareInviteAgents: String = "Pozývanie agentov"
        override val compareSharedLeads: String = "Zdieľané leady"
        override val compareAgencyBranding: String = "Branding agentúry"
        override val comparePrioritySupport: String = "Prioritná podpora"
        override val unlimited: String = "Neobmedzené"
        override val basic: String = "Základné"
        override val advanced: String = "Pokročilé"
        override val perMonth: String = "/ mesiac"
        override val members: String = "členov"
        override val upgradeToProForAgencyTools: String = "Vylepšite na Pro a používajte nástroje agentúry"
        override val languageTitle: String = "Jazyk"
        override val languageBody: String = "Vyberte jazyk aplikácie pre toto zariadenie."
        override val english: String = "Angličtina"
        override val slovak: String = "Slovenčina"
        override val unitsTitle: String = "Jednotky a mena"
        override val unitsBody: String = "Vyberte, ako sa v aplikácii zobrazujú ceny a rozmery nehnuteľnosti."
        override val measurementSystemTitle: String = "Meranie"
        override val metric: String = "Metrické"
        override val imperial: String = "Imperiálne"
        override val currencyTitle: String = "Mena"
        override val notificationsTitle: String = "Notifikácie"
        override val notificationsBody: String = "Nastavte push upozornenia, tichý režim a typy správ, ktoré môže HAVN posielať."
        override val notificationSettings: String = "Nastavenia notifikácií"
        override val notificationsSubtitle: String = "Iba dôležité upozornenia podľa vašich nastavení."
        override val quietHoursTitle: String = "Tichý režim"
        override val quietHoursBody: String = "HAVN počas tichého režimu preskočí menej dôležité upozornenia. Fakturácia a problémy s účtom ostanú stručné."
        override val enableQuietHours: String = "Zapnúť tichý režim"
        override val quietHoursStart: String = "Začiatok"
        override val quietHoursEnd: String = "Koniec"
        override val timezoneLabel: String = "Časové pásmo"
        override val notificationTypesTitle: String = "Typy notifikácií"
        override val notificationNewLeadCapturedTitle: String = "Zachytený nový lead"
        override val notificationNewLeadCapturedBody: String = "Keď obhliadka alebo QR flow zachytí lead."
        override val notificationHotLeadTitle: String = "Lead označený ako horúci"
        override val notificationHotLeadBody: String = "Iba keď sa z leadu stane vysoký záujem."
        override val notificationOpeningStartsSoonTitle: String = "Obhliadka čoskoro začína"
        override val notificationOpeningStartsSoonBody: String = "Jedno pripomenutie 30 minút pred začiatkom."
        override val notificationOpeningSummaryReadyTitle: String = "Súhrn obhliadky je pripravený"
        override val notificationOpeningSummaryReadyBody: String = "Keď je pripravený súhrn po obhliadke."
        override val notificationSellerReportGeneratedTitle: String = "Report pre predávajúceho vytvorený"
        override val notificationSellerReportGeneratedBody: String = "Keď bol vytvorený report pre predávajúceho."
        override val notificationAiFollowUpReadyTitle: String = "AI pripomienka pripravená"
        override val notificationAiFollowUpReadyBody: String = "Keď je návrh pripomienky pripravený na kontrolu."
        override val notificationAgentInvitedTitle: String = "Agent pozvaný do agentúry"
        override val notificationAgentInvitedBody: String = "Pozvánky do agentúry a zmeny členstva."
        override val notificationLeadAssignedTitle: String = "Lead priradený vám"
        override val notificationLeadAssignedBody: String = "Keď vám kolega priradí lead."
        override val notificationLeadTransferredTitle: String = "Lead presunutý na vás"
        override val notificationLeadTransferredBody: String = "Keď sa vlastníctvo leadu presunie na vás."
        override val notificationSubscriptionIssueTitle: String = "Problém s predplatným"
        override val notificationSubscriptionIssueBody: String = "Neúspešné obnovenie a problémy s platbou."
        override val kioskSecurityTitle: String = "Zabezpečenie kiosku"
        override val kioskSecurityBody: String = "Tento PIN slúži na opustenie kiosku a návrat do aplikácie agenta."
        override val kioskPinLabel: String = "PIN kiosku"
        override val kioskFeaturedProperty: String = "Odporúčaná nehnuteľnosť"
        override val kioskPrivateShowing: String = "Súkromná obhliadka"
        override val kioskLuxuryListing: String = "Luxusná ponuka"
        override val kioskFastCheckIn: String = "Rýchle prihlásenie"
        override val kioskExitContentDescription: String = "Opustiť kiosk"
        override val kioskWelcome: String = "Vitajte"
        override val kioskGladHere: String = "Sme radi, že ste tu."
        override val kioskScanToCheckIn: String = "Naskenujte QR kód"
        override val kioskReceivePropertyDetails: String = "a získajte informácie o nehnuteľnosti"
        override val kioskOr: String = "Alebo"
        override val kioskStartCheckInManually: String = "Prihlásiť sa manuálne"
        override val kioskSecureInfo: String = "Vaše údaje sú v bezpečí a nebudú zdieľané."
        override val kioskExitTitle: String = "Opustiť kiosk"
        override val kioskExitBody: String = "Zadajte PIN kiosku pre návrat do aplikácie agenta."
        override val kioskIncorrectPin: String = "Nesprávny PIN."
        override val kioskUnlock: String = "Odomknúť"
        override val kioskTellUsTitle: String = "Povedzte nám o sebe"
        override val kioskTellUsBody: String = "Vaše údaje dostane iba agent, ktorý obhliadku organizuje."
        override val kioskFullName: String = "Meno a priezvisko"
        override val kioskContinue: String = "Pokračovať"
        override val kioskQuestionsTitle: String = "Pár krátkych otázok"
        override val kioskQuestionsBody: String = "Pomôže to agentovi nadviazať s vami správnym spôsobom."
        override val kioskWorkingWithAgentQuestion: String = "Spolupracujete už s agentom?"
        override val kioskYes: String = "Áno"
        override val kioskNo: String = "Nie"
        override val kioskInterestQuestion: String = "O čo máte záujem?"
        override val kioskInterestBuying: String = "Kúpa"
        override val kioskInterestInvesting: String = "Investícia"
        override val kioskInterestBrowsing: String = "Len sa pozerám"
        override val kioskInterestRelocating: String = "Sťahovanie"
        override val kioskFinish: String = "Dokončiť"
        override val kioskThankYou: String = "Ďakujeme"
        override val kioskEnjoyVisitPrefix: String = "Užite si návštevu nehnuteľnosti"
        override val kioskResetAutomatically: String = "Kiosk sa automaticky obnoví."
        override val environmentTitle: String = "Prostredie"
        override val environmentBody: String = "Lokálny Supabase je nastavený na vývoj. Produkčné hodnoty majú byť za build-time konfiguráciou."
        override val secure: String = "Zabezpečiť"
        override val brokerageProfileTitle: String = "Profil kancelárie"
        override val brokerageProfileBody: String = "Tu budú tímová značka, pozvánky agentov a notifikačné preferencie."
        override val logout: String = "Odhlásiť sa"
        override val languageChanged: String = "Jazyk bol zmenený"
        override val commonAdd: String = "Pridať"
        override val commonEdit: String = "Upraviť"
        override val commonDelete: String = "Zmazať"
        override val commonCancel: String = "Zrušiť"
        override val commonSave: String = "Uložiť"
        override val commonCreate: String = "Vytvoriť"
        override val commonDismiss: String = "Zavrieť"
        override val commonAll: String = "Všetko"
        override val commonDone: String = "Hotovo"
        override val commonTime: String = "Čas"
        override val commonHour: String = "Hodina"
        override val commonMinute: String = "Minúta"
        override val commonAgency: String = "Agentúra"
        override val commonSettings: String = "Nastavenia"
        override val commonOpening: String = "Obhliadka"
        override val commonPropertyName: String = "Nehnuteľnosť"
        override val commonToday: String = "Dnes"
        override val agencyToolsAvailable: String = "Nástroje agentúry sú dostupné."
        override val agencySetupSubtitle: String = "Každý účet HAVN má predvolenú agentúru. Pro umožňuje spravovať pozvánky, zdieľané leady a branding."
        override val agencyRecentActivity: String = "Nedávna aktivita"
        override val agencyActivityNewLead: String = "Pridaný nový lead"
        override val agencyActivityInvitationAccepted: String = "Pozvánka agenta prijatá"
        override val agencyActivityAgentJoined: String = "Agent sa pridal do agentúry"
        override val agencyActivitySellerReport: String = "Report pre predávajúceho vytvorený"
        override val agencyWorkspaceTitle: String = "Pracovný priestor agentúry"
        override val agencyWorkspaceBody: String = "Vyberte agentúru, v ktorej práve pracujete."
        override val agencySoloActiveTitle: String = "Solo agency je aktívna"
        override val agencyProRequiredTitle: String = "Vyžaduje sa Pro plán"
        override val agencyCreateOrAcceptInviteBody: String = "Vytvorte pracovný priestor agentúry alebo prijmite pozvánku na spoluprácu s inou agentúrou."
        override val agencyProUnlockBody: String = "Zmeny agentúry, pozvánky, zdieľané leady a branding odomkne Pro."
        override val realEstate: String = "Realitná kancelária"
        override val proAgency: String = "Pro agentúra"
        override val agencyBrandingTitle: String = "Branding agentúry"
        override val agencyBrandingBody: String = "Nastavte názov a logo agentúry zobrazené v aplikácii, kiosku a zdieľanom priestore."
        override val uploadLogo: String = "Nahrať logo"
        override val saveAgency: String = "Uložiť agentúru"
        override val yourAgencyRole: String = "Vaša rola v agentúre"
        override val agencyAgentsTitle: String = "Agenti agentúry"
        override val agencyAgentsBody: String = "Ľudia oprávnení pracovať v tejto agentúre."
        override val inviteAgent: String = "Pozvať agenta"
        override val loadingAgents: String = "Načítavam agentov..."
        override val noAgencyAgentsYet: String = "Zatiaľ tu nie sú žiadni agenti agentúry."
        override val changeRole: String = "Zmeniť rolu"
        override val updating: String = "Aktualizujem..."
        override val deleting: String = "Mažem..."
        override val deleteInvite: String = "Zmazať pozvánku"
        override val chooseAgencyRoleFor: String = "Vyberte rolu v agentúre pre"
        override val removeAccess: String = "Odobrať prístup"
        override val inviteAgentBody: String = "Pošlite pozvánku do agentúry e-mailom. Agent ju prijme po prihlásení rovnakým e-mailom."
        override val agentEmail: String = "E-mail agenta"
        override val role: String = "Rola"
        override val inviting: String = "Pozývam..."
        override val invite: String = "Pozvať"
        override val agents: String = "Agenti"
        override val ok: String = "Ok"
        override val personalActivePropertyLimit: String = "Limit osobných aktívnych nehnuteľností"
        override val personalAccountAgencyToolsLocked: String = "Osobný účet je aktívny. Nástroje agentúry odomkne Pro."
        override val selected: String = "Vybrané"
        override val activeMembers: String = "aktívnych členov"
        override val agencySharedWorkspaceBody: String = "Zdieľané nehnuteľnosti, kontakty, obhliadky, leady, pripomienky a reporty používajú tento pracovný priestor agentúry."
        override val agencyRoleOwner: String = "Vlastník"
        override val agencyRoleAdmin: String = "Admin"
        override val agencyRoleAgent: String = "Agent"
        override val agencyRoleAssistant: String = "Asistent"
        override val agencyRoleViewer: String = "Pozorovateľ"
        override val agencyRoleOwnerDescription: String = "Plná kontrola agentúry vrátane členov, brandingu, priradení, ponúk, leadov a reportov."
        override val agencyRoleAdminDescription: String = "Plná správa agentúry okrem zmazania agentúry."
        override val agencyRoleAgentDescription: String = "Pracuje s priradenými ponukami, obhliadkami, leadmi, pripomienkami, poznámkami a reportmi."
        override val agencyRoleAssistantDescription: String = "Podporuje priradené ponuky úpravou leadov, prípravou pripomienok a návrhmi reportov."
        override val agencyRoleViewerDescription: String = "Prístup iba na čítanie k dashboardom a reportom."
        override val agencyCapabilityInviteRemoveMembers: String = "Pozývať a odoberať členov"
        override val agencyCapabilityChangeRoles: String = "Meniť roly členov"
        override val agencyCapabilityManageAllProperties: String = "Vytvárať, upravovať a mazať všetky nehnuteľnosti"
        override val agencyCapabilityAssignAgents: String = "Priraďovať agentov"
        override val agencyCapabilitySeeAllLeads: String = "Vidieť všetky leady"
        override val agencyCapabilityExportReports: String = "Exportovať reporty"
        override val agencyCapabilityChangeBranding: String = "Meniť branding a nastavenia agentúry"
        override val agencyCapabilityDeleteAgency: String = "Zmazať agentúru"
        override val agencyCapabilityViewAssignedProperties: String = "Vidieť priradené nehnuteľnosti"
        override val agencyCapabilityHostAssignedOpenings: String = "Viesť priradené obhliadky"
        override val agencyCapabilitySeeAssignedLeads: String = "Vidieť leady z priradených nehnuteľností a obhliadok"
        override val agencyCapabilityAddNotes: String = "Pridávať poznámky"
        override val agencyCapabilitySendFollowUps: String = "Posielať pripomienky"
        override val agencyCapabilityCreateSellerReports: String = "Vytvárať reporty pre predávajúcich k priradeným ponukám"
        override val agencyCapabilityEditAssignedLeads: String = "Upravovať priradené leady"
        override val agencyCapabilityPrepareFollowUps: String = "Pripravovať pripomienky"
        override val agencyCapabilityCreateDraftReports: String = "Vytvárať návrhy reportov"
        override val agencyCapabilityCannotDeleteProperties: String = "Nemôže mazať nehnuteľnosti"
        override val agencyCapabilityCannotInviteAgents: String = "Nemôže pozývať agentov, pokiaľ to nie je povolené"
        override val agencyCapabilityViewDashboards: String = "Vidieť dashboardy"
        override val agencyCapabilityViewReports: String = "Vidieť reporty"
        override val agencyCapabilityCannotEdit: String = "Nemôže nič upravovať"
        override val commonVisitors: String = "Leady"
        override val commonHot: String = "Horúce"
        override val commonWarm: String = "Teplé"
        override val commonCold: String = "Studené"
        override val commonActive: String = "Aktívne"
        override val commonPlanned: String = "Plánované"
        override val commonArchived: String = "Archivované"
        override val commonPast: String = "Ukončené"
        override val commonFollowUps: String = "Pripomienky"
        override val commonProperty: String = "Nehnuteľnosť"
        override val commonAddress: String = "Adresa"
        override val commonOpenHouse: String = "Obhliadka"
        override val commonCheckedIn: String = "Príchod"
        override val commonNotScheduled: String = "nenaplánované"
        override val todayTitle: String = "Dnes"
        override val todaySubtitle: String = "Denný priestor pre obhliadky, leady, pripomienky a podklady pre predávajúceho."
        override val todayOpenHousesMetric: String = "obhliadky"
        override val capturedMetric: String = "zachytené"
        override val priorityMetric: String = "priorita"
        override val noActivePropertiesTitle: String = "Žiadne aktívne nehnuteľnosti"
        override val noActivePropertiesBody: String = "Pridajte alebo aktivujte nehnuteľnosť, aby sa zobrazila na obrazovke Dnes."
        override val checkIns: String = "Príchody"
        override val allOpenHouses: String = "všetky obhliadky"
        override val pendingDrafts: String = "čakajúce koncepty"
        override val priorityLead: String = "Prioritný kontakt"
        override val nextOpenHouseAt: String = "Najbližšie obhliadky"
        override val noOpenHouseScheduled: String = "Žiadna obhliadka nie je naplánované"
        override val personalAccount: String = "Osobný účet"
        override val accountReady: String = "Váš účet je pripravený"
        override val realEstateApp: String = "Realitná aplikácia"
        override val needHelp: String = "Potrebujete pomoc?"
        override val contactSupport: String = "Kontaktovať podporu"
        override val upgradePlan: String = "Vylepšiť plán"
        override val planSuffix: String = "Plán"
        override val todayActionsTitle: String = "Dnešné priority"
        override val whatOpeningNext: String = "Ktorá Obhliadka je najbližšie?"
        override val whoCheckedIn: String = "Kto sa prihlásil?"
        override val whoNeedsFollowUp: String = "Kto čaká na pripomienku?"
        override val whatShouldIDoNow: String = "Čo mám urobiť teraz?"
        override val noCheckInsYet: String = "Zatiaľ sa neprihlásil žiadny kontakt."
        override val noPendingFollowUps: String = "Momentálne nie sú žiadne čakajúce pripomienky."
        override val openKioskForNextOpening: String = "Otvorte kiosk pre najbližšiu obhliadku."
        override val reviewNewLeads: String = "Skontrolujte nové leady a pošlite pripomienky."
        override val createOpeningToStart: String = "Vytvorte obhliadku z nehnuteľnosti a začnite zbierať leady."
        override val addFirstPropertyToStart: String = "Začnite pridaním prvej nehnuteľnosti."
        override val nextOpening: String = "Najbližšia obhliadka"
        override val quickSignIn: String = "Rýchle prihlásenie"
        override val scanQrCode: String = "Skenovať QR kód"
        override val newLead: String = "Nový lead"
        override val myProperties: String = "Moje nehnuteľnosti"
        override val manageListings: String = "Spravovať ponuky"
        override val todaysOverview: String = "Dnešný prehľad"
        override val seeAll: String = "Zobraziť všetko"
        override val propertiesEyebrow: String = "Portfolio"
        override val propertiesSubtitle: String = "Spravujte aktívne, plánované a archivované ponuky s médiami a výkonom zo Supabase."
        override val propertiesLiveMetric: String = "live"
        override val propertiesPipelineMetric: String = "pipeline"
        override val propertiesAllTimeMetric: String = "celkovo"
        override val addProperty: String = "Pridať nehnuteľnosť"
        override val editProperty: String = "Upraviť nehnuteľnosť"
        override val propertyFallback: String = "Nehnuteľnosť"
        override val propertyUnavailableTitle: String = "Nehnuteľnosť nie je dostupná"
        override val propertyUnavailableBody: String = "Obnovte portfólio a načítajte túto ponuku znova."
        override val backToProperties: String = "Späť na nehnuteľnosti"
        override val deletePropertyTitle: String = "Zmazať nehnuteľnosť?"
        override val deletePropertyBody: String = "Týmto natrvalo zmažete nehnuteľnosť a jej súvisiace lokálne záznamy. Akciu nie je možné vrátiť späť."
        override val loadingProperties: String = "Načítavam nehnuteľnosti"
        override val noPropertiesTitle: String = "Zatiaľ žiadne nehnuteľnosti"
        override val noPropertiesBody: String = "Pridajte prvú nehnuteľnosť a vytvorte obhliadku, aby ste začali zbierať leady a spätnú väzbu pre predávajúceho."
        override val openHouseButton: String = "Vytvoriť obhliadku"
        override val photosTitle: String = "Fotky"
        override val photosBody: String = "Prvá fotka sa použije ako hlavný obrázok nehnuteľnosti v portfóliu."
        override val uploadPhoto: String = "Nahrať fotku"
        override val noPhotosYet: String = "Zatiaľ nie sú nahraté žiadne fotky."
        override val mainPhoto: String = "Hlavná"
        override val propertyTitleLabel: String = "Názov nehnuteľnosti"
        override val propertyAddressLine1Label: String = "Ulica a číslo"
        override val propertyAddressLine2Label: String = "Doplnenie adresy"
        override val propertyCityLabel: String = "Mesto"
        override val propertyRegionLabel: String = "Kraj"
        override val propertyPostalCodeLabel: String = "PSČ"
        override val propertyCountryLabel: String = "Krajina"
        override val propertyAskingPriceLabel: String = "Požadovaná cena"
        override val propertyBedsLabel: String = "Izby"
        override val propertyBathsLabel: String = "Kúpeľne"
        override val propertyInteriorLabel: String = "Interiér"
        override val propertyDescriptionLabel: String = "Popis"
        override val createPropertyButton: String = "+ Vytvoriť nehnuteľnosť"
        override val locateProperty: String = "Lokalizovať nehnuteľnosť"
        override val findLocation: String = "Nájsť polohu"
        override val find: String = "Nájsť"
        override val navigate: String = "Navigovať"
        override val propertyLocationMarkerTitle: String = "Poloha nehnuteľnosti"
        override val mapKitJsMissingToken: String = "Pridajte HAVN_MAPKIT_JS_TOKEN do local.properties pre webovú mapu."
        override val mapKitJsLoading: String = "Načítava sa MapKit JS..."
        override val generateSellerReport: String = "Vygenerovať report pre predávajúceho"
        override val deleteProperty: String = "Zmazať nehnuteľnosť"
        override val conversionMetric: String = "Konverzia"
        override val propertyPhotoContentDescription: String = "Fotka nehnuteľnosti"
        override val deletePhoto: String = "Zmazať fotku"
        override val movePhotoLeft: String = "Presunúť fotku doľava"
        override val movePhotoRight: String = "Presunúť fotku doprava"
        override val propertyTitleRequired: String = "Názov nehnuteľnosti je povinný."
        override val propertyStreetRequired: String = "Ulica a číslo sú povinné."
        override val propertyCityRequired: String = "Mesto je povinné."
        override val propertyRegionRequired: String = "Kraj je povinný."
        override val propertyPostalRequired: String = "PSČ je povinné."
        override val propertyAskingPriceInvalid: String = "Zadajte platnú požadovanú cenu."
        override val propertyOwnerContactTitle: String = "Kontakt na majiteľa nehnuteľnosti"
        override val propertyOwnerSelectContact: String = "Vyberte existujúci kontakt ako majiteľa nehnuteľnosti."
        override val propertyOwnerSelected: String = "Vybraný majiteľ"
        override val propertyOwnerNoContacts: String = "Zatiaľ nemáte žiadne kontakty. Pridajte majiteľa v Kontaktoch a potom ho tu vyberte."
        override val propertyOwnerChooseContact: String = "Vybrať kontakt"
        override val propertyOwnerChangeContact: String = "Zmeniť kontakt"
        override val propertyOwnerRemoveContact: String = "Odstrániť"
        override val propertyOwnerPickerTitle: String = "Vyberte majiteľa nehnuteľnosti"
        override val propertyOwnerSearchContact: String = "Hľadať kontakty"
        override val propertyOwnerSearchHint: String = "Začnite písať meno, e-mail alebo telefón."
        override val propertyOwnerNoMatches: String = "Nenašli sa žiadne kontakty."
        override val propertyOpeningsTitle: String = "Obhliadky"
        override val propertyNoOpenings: String = "Pre túto nehnuteľnosť nie sú naplánované žiadne obhliadky."
        override val teamAccessTitle: String = "Prístup tímu"
        override val onlyListingOwner: String = "Iba vlastník ponuky"
        override val assignTeam: String = "Priradiť tím"
        override val assignPropertyTitle: String = "Priradiť nehnuteľnosť"
        override val assignPropertyBody: String = "Vyberte, kto môže pracovať s touto nehnuteľnosťou. Vyberte celý tím alebo konkrétnych agentov."
        override val wholeTeam: String = "Celý tím"
        override val leadsEyebrow: String = "Leady"
        override val leadFallback: String = "Kontakt"
        override val leadsSubtitle: String = "Vyhľadávajte, filtrujte a kvalifikujte leady zo všetkých obhliadok."
        override val leadDetailSubtitle: String = "Zdroj, kvalifikácia, poznámky a história pripomienok pre tento lead."
        override val totalMetric: String = "Spolu"
        override val loggedMetric: String = "zapísané"
        override val searchLeads: String = "Hľadať kontakty"
        override val searchLeadsPlaceholder: String = "Meno, telefón alebo email"
        override val allProperties: String = "Všetky nehnuteľnosti"
        override val loadingLeads: String = "Načítavam leady z obhliadok"
        override val noLeadsFoundTitle: String = "Leady sa zobrazia tu, keď sa kontakty prihlásia na obhliadku."
        override val noLeadsEmptyBody: String = "Použite kiosk alebo pridajte kontakty ručne z obhliadky."
        override val noLeadsFilteredBody: String = "Skúste inú nehnuteľnosť, teplotu kontaktu alebo hľadaný výraz."
        override val backToLeads: String = "Späť na kontakty"
        override val leadUnavailableTitle: String = "Kontakt nie je dostupný"
        override val leadUnavailableBody: String = "Tento lead už nie je dostupný v aktuálnom zozname kontaktov."
        override val leadTemperature: String = "Stav leadu"
        override val leadLabelSuffix: String = "Lead"
        override val greetingHi: String = "Dobrý deň"
        override val leadActionCall: String = "Zavolať"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "E-mail"
        override val leadFollowUp: String = "Pripomienka"
        override val leadNoFollowUpScheduled: String = "Pripomienka nie je naplánovaná"
        override val leadIntentScore: String = "Skóre záujmu"
        override val leadInterestedIn: String = "Záujem o"
        override val leadGenericGreetingName: String = "vás"
        override val followUpMessageTypeThankYou: String = "Poďakovanie"
        override val followUpMessageTypePropertyInfo: String = "Info o nehnuteľnosti"
        override val followUpMessageTypeFollowUp: String = "Pripomienka"
        override val followUpMessageTypeCheckIn: String = "Overenie záujmu"
        override val followUpMessageTypePriceUpdate: String = "Zmena ceny"
        override val followUpMessageTypePropertyBrochure: String = "Fotky"
        override val followUpPreview: String = "Náhľad"
        override val followUpSubject: String = "Predmet"
        override val followUpMessage: String = "Správa"
        override val followUpSendViaEmail: String = "Odoslať e-mailom"
        override val followUpSendViaSms: String = "Odoslať SMS"
        override val followUpAiAssistantTitle: String = "AI asistent"
        override val followUpAiAssistantBody: String = "Vygenerujte osobnú správu za pár sekúnd."
        override val followUpGenerateWithAi: String = "Vygenerovať s AI"
        override val followUpUpgradeForAi: String = "Odomknúť AI"
        override val followUpDefaultSubject: String = "Pripomienka k nehnuteľnosti"
        override val privateAgentNotes: String = "Súkromné poznámky agenta"
        override val notes: String = "Poznámky"
        override val notesPlaceholder: String = "Motivácia, preferencie, námietky, ďalší krok"
        override val saveNotes: String = "Uložiť poznámky"
        override val followUpHistory: String = "História pripomienok"
        override val noFollowUpsLogged: String = "Zatiaľ nie sú zapísané žiadne pripomienky."
        override val openHousesEyebrow: String = "Obhliadky"
        override val scheduleOpenHouse: String = "Vytvoriť obhliadku"
        override val openingDetails: String = "Detail obhliadky"
        override val editOpening: String = "Upraviť obhliadku"
        override val deleteOpening: String = "Vymazať obhliadku"
        override val deleteOpeningBody: String = "Naozaj chcete vymazať túto obhliadku? Táto akcia sa nedá vrátiť späť."
        override val openingName: String = "Názov obhliadky"
        override val startsAt: String = "Začína"
        override val endsAt: String = "Končí"
        override val chooseStartDateTime: String = "Vyberte dátum a čas začiatku"
        override val chooseEndDateTime: String = "Vyberte dátum a čas konca"
        override val accessNotes: String = "Poznámky k prístupu"
        override val privateNotes: String = "Súkromné poznámky"
        override val addPrivateNote: String = "Pridať súkromnú poznámku"
        override val liveDashboard: String = "Live prehľad"
        override val visitorKiosk: String = "Kiosk leadov"
        override val openHousesSubtitle: String = "Vytvárajte obhliadky k nehnuteľnostiam, sledujte leady a spúšťajte kiosk."
        override val liveMetric: String = "Live"
        override val upcomingMetric: String = "Najbližšie"
        override val inProgressMetric: String = "prebieha"
        override val scheduledMetric: String = "naplánované"
        override val loadingOpenHouses: String = "Načítavam obhliadky"
        override val addPropertyFirstTitle: String = "Najprv pridajte nehnuteľnosť"
        override val addPropertyFirstBody: String = "Vytvorte obhliadku z nehnuteľnosti a začnite zbierať leady."
        override val noOpenHousesTitle: String = "Žiadne naplánované obhliadky"
        override val noOpenHousesBody: String = "Vytvorte obhliadku z nehnuteľnosti a začnite zbierať leady."
        override val noSignInsTitle: String = "Žiadne príchody"
        override val noSignInsBody: String = "Leady prihlásené cez kiosk sa tu zobrazia v reálnom čase."
        override val dashboard: String = "Prehľad"
        override val start: String = "Spustiť"
        override val end: String = "Ukončiť"
        override val endOpenHouse: String = "Ukončiť obhliadku"
        override val reportsEyebrow: String = "Predávajúci"
        override val sellerReportsTitle: String = "Reporty pre predávajúceho"
        override val createReport: String = "Vytvoriť report"
        override val reportPreview: String = "Property Report"
        override val reportsSubtitle: String = "Generujte luxusné súhrny po obhliadke s kvalitou leadov, záujmom kupujúcich a naratívom pre predávajúceho."
        override val reportsMetricSaved: String = "uložené"
        override val reportedMetric: String = "reportované"
        override val leadsMetric: String = "kontakty"
        override val createSellerReport: String = "Vytvoriť report pre predávajúceho"
        override val attendance: String = "Účasť"
        override val savedReports: String = "uložené reporty"
        override val buyerHeat: String = "Záujem kupujúcich"
        override val hotLeads: String = "horúce kontakty"
        override val loadingSellerReports: String = "Načítavam reporty pre predávajúceho"
        override val noSellerReportsTitle: String = "Zatiaľ žiadne reporty"
        override val noSellerReportsBody: String = "Vyberte obhliadku, pridajte poznámky agenta, zobrazte náhľad a uložte report."
        override val chooseOpenHouse: String = "Vyberte obhliadku"
        override val noOpenHousesAvailable: String = "Zatiaľ nie sú dostupné žiadne obhliadky."
        override val agentNotes: String = "Poznámky agenta"
        override val notesForSeller: String = "Poznámky pre predávajúceho"
        override val sellerNotesPlaceholder: String = "Námietky kupujúcich, cenové signály, spätná väzba, odporúčaný ďalší krok"
        override val generatePreview: String = "Vygenerovať náhľad"
        override val noPreviewReadyTitle: String = "Náhľad nie je pripravený"
        override val noPreviewReadyBody: String = "Pred uložením najprv vygenerujte náhľad reportu."
        override val saveReport: String = "Uložiť report"
        override val reportSaved: String = "Report uložený"
        override val sellerOpenHouseReport: String = "Report z obhliadky pre predávajúceho"
        override val mostCommonBuyerInterest: String = "Najčastejší záujem kupujúcich"
        override val followUpsSent: String = "Odoslané pripomienky"
        override val summary: String = "Súhrn"
        override val noPrivateNotesAdded: String = "Neboli pridané žiadne súkromné poznámky."
        override val openHouseReport: String = "Report z obhliadky"
        override val searchProperties: String = "Hľadať nehnuteľnosti"
        override val searchOpenings: String = "Hľadať obhliadky"
        override val noOpeningsFoundTitle: String = "Nenašli sa žiadne obhliadky"
        override val noOpeningsFoundBody: String = "Skúste iné vyhľadávanie alebo filter stavu obhliadky."
        override val noMatchingPropertiesTitle: String = "Žiadne zodpovedajúce nehnuteľnosti"
        override val noMatchingPropertiesBody: String = "Skúste iné vyhľadávanie alebo filter stavu."
        override val clientsTitle: String = "Kontakty"
        override val clientFallback: String = "Kontakt"
        override val addClient: String = "Pridať kontakt"
        override val editClient: String = "Upraviť kontakt"
        override val newClient: String = "Nový kontakt"
        override val saveClient: String = "Uložiť kontakt"
        override val createClient: String = "Vytvoriť kontakt"
        override val deleteClientTitle: String = "Zmazať kontakt?"
        override val deleteClientBody: String = "Týmto natrvalo zmažete kontakt. Akciu nie je možné vrátiť späť."
        override val firstName: String = "Meno"
        override val lastName: String = "Priezvisko"
        override val email: String = "Email"
        override val phone: String = "Telefón"
        override val comments: String = "Komentáre"
        override val addPhoto: String = "Pridať fotku"
        override val sendQr: String = "Odoslať QR"
        override val photo: String = "Fotka"
        override val clientDetailSubtitle: String = "QR identita, kontaktné údaje, komentáre a obhliadky prepojené cez leady."
        override val clientFormEditSubtitle: String = "Upravte kontaktné údaje, doručenie a komentáre."
        override val clientFormNewSubtitle: String = "Zaregistrujte kupujúceho/kontakt a vytvorte opakovane použiteľnú QR identitu pre obhliadky."
        override val searchClients: String = "Hľadať kontakty"
        override val noClientsYetTitle: String = "Zatiaľ žiadne kontakty"
        override val noClientsYetBody: String = "Najprv zaregistrujte kontakty a potom im pred obhliadkou odošlite QR kód emailom alebo SMS."
        override val noClientsFoundTitle: String = "Nenašli sa žiadne kontakty"
        override val noClientsFoundBody: String = "Skúste iné meno, telefón alebo email."
        override val clientUnavailableTitle: String = "Kontakt nie je dostupný"
        override val clientUnavailableBody: String = "Obnovte zoznam kontaktov a otvorte tento záznam znova."
        override val noCommentsAdded: String = "Neboli pridané žiadne komentáre."
        override val openingsTitle: String = "Obhliadky"
        override val clientOpeningsEmpty: String = "Zatiaľ nie sú pripojené žiadne obhliadky. Leady prepájajú kontakt s obhliadkou."
        override val clientPassLabel: String = "Pass"
        override val clientNoEmail: String = "Bez e-mailu"
        override val visitorsBody: String = "Otvorte kiosk, naskenujte QR kontakt alebo pridajte existujúce kontakty ako leady pre túto obhliadku."
        override val openKiosk: String = "Otvoriť kiosk"
        override val addQrClient: String = "Pridať QR kontakt"
        override val addManually: String = "Pridať manuálne"
        override val selectClients: String = "Vybrať kontakty"
        override val selectClientsBody: String = "Vyberte kontakty zo zoznamu. Každý vybraný kontakt sa stane leadom pre túto obhliadku."
        override val kioskCheckIn: String = "Kiosk check-in"
        override val kioskCheckInBody: String = "Použite zadnú kameru na skenovanie HAVN Wallet QR kontaktu. Keď sa kód rozpozná, HAVN automaticky vytvorí lead pre túto obhliadku."
        override val scanWithCamera: String = "Skenovať zadnou kamerou"
        override val clientQrImage: String = "QR obrázok kontaktu"
        override val clientQrImageBody: String = "Držte QR kontaktu v zlatom štvorci. HAVN pridá každý sken do zoznamu nižšie."
        override val scanMultipleQrBody: String = "Naskenujte jeden alebo viac HAVN QR kódov kontaktov a potom klepnite na Pridať QR kontakt."
        override val scannedQrReady: String = "QR kontakt pripravený na pridanie"
        override val createLeadFromQr: String = "Vytvoriť lead z QR"
        override val noClientsFoundShort: String = "Nenašli sa žiadne kontakty."
        override val remove: String = "Odstrániť"
    }

    private val german: HavnStrings = object : HavnStrings {
        override val navToday: String = "Heute"
        override val navProperties: String = "Immobilien"
        override val navLeads: String = "Leads"
        override val navReports: String = "Berichte"
        override val navSettings: String = "Einstellungen"
        override val navAuth: String = "Agentenzugang"
        override val navOpenHouses: String = "Besichtigungen"
        override val navTours: String = "Besichtigungen"
        override val navFollowUps: String = "Kontakte"
        override val navFollow: String = "Kontakte"
        override val back: String = "Zuruck"
        override val settingsEyebrow: String = "Arbeitsbereich"
        override val settingsTitle: String = "Einstellungen"
        override val settingsSubtitle: String = "Profil, Sprache, Einheiten, Umgebung und Teamoptionen."
        override val agentProfileTitle: String = "Agentenprofil"
        override val agentPhoto: String = "Agentenfoto"
        override val uploading: String = "Wird hochgeladen..."
        override val saving: String = "Wird gespeichert..."
        override val validAgentPhotoRequired: String = "Wählen Sie ein gültiges Agentenfoto."
        override val signOut: String = "Abmelden"
        override val signOutQuestion: String = "Abmelden?"
        override val signOutConfirmation: String = "Möchten Sie sich wirklich von HAVN abmelden?"
        override val upgrade: String = "Upgrade"
        override val premiumThemesTitle: String = "Premium-Designs"
        override val premiumThemesUpgradePrompt: String = "Wechseln Sie zu Pro, um Premium-Designs freizuschalten."
        override val appearanceTitle: String = "Darstellung"
        override val appearanceBody: String = "Wählen Sie ein kuratiertes HAVN-Design. Premium-Designs sind mit Pro verfügbar."
        override val previewComponents: String = "Komponenten ansehen"
        override val themeShowcaseTitle: String = "Design-Vorschau"
        override val showcaseButtons: String = "Buttons"
        override val showcasePrimaryAction: String = "Primäre Aktion"
        override val showcaseSecondaryAction: String = "Sekundäre Aktion"
        override val showcaseGhostAction: String = "Dezente Aktion"
        override val showcaseTextField: String = "Textfeld"
        override val showcaseFocusedBorder: String = "Akzent-Rahmen im Fokus"
        override val showcaseSearchPreview: String = "Suchvorschau"
        override val showcaseOpeningCheckedIn: String = "Heute bei einer Besichtigung eingecheckt"
        override val showcaseSentAt: String = "Gesendet um 10:30"
        override val themeObsidianGoldName: String = "Obsidian Gold"
        override val themeObsidianGoldDescription: String = "Luxuriöses Schwarz, Graphit und warmes Gold."
        override val themeMidnightSapphireName: String = "Midnight Sapphire"
        override val themeMidnightSapphireDescription: String = "Tiefes Navy, Saphirblau und silberne Akzente."
        override val themeEmeraldEstateName: String = "Emerald Estate"
        override val themeEmeraldEstateDescription: String = "Dunkles Smaragdgrün, Anthrazit und Champagnergold."
        override val themePlatinumStoneName: String = "Platinum Stone"
        override val themePlatinumStoneDescription: String = "Steingrau, Platin und sanftes Weiß."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Dunkler Weinrot-Ton, Graphit und Kupferakzente."
        override val commonChange: String = "Ändern"
        override val agentPlanTitle: String = "Agentenplan"
        override val agentPlanBody: String = "Verbessern Sie Ihre Arbeitsweise und wählen Sie den Plan, der am besten passt."
        override val currentPlan: String = "Aktueller Plan"
        override val transferPlan: String = "Plan übertragen"
        override val restorePurchase: String = "Kauf wiederherstellen"
        override val agencySettingsProBody: String = "Solo agency ist standardmäßig aktiv. Mit Pro können Sie eine gemeinsame Agentur erstellen oder auswählen."
        override val agencySettingsLockedBody: String = "Solo agency ist aktiv. Änderungen an Agenturen sind mit Pro verfügbar."
        override val soloAgency: String = "Solo agency"
        override val defaultPrivateAgencyWorkspace: String = "Standardmäßige private Agentur"
        override val noAgenciesAvailableYet: String = "Es sind noch keine Einladungen oder eigenen Agenturen verfügbar."
        override val oneOwnedAgencyHint: String = "Ihre eigene Agentur ist oben aufgeführt. Ein Agent kann eine Agentur besitzen."
        override val createAgency: String = "Agentur erstellen"
        override val createYourAgency: String = "Erstellen Sie Ihre Agentur"
        override val createAgencyBody: String = "Bauen Sie Ihr Team auf, verwalten Sie Immobilien gemeinsam und wachsen Sie weiter."
        override val agencyName: String = "Agenturname"
        override val agencyEmail: String = "Agentur-E-Mail"
        override val logoOptional: String = "Logo (optional)"
        override val upgradeExperienceTitle: String = "Erweitern Sie Ihr Erlebnis"
        override val upgradeExperienceSubtitle: String = "Wählen Sie den Plan, der zu Ihrer Arbeitsweise passt."
        override val soloAgentPlan: String = "Solo agent"
        override val proAgentPlan: String = "Pro agent"
        override val soloBenefitActiveProperties: String = "Bis zu 5 aktive Immobilien"
        override val soloBenefitAiFollowUps: String = "AI-Follow-ups (Basis)"
        override val soloBenefitSellerReports: String = "Luxus-Verkäuferberichte (Basis)"
        override val soloBenefitPersonalOnly: String = "Nur persönliches Konto"
        override val proBenefitUnlimitedProperties: String = "Unbegrenzte Immobilien"
        override val proBenefitUnlimitedAi: String = "AI-Follow-ups (unbegrenzt)"
        override val proBenefitAdvancedReports: String = "Erweiterte Verkäuferberichte"
        override val proBenefitAgencyCreation: String = "Agentur erstellen und verwalten"
        override val proBenefitInviteAgents: String = "Agenten einladen und zusammenarbeiten"
        override val proBenefitSharedLeads: String = "Geteilte Leads und Teamabläufe"
        override val proBenefitAgencyBranding: String = "Agentur-Branding"
        override val proBenefitAdvancedAnalytics: String = "Erweiterte Analysen"
        override val startFreeTrial7Day: String = "Jetzt abonnieren"
        override val restorePurchases: String = "Käufe wiederherstellen"
        override val comparePlans: String = "Pläne vergleichen"
        override val startFreeTrial: String = "Plan wählen"
        override val noCommitmentCancelAnytime: String = "Keine Verpflichtung. Jederzeit kündbar."
        override val monthly: String = "Monthly"
        override val yearly: String = "Yearly"
        override val yearlySave20: String = "Yearly - save 20%"
        override val yearlySavings20: String = "Yearly saves 20% compared to monthly."
        override val perYear: String = "/ year"
        override val loadingPlans: String = "Loading plans..."
        override val selectedPlanUnavailable: String = "This plan is not available yet. Check RevenueCat offerings and product identifiers."
        override val signInRequiredForPurchase: String = "Sign in before starting a purchase."
        override val compareActiveProperties: String = "Aktive Immobilien"
        override val compareAiFollowUps: String = "AI-Follow-ups"
        override val compareSellerReports: String = "Verkäuferberichte"
        override val compareAdvancedAnalytics: String = "Erweiterte Analysen"
        override val compareAgencyCreation: String = "Agenturerstellung"
        override val compareJoinAgencies: String = "Agenturen beitreten"
        override val compareInviteAgents: String = "Agenten einladen"
        override val compareSharedLeads: String = "Geteilte Leads"
        override val compareAgencyBranding: String = "Agentur-Branding"
        override val comparePrioritySupport: String = "Prioritäts-Support"
        override val unlimited: String = "Unbegrenzt"
        override val basic: String = "Basis"
        override val advanced: String = "Erweitert"
        override val perMonth: String = "/ Monat"
        override val members: String = "Mitglieder"
        override val upgradeToProForAgencyTools: String = "Wechseln Sie zu Pro, um Agentur-Tools zu nutzen"
        override val languageTitle: String = "Sprache"
        override val languageBody: String = "Wahlen Sie die App-Sprache fur dieses Gerat."
        override val english: String = "English"
        override val slovak: String = "Slovak"
        override val unitsTitle: String = "Einheiten und Wahrung"
        override val unitsBody: String = "Legen Sie fest, wie Preise und Flachen in der App angezeigt werden."
        override val measurementSystemTitle: String = "Masssystem"
        override val metric: String = "Metrisch"
        override val imperial: String = "Imperial"
        override val currencyTitle: String = "Wahrung"
        override val notificationsTitle: String = "Notifications"
        override val notificationsBody: String = "Control push alerts, quiet hours, and the types of updates HAVN can send."
        override val notificationSettings: String = "Notification settings"
        override val notificationsSubtitle: String = "Only important updates, filtered by your preferences."
        override val quietHoursTitle: String = "Quiet hours"
        override val quietHoursBody: String = "HAVN skips non-critical pushes during quiet hours. Billing and account issues still stay concise."
        override val enableQuietHours: String = "Enable quiet hours"
        override val quietHoursStart: String = "Start"
        override val quietHoursEnd: String = "End"
        override val timezoneLabel: String = "Timezone"
        override val notificationTypesTitle: String = "Notification types"
        override val notificationNewLeadCapturedTitle: String = "New lead captured"
        override val notificationNewLeadCapturedBody: String = "When an opening or QR flow captures a lead."
        override val notificationHotLeadTitle: String = "Lead marked as hot"
        override val notificationHotLeadBody: String = "Only when a lead becomes high intent."
        override val notificationOpeningStartsSoonTitle: String = "Opening starts soon"
        override val notificationOpeningStartsSoonBody: String = "A single reminder 30 minutes before start."
        override val notificationOpeningSummaryReadyTitle: String = "Opening summary ready"
        override val notificationOpeningSummaryReadyBody: String = "When the post-event summary is ready."
        override val notificationSellerReportGeneratedTitle: String = "Seller report generated"
        override val notificationSellerReportGeneratedBody: String = "When a seller report has been created."
        override val notificationAiFollowUpReadyTitle: String = "AI follow-up ready"
        override val notificationAiFollowUpReadyBody: String = "When a follow-up draft is ready to review."
        override val notificationAgentInvitedTitle: String = "Agent invited to agency"
        override val notificationAgentInvitedBody: String = "Agency invitations and membership changes."
        override val notificationLeadAssignedTitle: String = "Lead assigned to you"
        override val notificationLeadAssignedBody: String = "When a teammate assigns a lead to you."
        override val notificationLeadTransferredTitle: String = "Lead transferred to you"
        override val notificationLeadTransferredBody: String = "When ownership of a lead moves to you."
        override val notificationSubscriptionIssueTitle: String = "Subscription issue"
        override val notificationSubscriptionIssueBody: String = "Renewal failures and billing problems."
        override val kioskSecurityTitle: String = "Kiosk security"
        override val kioskSecurityBody: String = "Use this PIN to leave kiosk mode and return to the agent app."
        override val kioskPinLabel: String = "Kiosk PIN"
        override val kioskFeaturedProperty: String = "Featured property"
        override val kioskPrivateShowing: String = "Private showing"
        override val kioskLuxuryListing: String = "Luxury listing"
        override val kioskFastCheckIn: String = "Fast check-in"
        override val kioskExitContentDescription: String = "Exit kiosk"
        override val kioskWelcome: String = "Welcome"
        override val kioskGladHere: String = "We’re glad you’re here."
        override val kioskScanToCheckIn: String = "Scan to check in"
        override val kioskReceivePropertyDetails: String = "and receive property details"
        override val kioskOr: String = "Or"
        override val kioskStartCheckInManually: String = "Start check-in manually"
        override val kioskSecureInfo: String = "Your information is secure and will never be shared."
        override val kioskExitTitle: String = "Exit kiosk"
        override val kioskExitBody: String = "Enter the kiosk PIN to return to the agent app."
        override val kioskIncorrectPin: String = "Incorrect PIN."
        override val kioskUnlock: String = "Unlock"
        override val kioskTellUsTitle: String = "Tell us about yourself"
        override val kioskTellUsBody: String = "Your information goes only to the hosting agent."
        override val kioskFullName: String = "Full name"
        override val kioskContinue: String = "Continue"
        override val kioskQuestionsTitle: String = "A couple quick questions"
        override val kioskQuestionsBody: String = "This helps the agent follow up with the right context."
        override val kioskWorkingWithAgentQuestion: String = "Are you working with an agent?"
        override val kioskYes: String = "Yes"
        override val kioskNo: String = "No"
        override val kioskInterestQuestion: String = "What are you interested in?"
        override val kioskInterestBuying: String = "Buying"
        override val kioskInterestInvesting: String = "Investing"
        override val kioskInterestBrowsing: String = "Just browsing"
        override val kioskInterestRelocating: String = "Relocating"
        override val kioskFinish: String = "Finish"
        override val kioskThankYou: String = "Thank you"
        override val kioskEnjoyVisitPrefix: String = "Enjoy your visit at"
        override val kioskResetAutomatically: String = "This kiosk will reset automatically."
        override val environmentTitle: String = "Environment"
        override val environmentBody: String = "Local Supabase is configured for development. Production values should move behind build-time configuration."
        override val secure: String = "Secure"
        override val brokerageProfileTitle: String = "Brokerage profile"
        override val brokerageProfileBody: String = "Team branding, agent invites, and notification preferences will live here."
        override val logout: String = "Abmelden"
        override val languageChanged: String = "Language changed"
        override val commonAdd: String = "Add"
        override val commonEdit: String = "Bearbeiten"
        override val commonDelete: String = "Loschen"
        override val commonCancel: String = "Abbrechen"
        override val commonSave: String = "Speichern"
        override val commonCreate: String = "Erstellen"
        override val commonDismiss: String = "Dismiss"
        override val commonAll: String = "Alle"
        override val commonDone: String = "Fertig"
        override val commonTime: String = "Zeit"
        override val commonHour: String = "Stunde"
        override val commonMinute: String = "Minute"
        override val commonAgency: String = "Agentur"
        override val commonSettings: String = "Einstellungen"
        override val commonOpening: String = "Opening"
        override val commonPropertyName: String = "Immobilie"
        override val commonToday: String = "Heute"
        override val agencyToolsAvailable: String = "Agentur-Tools sind verfügbar."
        override val agencySetupSubtitle: String = "Jedes HAVN-Konto hat eine Standardagentur. Pro ermöglicht Einladungen, gemeinsame Leads und Branding."
        override val agencyRecentActivity: String = "Recent activity"
        override val agencyActivityNewLead: String = "New lead added"
        override val agencyActivityInvitationAccepted: String = "Agent invitation accepted"
        override val agencyActivityAgentJoined: String = "Agent joined the agency"
        override val agencyActivitySellerReport: String = "Seller report created"
        override val agencyWorkspaceTitle: String = "Agency workspace"
        override val agencyWorkspaceBody: String = "Choose which agency you are working with."
        override val agencySoloActiveTitle: String = "Solo agency is active"
        override val agencyProRequiredTitle: String = "Pro plan required"
        override val agencyCreateOrAcceptInviteBody: String = "Create your agency workspace or accept an invite to collaborate with another agency."
        override val agencyProUnlockBody: String = "Agency changes, invites, shared leads, and shared branding unlock with Pro."
        override val realEstate: String = "Real estate"
        override val proAgency: String = "Pro agency"
        override val agencyBrandingTitle: String = "Agency branding"
        override val agencyBrandingBody: String = "Set the agency name and logo shown in the app, kiosk, and shared workspace."
        override val uploadLogo: String = "Upload logo"
        override val saveAgency: String = "Save agency"
        override val yourAgencyRole: String = "Your agency role"
        override val agencyAgentsTitle: String = "Agency agents"
        override val agencyAgentsBody: String = "People eligible to work with this agency."
        override val inviteAgent: String = "Invite agent"
        override val loadingAgents: String = "Loading agents..."
        override val noAgencyAgentsYet: String = "No agency agents yet."
        override val changeRole: String = "Change role"
        override val updating: String = "Updating..."
        override val deleting: String = "Deleting..."
        override val deleteInvite: String = "Delete invite"
        override val chooseAgencyRoleFor: String = "Choose the agency role for"
        override val removeAccess: String = "Remove access"
        override val inviteAgentBody: String = "Send an agency invitation by email. The agent accepts after signing in with the same email."
        override val agentEmail: String = "Agent email"
        override val role: String = "Role"
        override val inviting: String = "Inviting..."
        override val invite: String = "Invite"
        override val agents: String = "Agents"
        override val ok: String = "Ok"
        override val personalActivePropertyLimit: String = "Personal active property limit"
        override val personalAccountAgencyToolsLocked: String = "Personal account is active. Agency tools unlock with Pro."
        override val selected: String = "Selected"
        override val activeMembers: String = "active members"
        override val agencySharedWorkspaceBody: String = "Shared properties, contacts, openings, leads, follow-ups, and reports use this agency workspace."
        override val agencyRoleOwner: String = "Owner"
        override val agencyRoleAdmin: String = "Admin"
        override val agencyRoleAgent: String = "Agent"
        override val agencyRoleAssistant: String = "Assistant"
        override val agencyRoleViewer: String = "Viewer"
        override val agencyRoleOwnerDescription: String = "Full agency control, including members, branding, assignments, listings, leads, and reports."
        override val agencyRoleAdminDescription: String = "Full agency management except deleting the agency."
        override val agencyRoleAgentDescription: String = "Works assigned listings, openings, leads, follow-ups, notes, and seller reports."
        override val agencyRoleAssistantDescription: String = "Supports assigned listings by editing leads, preparing follow-ups, and drafting reports."
        override val agencyRoleViewerDescription: String = "Read-only access to dashboards and reports."
        override val agencyCapabilityInviteRemoveMembers: String = "Invite and remove members"
        override val agencyCapabilityChangeRoles: String = "Change member roles"
        override val agencyCapabilityManageAllProperties: String = "Create, edit, and delete all properties"
        override val agencyCapabilityAssignAgents: String = "Assign agents"
        override val agencyCapabilitySeeAllLeads: String = "See all leads"
        override val agencyCapabilityExportReports: String = "Export reports"
        override val agencyCapabilityChangeBranding: String = "Change agency branding and settings"
        override val agencyCapabilityDeleteAgency: String = "Delete agency"
        override val agencyCapabilityViewAssignedProperties: String = "View assigned properties"
        override val agencyCapabilityHostAssignedOpenings: String = "Host assigned openings"
        override val agencyCapabilitySeeAssignedLeads: String = "See leads from assigned properties and openings"
        override val agencyCapabilityAddNotes: String = "Add notes"
        override val agencyCapabilitySendFollowUps: String = "Send follow-ups"
        override val agencyCapabilityCreateSellerReports: String = "Create seller reports for assigned listings"
        override val agencyCapabilityEditAssignedLeads: String = "Edit assigned leads"
        override val agencyCapabilityPrepareFollowUps: String = "Prepare follow-ups"
        override val agencyCapabilityCreateDraftReports: String = "Create draft reports"
        override val agencyCapabilityCannotDeleteProperties: String = "Cannot delete properties"
        override val agencyCapabilityCannotInviteAgents: String = "Cannot invite agents unless allowed"
        override val agencyCapabilityViewDashboards: String = "View dashboards"
        override val agencyCapabilityViewReports: String = "View reports"
        override val agencyCapabilityCannotEdit: String = "Cannot edit anything"
        override val commonVisitors: String = "Leads"
        override val commonHot: String = "Hot"
        override val commonWarm: String = "Warm"
        override val commonCold: String = "Cold"
        override val commonActive: String = "Aktiv"
        override val commonPlanned: String = "Geplant"
        override val commonArchived: String = "Archiviert"
        override val commonPast: String = "Vergangen"
        override val commonFollowUps: String = "Follow-ups"
        override val commonProperty: String = "Immobilie"
        override val commonAddress: String = "Adresse"
        override val commonOpenHouse: String = "Opening"
        override val commonCheckedIn: String = "Checked in"
        override val commonNotScheduled: String = "not scheduled"
        override val todayTitle: String = "Today"
        override val todaySubtitle: String = "Your daily workspace for openings, leads, follow-ups, and seller-ready momentum."
        override val todayOpenHousesMetric: String = "openings"
        override val capturedMetric: String = "captured"
        override val priorityMetric: String = "priority"
        override val noActivePropertiesTitle: String = "No active properties"
        override val noActivePropertiesBody: String = "Add or activate a property to make it appear on Today."
        override val checkIns: String = "Check-ins"
        override val allOpenHouses: String = "all openings"
        override val pendingDrafts: String = "pending drafts"
        override val priorityLead: String = "Priority lead"
        override val nextOpenHouseAt: String = "Next opening at"
        override val noOpenHouseScheduled: String = "No opening scheduled"
        override val personalAccount: String = "Persönliches Konto"
        override val accountReady: String = "Ihr Konto ist bereit"
        override val realEstateApp: String = "Immobilien-App"
        override val needHelp: String = "Brauchen Sie Hilfe?"
        override val contactSupport: String = "Support kontaktieren"
        override val upgradePlan: String = "Plan upgraden"
        override val planSuffix: String = "Plan"
        override val todayActionsTitle: String = "Heutige Prioritäten"
        override val whatOpeningNext: String = "Welches Opening ist als Nächstes?"
        override val whoCheckedIn: String = "Wer hat eingecheckt?"
        override val whoNeedsFollowUp: String = "Wer braucht ein Follow-up?"
        override val whatShouldIDoNow: String = "Was soll ich jetzt tun?"
        override val noCheckInsYet: String = "Noch keine Kontakte eingecheckt."
        override val noPendingFollowUps: String = "Aktuell keine offenen Follow-ups."
        override val openKioskForNextOpening: String = "Öffnen Sie den Kiosk für das nächste Opening."
        override val reviewNewLeads: String = "Prüfen Sie neue Leads und senden Sie Follow-ups."
        override val createOpeningToStart: String = "Erstellen Sie ein Opening aus einer Immobilie, um Leads zu sammeln."
        override val addFirstPropertyToStart: String = "Fügen Sie Ihre erste Immobilie hinzu."
        override val nextOpening: String = "Nächstes Opening"
        override val quickSignIn: String = "Schneller Check-in"
        override val scanQrCode: String = "QR-Code scannen"
        override val newLead: String = "Neuer Lead"
        override val myProperties: String = "Meine Immobilien"
        override val manageListings: String = "Angebote verwalten"
        override val todaysOverview: String = "Heutige Übersicht"
        override val seeAll: String = "Alle anzeigen"
        override val propertiesEyebrow: String = "Portfólio"
        override val propertiesSubtitle: String = "Manage active, planned, and archived listings with Supabase-backed media and performance intelligence."
        override val propertiesLiveMetric: String = "live"
        override val propertiesPipelineMetric: String = "pipeline"
        override val propertiesAllTimeMetric: String = "all time"
        override val addProperty: String = "Immobilie hinzufugen"
        override val editProperty: String = "Immobilie bearbeiten"
        override val propertyFallback: String = "Property"
        override val propertyUnavailableTitle: String = "Immobilie nicht verfügbar"
        override val propertyUnavailableBody: String = "Refresh the portfolio to reload this listing."
        override val backToProperties: String = "Zurück zu Immobilien"
        override val deletePropertyTitle: String = "Immobilie löschen?"
        override val deletePropertyBody: String = "This will permanently delete the property and its related local records. This cannot be undone."
        override val loadingProperties: String = "Immobilien werden geladen"
        override val noPropertiesTitle: String = "Noch keine Immobilien"
        override val noPropertiesBody: String = "Add your first property, then create an opening to start collecting leads and seller-ready feedback."
        override val openHouseButton: String = "Opening erstellen"
        override val photosTitle: String = "Photos"
        override val photosBody: String = "The first photo is used as the main property image across Portfolio."
        override val uploadPhoto: String = "Foto hochladen"
        override val noPhotosYet: String = "Noch keine Fotos hochgeladen."
        override val mainPhoto: String = "Hauptfoto"
        override val propertyTitleLabel: String = "Name der Immobilie"
        override val propertyAddressLine1Label: String = "Straße und Hausnummer"
        override val propertyAddressLine2Label: String = "Adresszusatz"
        override val propertyCityLabel: String = "Stadt"
        override val propertyRegionLabel: String = "Region"
        override val propertyPostalCodeLabel: String = "Postleitzahl"
        override val propertyCountryLabel: String = "Land"
        override val propertyAskingPriceLabel: String = "Angebotspreis"
        override val propertyBedsLabel: String = "Zimmer"
        override val propertyBathsLabel: String = "Bäder"
        override val propertyInteriorLabel: String = "Innenfläche"
        override val propertyDescriptionLabel: String = "Beschreibung"
        override val createPropertyButton: String = "+ Immobilie erstellen"
        override val locateProperty: String = "Immobilie lokalisieren"
        override val findLocation: String = "Standort suchen"
        override val find: String = "Suchen"
        override val navigate: String = "Navigieren"
        override val propertyLocationMarkerTitle: String = "Standort der Immobilie"
        override val mapKitJsMissingToken: String = "Fügen Sie HAVN_MAPKIT_JS_TOKEN zu local.properties hinzu, um die Webkarte zu verwenden."
        override val mapKitJsLoading: String = "MapKit JS wird geladen..."
        override val generateSellerReport: String = "Verkäuferbericht erstellen"
        override val deleteProperty: String = "Immobilie löschen"
        override val conversionMetric: String = "Konversion"
        override val propertyPhotoContentDescription: String = "Foto der Immobilie"
        override val deletePhoto: String = "Foto löschen"
        override val movePhotoLeft: String = "Foto nach links verschieben"
        override val movePhotoRight: String = "Foto nach rechts verschieben"
        override val propertyTitleRequired: String = "Der Name der Immobilie ist erforderlich."
        override val propertyStreetRequired: String = "Straße und Hausnummer sind erforderlich."
        override val propertyCityRequired: String = "Die Stadt ist erforderlich."
        override val propertyRegionRequired: String = "Die Region ist erforderlich."
        override val propertyPostalRequired: String = "Die Postleitzahl ist erforderlich."
        override val propertyAskingPriceInvalid: String = "Geben Sie einen gültigen Angebotspreis ein."
        override val propertyOwnerContactTitle: String = "Kontakt des Eigentümers"
        override val propertyOwnerSelectContact: String = "Wählen Sie einen bestehenden Kontakt als Eigentümer der Immobilie aus."
        override val propertyOwnerSelected: String = "Ausgewählter Eigentümer"
        override val propertyOwnerNoContacts: String = "Noch keine Kontakte. Fügen Sie den Eigentümer unter Kontakte hinzu und wählen Sie ihn dann hier aus."
        override val propertyOwnerChooseContact: String = "Kontakt wählen"
        override val propertyOwnerChangeContact: String = "Kontakt ändern"
        override val propertyOwnerRemoveContact: String = "Entfernen"
        override val propertyOwnerPickerTitle: String = "Eigentümer der Immobilie wählen"
        override val propertyOwnerSearchContact: String = "Kontakte suchen"
        override val propertyOwnerSearchHint: String = "Beginnen Sie mit Name, E-Mail oder Telefonnummer."
        override val propertyOwnerNoMatches: String = "Keine passenden Kontakte."
        override val propertyOpeningsTitle: String = "Openings"
        override val propertyNoOpenings: String = "No openings scheduled for this property."
        override val teamAccessTitle: String = "Team access"
        override val onlyListingOwner: String = "Only the listing owner"
        override val assignTeam: String = "Assign team"
        override val assignPropertyTitle: String = "Assign property"
        override val assignPropertyBody: String = "Choose who can work this property. Select the whole team or specific agents."
        override val wholeTeam: String = "Whole team"
        override val leadsEyebrow: String = "Leads"
        override val leadFallback: String = "Lead"
        override val leadsSubtitle: String = "Search, filter, and qualify leads captured across every opening."
        override val leadDetailSubtitle: String = "Source, qualification, notes, and follow-up history for this opening lead."
        override val totalMetric: String = "Total"
        override val loggedMetric: String = "logged"
        override val searchLeads: String = "Search leads"
        override val searchLeadsPlaceholder: String = "Name, phone, or email"
        override val allProperties: String = "All properties"
        override val loadingLeads: String = "Loading opening leads"
        override val noLeadsFoundTitle: String = "Leads erscheinen hier, wenn Kontakte bei einem Opening einchecken."
        override val noLeadsEmptyBody: String = "Nutzen Sie den Kiosk-Check-in oder fügen Sie Kontakte manuell aus einem Opening hinzu."
        override val noLeadsFilteredBody: String = "Try a different property, status, or search term."
        override val backToLeads: String = "Back to leads"
        override val leadUnavailableTitle: String = "Lead unavailable"
        override val leadUnavailableBody: String = "This lead is no longer available in the current lead list."
        override val leadTemperature: String = "Lead status"
        override val leadLabelSuffix: String = "Lead"
        override val greetingHi: String = "Hallo"
        override val leadActionCall: String = "Anrufen"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "E-Mail"
        override val leadFollowUp: String = "Follow-up"
        override val leadNoFollowUpScheduled: String = "Kein Follow-up geplant"
        override val leadIntentScore: String = "Interesse-Score"
        override val leadInterestedIn: String = "Interessiert an"
        override val leadGenericGreetingName: String = "zusammen"
        override val followUpMessageTypeThankYou: String = "Danke"
        override val followUpMessageTypePropertyInfo: String = "Immobilieninfo"
        override val followUpMessageTypeFollowUp: String = "Follow-up"
        override val followUpMessageTypeCheckIn: String = "Nachfragen"
        override val followUpMessageTypePriceUpdate: String = "Preisupdate"
        override val followUpMessageTypePropertyBrochure: String = "Fotos"
        override val followUpPreview: String = "Vorschau"
        override val followUpSubject: String = "Betreff"
        override val followUpMessage: String = "Nachricht"
        override val followUpSendViaEmail: String = "Per E-Mail senden"
        override val followUpSendViaSms: String = "Per SMS senden"
        override val followUpAiAssistantTitle: String = "AI-Assistent"
        override val followUpAiAssistantBody: String = "Erstellen Sie in Sekunden eine persönliche Nachricht."
        override val followUpGenerateWithAi: String = "Mit AI erstellen"
        override val followUpUpgradeForAi: String = "AI freischalten"
        override val followUpDefaultSubject: String = "Follow-up zu"
        override val privateAgentNotes: String = "Private agent notes"
        override val notes: String = "Notes"
        override val notesPlaceholder: String = "Motivation, preferences, objections, next move"
        override val saveNotes: String = "Save notes"
        override val followUpHistory: String = "Follow-up history"
        override val noFollowUpsLogged: String = "No follow-ups logged yet."
        override val openHousesEyebrow: String = "Showings"
        override val scheduleOpenHouse: String = "Besichtigung erstellen"
        override val openingDetails: String = "Opening-Details"
        override val editOpening: String = "Opening bearbeiten"
        override val deleteOpening: String = "Opening löschen"
        override val deleteOpeningBody: String = "Möchten Sie dieses Opening wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden."
        override val openingName: String = "Name des Openings"
        override val startsAt: String = "Beginnt um"
        override val endsAt: String = "Endet um"
        override val chooseStartDateTime: String = "Startdatum und Uhrzeit wählen"
        override val chooseEndDateTime: String = "Enddatum und Uhrzeit wählen"
        override val accessNotes: String = "Zugangshinweise"
        override val privateNotes: String = "Private Notizen"
        override val addPrivateNote: String = "Private Notiz hinzufügen"
        override val liveDashboard: String = "Live dashboard"
        override val visitorKiosk: String = "Lead kiosk"
        override val openHousesSubtitle: String = "Create openings for properties, review leads, and launch kiosk sessions."
        override val liveMetric: String = "Live"
        override val upcomingMetric: String = "Upcoming"
        override val inProgressMetric: String = "in progress"
        override val scheduledMetric: String = "scheduled"
        override val loadingOpenHouses: String = "Loading openings"
        override val addPropertyFirstTitle: String = "Add a property first"
        override val addPropertyFirstBody: String = "Create an opening from a property to start collecting leads."
        override val noOpenHousesTitle: String = "No openings scheduled"
        override val noOpenHousesBody: String = "Create an opening from a property to start collecting leads."
        override val noSignInsTitle: String = "No sign-ins yet"
        override val noSignInsBody: String = "Leads checked in through kiosk mode will appear here in real time."
        override val dashboard: String = "Dashboard"
        override val start: String = "Start"
        override val end: String = "End"
        override val endOpenHouse: String = "End opening"
        override val reportsEyebrow: String = "Owners"
        override val sellerReportsTitle: String = "Seller reports"
        override val createReport: String = "Create report"
        override val reportPreview: String = "Property Report"
        override val reportsSubtitle: String = "Generate premium post-opening recaps with lead quality, buyer intent, and seller-ready narrative."
        override val reportsMetricSaved: String = "saved"
        override val reportedMetric: String = "reported"
        override val leadsMetric: String = "leads"
        override val createSellerReport: String = "Create seller report"
        override val attendance: String = "Attendance"
        override val savedReports: String = "saved reports"
        override val buyerHeat: String = "Buyer heat"
        override val hotLeads: String = "hot leads"
        override val loadingSellerReports: String = "Loading seller reports"
        override val noSellerReportsTitle: String = "No seller reports yet"
        override val noSellerReportsBody: String = "Choose an opening, add agent notes, preview an export-ready recap, then save it."
        override val chooseOpenHouse: String = "Choose opening"
        override val noOpenHousesAvailable: String = "No openings available yet."
        override val agentNotes: String = "Agent notes"
        override val notesForSeller: String = "Notes for seller"
        override val sellerNotesPlaceholder: String = "Buyer objections, pricing signals, showing feedback, recommended next move"
        override val generatePreview: String = "Generate preview"
        override val noPreviewReadyTitle: String = "No preview ready"
        override val noPreviewReadyBody: String = "Generate a seller report preview before saving."
        override val saveReport: String = "Save report"
        override val reportSaved: String = "Report saved"
        override val sellerOpenHouseReport: String = "Seller opening report"
        override val mostCommonBuyerInterest: String = "Most common buyer interest"
        override val followUpsSent: String = "Follow-ups sent"
        override val summary: String = "Summary"
        override val noPrivateNotesAdded: String = "No private notes added."
        override val openHouseReport: String = "Opening report"
        override val searchProperties: String = "Immobilien suchen"
        override val searchOpenings: String = "Besichtigungen suchen"
        override val noOpeningsFoundTitle: String = "No openings found"
        override val noOpeningsFoundBody: String = "Try another search or opening status filter."
        override val noMatchingPropertiesTitle: String = "No matching properties"
        override val noMatchingPropertiesBody: String = "Try another search or status filter."
        override val clientsTitle: String = "Kontakte"
        override val clientFallback: String = "Kontakt"
        override val addClient: String = "Kontakt hinzufügen"
        override val editClient: String = "Kontakt bearbeiten"
        override val newClient: String = "Neuer Kontakt"
        override val saveClient: String = "Kontakt speichern"
        override val createClient: String = "Kontakt erstellen"
        override val deleteClientTitle: String = "Delete contact?"
        override val deleteClientBody: String = "This will permanently delete the contact. This cannot be undone."
        override val firstName: String = "Vorname"
        override val lastName: String = "Nachname"
        override val email: String = "E-Mail"
        override val phone: String = "Telefon"
        override val comments: String = "Kommentare"
        override val addPhoto: String = "Add photo"
        override val sendQr: String = "Send QR"
        override val photo: String = "Photo"
        override val clientDetailSubtitle: String = "QR identity, contact details, comments, and openings connected through leads."
        override val clientFormEditSubtitle: String = "Update contact details, delivery info, and comments."
        override val clientFormNewSubtitle: String = "Register a buyer/contact and generate a reusable QR identity for openings."
        override val searchClients: String = "Kontakte suchen"
        override val noClientsYetTitle: String = "No contacts yet"
        override val noClientsYetBody: String = "Register contacts first, then send their QR code by email or SMS before an opening."
        override val noClientsFoundTitle: String = "No contacts found"
        override val noClientsFoundBody: String = "Try another name, phone, or email."
        override val clientUnavailableTitle: String = "Contact unavailable"
        override val clientUnavailableBody: String = "Refresh the contacts list and open this record again."
        override val noCommentsAdded: String = "No comments added."
        override val openingsTitle: String = "Besichtigungen"
        override val clientOpeningsEmpty: String = "No openings connected yet. Leads connect a contact to an opening."
        override val clientPassLabel: String = "Pass"
        override val clientNoEmail: String = "No email"
        override val visitorsBody: String = "Open kiosk mode, scan a contact QR, or add existing contacts as leads for this opening."
        override val openKiosk: String = "Kiosk öffnen"
        override val addQrClient: String = "QR-Kontakt hinzufügen"
        override val addManually: String = "Manuell hinzufügen"
        override val selectClients: String = "Kontakte auswählen"
        override val selectClientsBody: String = "Choose contacts from your list. Each selected contact becomes a lead for this opening."
        override val kioskCheckIn: String = "Kiosk check-in"
        override val kioskCheckInBody: String = "Use the rear camera to scan the contact's HAVN Wallet QR. When the code is recognized, HAVN creates the lead for this opening automatically."
        override val scanWithCamera: String = "Scan with rear camera"
        override val clientQrImage: String = "Contact QR image"
        override val clientQrImageBody: String = "Keep the contact's QR inside the gold square. HAVN collects each scan below."
        override val scanMultipleQrBody: String = "Scan one or more HAVN contact QR codes, then tap Add QR contact."
        override val scannedQrReady: String = "contact QR ready to add"
        override val createLeadFromQr: String = "Create lead from QR"
        override val noClientsFoundShort: String = "No contacts found."
        override val remove: String = "Entfernen"
    }

    private val french: HavnStrings = object : HavnStrings {
        override val navToday: String = "Aujourd'hui"
        override val navProperties: String = "Biens"
        override val navLeads: String = "Prospects"
        override val navReports: String = "Rapports"
        override val navSettings: String = "Reglages"
        override val navAuth: String = "Acces agent"
        override val navOpenHouses: String = "Visites"
        override val navTours: String = "Visites"
        override val navFollowUps: String = "Contacts"
        override val navFollow: String = "Contacts"
        override val back: String = "Retour"
        override val settingsEyebrow: String = "Espace de travail"
        override val settingsTitle: String = "Reglages"
        override val settingsSubtitle: String = "Profil, langue, unites, environnement et options d'equipe."
        override val agentProfileTitle: String = "Profil agent"
        override val agentPhoto: String = "Photo de l’agent"
        override val uploading: String = "Importation..."
        override val saving: String = "Enregistrement..."
        override val validAgentPhotoRequired: String = "Choisissez une photo d’agent valide."
        override val signOut: String = "Se déconnecter"
        override val signOutQuestion: String = "Se déconnecter ?"
        override val signOutConfirmation: String = "Voulez-vous vraiment vous déconnecter de HAVN ?"
        override val upgrade: String = "Mettre à niveau"
        override val premiumThemesTitle: String = "Thèmes premium"
        override val premiumThemesUpgradePrompt: String = "Passez à Pro pour débloquer les thèmes premium."
        override val appearanceTitle: String = "Apparence"
        override val appearanceBody: String = "Choisissez un thème HAVN sélectionné. Les thèmes premium sont inclus avec Pro."
        override val previewComponents: String = "Aperçu des composants"
        override val themeShowcaseTitle: String = "Aperçu du thème"
        override val showcaseButtons: String = "Boutons"
        override val showcasePrimaryAction: String = "Action principale"
        override val showcaseSecondaryAction: String = "Action secondaire"
        override val showcaseGhostAction: String = "Action discrète"
        override val showcaseTextField: String = "Champ texte"
        override val showcaseFocusedBorder: String = "Bordure d’accent active"
        override val showcaseSearchPreview: String = "Aperçu de recherche"
        override val showcaseOpeningCheckedIn: String = "Inscription à une ouverture aujourd’hui"
        override val showcaseSentAt: String = "Envoyé à 10:30"
        override val themeObsidianGoldName: String = "Obsidian Gold"
        override val themeObsidianGoldDescription: String = "Noir luxueux, graphite et or chaud."
        override val themeMidnightSapphireName: String = "Midnight Sapphire"
        override val themeMidnightSapphireDescription: String = "Bleu nuit, saphir et accents argentés."
        override val themeEmeraldEstateName: String = "Emerald Estate"
        override val themeEmeraldEstateDescription: String = "Émeraude foncé, charbon et or champagne."
        override val themePlatinumStoneName: String = "Platinum Stone"
        override val themePlatinumStoneDescription: String = "Gris pierre, platine et blanc doux."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Rouge vin foncé, graphite et accents cuivre."
        override val commonChange: String = "Changer"
        override val agentPlanTitle: String = "Plan agent"
        override val agentPlanBody: String = "Améliorez votre expérience et choisissez le plan adapté à votre façon de travailler."
        override val currentPlan: String = "Plan actuel"
        override val transferPlan: String = "Transférer le plan"
        override val restorePurchase: String = "Restaurer l’achat"
        override val agencySettingsProBody: String = "Solo agency est active par défaut. Pro permet de créer ou choisir une agence partagée."
        override val agencySettingsLockedBody: String = "Solo agency est active. Les changements d’agence sont disponibles avec Pro."
        override val soloAgency: String = "Solo agency"
        override val defaultPrivateAgencyWorkspace: String = "Agence privée par défaut"
        override val noAgenciesAvailableYet: String = "Aucune invitation ni agence détenue n’est encore disponible."
        override val oneOwnedAgencyHint: String = "Votre agence détenue apparaît ci-dessus. Un agent peut posséder une seule agence."
        override val createAgency: String = "Créer une agence"
        override val createYourAgency: String = "Créez votre agence"
        override val createAgencyBody: String = "Développez votre équipe, gérez les biens ensemble et faites grandir votre activité."
        override val agencyName: String = "Nom de l’agence"
        override val agencyEmail: String = "E-mail de l’agence"
        override val logoOptional: String = "Logo (facultatif)"
        override val upgradeExperienceTitle: String = "Améliorez votre expérience"
        override val upgradeExperienceSubtitle: String = "Choisissez le plan adapté à votre façon de travailler."
        override val soloAgentPlan: String = "Solo agent"
        override val proAgentPlan: String = "Pro agent"
        override val soloBenefitActiveProperties: String = "Jusqu’à 5 biens actifs"
        override val soloBenefitAiFollowUps: String = "Relances IA (basiques)"
        override val soloBenefitSellerReports: String = "Rapports vendeurs premium (basiques)"
        override val soloBenefitPersonalOnly: String = "Compte personnel uniquement"
        override val proBenefitUnlimitedProperties: String = "Biens illimités"
        override val proBenefitUnlimitedAi: String = "Relances IA (illimitées)"
        override val proBenefitAdvancedReports: String = "Rapports vendeurs avancés"
        override val proBenefitAgencyCreation: String = "Création et gestion d’agence"
        override val proBenefitInviteAgents: String = "Inviter des agents et collaborer"
        override val proBenefitSharedLeads: String = "Leads partagés et workflows d’équipe"
        override val proBenefitAgencyBranding: String = "Branding d’agence"
        override val proBenefitAdvancedAnalytics: String = "Analytique avancée"
        override val startFreeTrial7Day: String = "S’abonner maintenant"
        override val restorePurchases: String = "Restaurer les achats"
        override val comparePlans: String = "Comparer les plans"
        override val startFreeTrial: String = "Choisir un plan"
        override val noCommitmentCancelAnytime: String = "Sans engagement. Annulation à tout moment."
        override val monthly: String = "Monthly"
        override val yearly: String = "Yearly"
        override val yearlySave20: String = "Yearly - save 20%"
        override val yearlySavings20: String = "Yearly saves 20% compared to monthly."
        override val perYear: String = "/ year"
        override val loadingPlans: String = "Loading plans..."
        override val selectedPlanUnavailable: String = "This plan is not available yet. Check RevenueCat offerings and product identifiers."
        override val signInRequiredForPurchase: String = "Sign in before starting a purchase."
        override val compareActiveProperties: String = "Biens actifs"
        override val compareAiFollowUps: String = "Relances IA"
        override val compareSellerReports: String = "Rapports vendeurs"
        override val compareAdvancedAnalytics: String = "Analytique avancée"
        override val compareAgencyCreation: String = "Création d’agence"
        override val compareJoinAgencies: String = "Rejoindre des agences"
        override val compareInviteAgents: String = "Inviter des agents"
        override val compareSharedLeads: String = "Leads partagés"
        override val compareAgencyBranding: String = "Branding d’agence"
        override val comparePrioritySupport: String = "Support prioritaire"
        override val unlimited: String = "Illimité"
        override val basic: String = "Basique"
        override val advanced: String = "Avancé"
        override val perMonth: String = "/ mois"
        override val members: String = "membres"
        override val upgradeToProForAgencyTools: String = "Passez à Pro pour utiliser les outils d’agence"
        override val languageTitle: String = "Langue"
        override val languageBody: String = "Choisissez la langue de l'application pour cet appareil."
        override val english: String = "English"
        override val slovak: String = "Slovak"
        override val unitsTitle: String = "Unites et devise"
        override val unitsBody: String = "Choisissez l'affichage des prix et surfaces dans l'application."
        override val measurementSystemTitle: String = "Mesure"
        override val metric: String = "Metrique"
        override val imperial: String = "Imperial"
        override val currencyTitle: String = "Devise"
        override val notificationsTitle: String = "Notifications"
        override val notificationsBody: String = "Control push alerts, quiet hours, and the types of updates HAVN can send."
        override val notificationSettings: String = "Notification settings"
        override val notificationsSubtitle: String = "Only important updates, filtered by your preferences."
        override val quietHoursTitle: String = "Quiet hours"
        override val quietHoursBody: String = "HAVN skips non-critical pushes during quiet hours. Billing and account issues still stay concise."
        override val enableQuietHours: String = "Enable quiet hours"
        override val quietHoursStart: String = "Start"
        override val quietHoursEnd: String = "End"
        override val timezoneLabel: String = "Timezone"
        override val notificationTypesTitle: String = "Notification types"
        override val notificationNewLeadCapturedTitle: String = "New lead captured"
        override val notificationNewLeadCapturedBody: String = "When an opening or QR flow captures a lead."
        override val notificationHotLeadTitle: String = "Lead marked as hot"
        override val notificationHotLeadBody: String = "Only when a lead becomes high intent."
        override val notificationOpeningStartsSoonTitle: String = "Opening starts soon"
        override val notificationOpeningStartsSoonBody: String = "A single reminder 30 minutes before start."
        override val notificationOpeningSummaryReadyTitle: String = "Opening summary ready"
        override val notificationOpeningSummaryReadyBody: String = "When the post-event summary is ready."
        override val notificationSellerReportGeneratedTitle: String = "Seller report generated"
        override val notificationSellerReportGeneratedBody: String = "When a seller report has been created."
        override val notificationAiFollowUpReadyTitle: String = "AI follow-up ready"
        override val notificationAiFollowUpReadyBody: String = "When a follow-up draft is ready to review."
        override val notificationAgentInvitedTitle: String = "Agent invited to agency"
        override val notificationAgentInvitedBody: String = "Agency invitations and membership changes."
        override val notificationLeadAssignedTitle: String = "Lead assigned to you"
        override val notificationLeadAssignedBody: String = "When a teammate assigns a lead to you."
        override val notificationLeadTransferredTitle: String = "Lead transferred to you"
        override val notificationLeadTransferredBody: String = "When ownership of a lead moves to you."
        override val notificationSubscriptionIssueTitle: String = "Subscription issue"
        override val notificationSubscriptionIssueBody: String = "Renewal failures and billing problems."
        override val kioskSecurityTitle: String = "Kiosk security"
        override val kioskSecurityBody: String = "Use this PIN to leave kiosk mode and return to the agent app."
        override val kioskPinLabel: String = "Kiosk PIN"
        override val kioskFeaturedProperty: String = "Featured property"
        override val kioskPrivateShowing: String = "Private showing"
        override val kioskLuxuryListing: String = "Luxury listing"
        override val kioskFastCheckIn: String = "Fast check-in"
        override val kioskExitContentDescription: String = "Exit kiosk"
        override val kioskWelcome: String = "Welcome"
        override val kioskGladHere: String = "We’re glad you’re here."
        override val kioskScanToCheckIn: String = "Scan to check in"
        override val kioskReceivePropertyDetails: String = "and receive property details"
        override val kioskOr: String = "Or"
        override val kioskStartCheckInManually: String = "Start check-in manually"
        override val kioskSecureInfo: String = "Your information is secure and will never be shared."
        override val kioskExitTitle: String = "Exit kiosk"
        override val kioskExitBody: String = "Enter the kiosk PIN to return to the agent app."
        override val kioskIncorrectPin: String = "Incorrect PIN."
        override val kioskUnlock: String = "Unlock"
        override val kioskTellUsTitle: String = "Tell us about yourself"
        override val kioskTellUsBody: String = "Your information goes only to the hosting agent."
        override val kioskFullName: String = "Full name"
        override val kioskContinue: String = "Continue"
        override val kioskQuestionsTitle: String = "A couple quick questions"
        override val kioskQuestionsBody: String = "This helps the agent follow up with the right context."
        override val kioskWorkingWithAgentQuestion: String = "Are you working with an agent?"
        override val kioskYes: String = "Yes"
        override val kioskNo: String = "No"
        override val kioskInterestQuestion: String = "What are you interested in?"
        override val kioskInterestBuying: String = "Buying"
        override val kioskInterestInvesting: String = "Investing"
        override val kioskInterestBrowsing: String = "Just browsing"
        override val kioskInterestRelocating: String = "Relocating"
        override val kioskFinish: String = "Finish"
        override val kioskThankYou: String = "Thank you"
        override val kioskEnjoyVisitPrefix: String = "Enjoy your visit at"
        override val kioskResetAutomatically: String = "This kiosk will reset automatically."
        override val environmentTitle: String = "Environment"
        override val environmentBody: String = "Local Supabase is configured for development. Production values should move behind build-time configuration."
        override val secure: String = "Secure"
        override val brokerageProfileTitle: String = "Brokerage profile"
        override val brokerageProfileBody: String = "Team branding, agent invites, and notification preferences will live here."
        override val logout: String = "Se deconnecter"
        override val languageChanged: String = "Language changed"
        override val commonAdd: String = "Ajouter"
        override val commonEdit: String = "Modifier"
        override val commonDelete: String = "Supprimer"
        override val commonCancel: String = "Annuler"
        override val commonSave: String = "Enregistrer"
        override val commonCreate: String = "Creer"
        override val commonDismiss: String = "Dismiss"
        override val commonAll: String = "Tout"
        override val commonDone: String = "Terminé"
        override val commonTime: String = "Heure"
        override val commonHour: String = "Heure"
        override val commonMinute: String = "Minute"
        override val commonAgency: String = "Agence"
        override val commonSettings: String = "Réglages"
        override val commonOpening: String = "Ouverture"
        override val commonPropertyName: String = "Bien"
        override val commonToday: String = "Aujourd’hui"
        override val agencyToolsAvailable: String = "Les outils d’agence sont disponibles."
        override val agencySetupSubtitle: String = "Chaque compte HAVN dispose d’une agence par défaut. Pro permet de gérer les invitations, les leads partagés et la marque."
        override val agencyRecentActivity: String = "Recent activity"
        override val agencyActivityNewLead: String = "New lead added"
        override val agencyActivityInvitationAccepted: String = "Agent invitation accepted"
        override val agencyActivityAgentJoined: String = "Agent joined the agency"
        override val agencyActivitySellerReport: String = "Seller report created"
        override val agencyWorkspaceTitle: String = "Agency workspace"
        override val agencyWorkspaceBody: String = "Choose which agency you are working with."
        override val agencySoloActiveTitle: String = "Solo agency is active"
        override val agencyProRequiredTitle: String = "Pro plan required"
        override val agencyCreateOrAcceptInviteBody: String = "Create your agency workspace or accept an invite to collaborate with another agency."
        override val agencyProUnlockBody: String = "Agency changes, invites, shared leads, and shared branding unlock with Pro."
        override val realEstate: String = "Real estate"
        override val proAgency: String = "Pro agency"
        override val agencyBrandingTitle: String = "Agency branding"
        override val agencyBrandingBody: String = "Set the agency name and logo shown in the app, kiosk, and shared workspace."
        override val uploadLogo: String = "Upload logo"
        override val saveAgency: String = "Save agency"
        override val yourAgencyRole: String = "Your agency role"
        override val agencyAgentsTitle: String = "Agency agents"
        override val agencyAgentsBody: String = "People eligible to work with this agency."
        override val inviteAgent: String = "Invite agent"
        override val loadingAgents: String = "Loading agents..."
        override val noAgencyAgentsYet: String = "No agency agents yet."
        override val changeRole: String = "Change role"
        override val updating: String = "Updating..."
        override val deleting: String = "Deleting..."
        override val deleteInvite: String = "Delete invite"
        override val chooseAgencyRoleFor: String = "Choose the agency role for"
        override val removeAccess: String = "Remove access"
        override val inviteAgentBody: String = "Send an agency invitation by email. The agent accepts after signing in with the same email."
        override val agentEmail: String = "Agent email"
        override val role: String = "Role"
        override val inviting: String = "Inviting..."
        override val invite: String = "Invite"
        override val agents: String = "Agents"
        override val ok: String = "Ok"
        override val personalActivePropertyLimit: String = "Personal active property limit"
        override val personalAccountAgencyToolsLocked: String = "Personal account is active. Agency tools unlock with Pro."
        override val selected: String = "Selected"
        override val activeMembers: String = "active members"
        override val agencySharedWorkspaceBody: String = "Shared properties, contacts, openings, leads, follow-ups, and reports use this agency workspace."
        override val agencyRoleOwner: String = "Owner"
        override val agencyRoleAdmin: String = "Admin"
        override val agencyRoleAgent: String = "Agent"
        override val agencyRoleAssistant: String = "Assistant"
        override val agencyRoleViewer: String = "Viewer"
        override val agencyRoleOwnerDescription: String = "Full agency control, including members, branding, assignments, listings, leads, and reports."
        override val agencyRoleAdminDescription: String = "Full agency management except deleting the agency."
        override val agencyRoleAgentDescription: String = "Works assigned listings, openings, leads, follow-ups, notes, and seller reports."
        override val agencyRoleAssistantDescription: String = "Supports assigned listings by editing leads, preparing follow-ups, and drafting reports."
        override val agencyRoleViewerDescription: String = "Read-only access to dashboards and reports."
        override val agencyCapabilityInviteRemoveMembers: String = "Invite and remove members"
        override val agencyCapabilityChangeRoles: String = "Change member roles"
        override val agencyCapabilityManageAllProperties: String = "Create, edit, and delete all properties"
        override val agencyCapabilityAssignAgents: String = "Assign agents"
        override val agencyCapabilitySeeAllLeads: String = "See all leads"
        override val agencyCapabilityExportReports: String = "Export reports"
        override val agencyCapabilityChangeBranding: String = "Change agency branding and settings"
        override val agencyCapabilityDeleteAgency: String = "Delete agency"
        override val agencyCapabilityViewAssignedProperties: String = "View assigned properties"
        override val agencyCapabilityHostAssignedOpenings: String = "Host assigned openings"
        override val agencyCapabilitySeeAssignedLeads: String = "See leads from assigned properties and openings"
        override val agencyCapabilityAddNotes: String = "Add notes"
        override val agencyCapabilitySendFollowUps: String = "Send follow-ups"
        override val agencyCapabilityCreateSellerReports: String = "Create seller reports for assigned listings"
        override val agencyCapabilityEditAssignedLeads: String = "Edit assigned leads"
        override val agencyCapabilityPrepareFollowUps: String = "Prepare follow-ups"
        override val agencyCapabilityCreateDraftReports: String = "Create draft reports"
        override val agencyCapabilityCannotDeleteProperties: String = "Cannot delete properties"
        override val agencyCapabilityCannotInviteAgents: String = "Cannot invite agents unless allowed"
        override val agencyCapabilityViewDashboards: String = "View dashboards"
        override val agencyCapabilityViewReports: String = "View reports"
        override val agencyCapabilityCannotEdit: String = "Cannot edit anything"
        override val commonVisitors: String = "Leads"
        override val commonHot: String = "Hot"
        override val commonWarm: String = "Warm"
        override val commonCold: String = "Cold"
        override val commonActive: String = "Actif"
        override val commonPlanned: String = "Planifie"
        override val commonArchived: String = "Archive"
        override val commonPast: String = "Passées"
        override val commonFollowUps: String = "Follow-ups"
        override val commonProperty: String = "Bien"
        override val commonAddress: String = "Adresse"
        override val commonOpenHouse: String = "Opening"
        override val commonCheckedIn: String = "Checked in"
        override val commonNotScheduled: String = "not scheduled"
        override val todayTitle: String = "Today"
        override val todaySubtitle: String = "Your daily workspace for openings, leads, follow-ups, and seller-ready momentum."
        override val todayOpenHousesMetric: String = "openings"
        override val capturedMetric: String = "captured"
        override val priorityMetric: String = "priority"
        override val noActivePropertiesTitle: String = "No active properties"
        override val noActivePropertiesBody: String = "Add or activate a property to make it appear on Today."
        override val checkIns: String = "Check-ins"
        override val allOpenHouses: String = "all openings"
        override val pendingDrafts: String = "pending drafts"
        override val priorityLead: String = "Priority lead"
        override val nextOpenHouseAt: String = "Next opening at"
        override val noOpenHouseScheduled: String = "No opening scheduled"
        override val personalAccount: String = "Compte personnel"
        override val accountReady: String = "Votre compte est prêt"
        override val realEstateApp: String = "Application immobilière"
        override val needHelp: String = "Besoin d’aide ?"
        override val contactSupport: String = "Contacter le support"
        override val upgradePlan: String = "Changer de formule"
        override val planSuffix: String = "Formule"
        override val todayActionsTitle: String = "Priorités du jour"
        override val whatOpeningNext: String = "Quelle ouverture est la prochaine ?"
        override val whoCheckedIn: String = "Qui s’est enregistré ?"
        override val whoNeedsFollowUp: String = "Qui attend un suivi ?"
        override val whatShouldIDoNow: String = "Que faire maintenant ?"
        override val noCheckInsYet: String = "Aucun contact ne s’est encore enregistré."
        override val noPendingFollowUps: String = "Aucun suivi en attente pour le moment."
        override val openKioskForNextOpening: String = "Ouvrez le kiosque pour la prochaine ouverture."
        override val reviewNewLeads: String = "Consultez les nouveaux leads et envoyez les suivis."
        override val createOpeningToStart: String = "Créez une ouverture depuis un bien pour commencer à collecter des leads."
        override val addFirstPropertyToStart: String = "Ajoutez votre premier bien pour commencer."
        override val nextOpening: String = "Prochaine ouverture"
        override val quickSignIn: String = "Enregistrement rapide"
        override val scanQrCode: String = "Scanner le QR code"
        override val newLead: String = "Nouveau lead"
        override val myProperties: String = "Mes biens"
        override val manageListings: String = "Gérer les annonces"
        override val todaysOverview: String = "Aperçu du jour"
        override val seeAll: String = "Voir tout"
        override val propertiesEyebrow: String = "Portfólio"
        override val propertiesSubtitle: String = "Manage active, planned, and archived listings with Supabase-backed media and performance intelligence."
        override val propertiesLiveMetric: String = "live"
        override val propertiesPipelineMetric: String = "pipeline"
        override val propertiesAllTimeMetric: String = "all time"
        override val addProperty: String = "Ajouter un bien"
        override val editProperty: String = "Modifier le bien"
        override val propertyFallback: String = "Property"
        override val propertyUnavailableTitle: String = "Bien indisponible"
        override val propertyUnavailableBody: String = "Refresh the portfolio to reload this listing."
        override val backToProperties: String = "Retour aux biens"
        override val deletePropertyTitle: String = "Supprimer le bien ?"
        override val deletePropertyBody: String = "This will permanently delete the property and its related local records. This cannot be undone."
        override val loadingProperties: String = "Chargement des biens"
        override val noPropertiesTitle: String = "Aucun bien pour le moment"
        override val noPropertiesBody: String = "Add your first property, then create an opening to start collecting leads and seller-ready feedback."
        override val openHouseButton: String = "Créer une ouverture"
        override val photosTitle: String = "Photos"
        override val photosBody: String = "The first photo is used as the main property image across Portfolio."
        override val uploadPhoto: String = "Importer une photo"
        override val noPhotosYet: String = "Aucune photo importée pour le moment."
        override val mainPhoto: String = "Principale"
        override val propertyTitleLabel: String = "Nom du bien"
        override val propertyAddressLine1Label: String = "Adresse"
        override val propertyAddressLine2Label: String = "Complément d’adresse"
        override val propertyCityLabel: String = "Ville"
        override val propertyRegionLabel: String = "Région"
        override val propertyPostalCodeLabel: String = "Code postal"
        override val propertyCountryLabel: String = "Pays"
        override val propertyAskingPriceLabel: String = "Prix demandé"
        override val propertyBedsLabel: String = "Chambres"
        override val propertyBathsLabel: String = "Salles de bain"
        override val propertyInteriorLabel: String = "Surface intérieure"
        override val propertyDescriptionLabel: String = "Description"
        override val createPropertyButton: String = "+ Créer un bien"
        override val locateProperty: String = "Localiser le bien"
        override val findLocation: String = "Trouver un emplacement"
        override val find: String = "Trouver"
        override val navigate: String = "Naviguer"
        override val propertyLocationMarkerTitle: String = "Emplacement du bien"
        override val mapKitJsMissingToken: String = "Ajoutez HAVN_MAPKIT_JS_TOKEN à local.properties pour la carte web."
        override val mapKitJsLoading: String = "Chargement de MapKit JS..."
        override val generateSellerReport: String = "Générer le rapport vendeur"
        override val deleteProperty: String = "Supprimer le bien"
        override val conversionMetric: String = "Conversion"
        override val propertyPhotoContentDescription: String = "Photo du bien"
        override val deletePhoto: String = "Supprimer la photo"
        override val movePhotoLeft: String = "Déplacer la photo à gauche"
        override val movePhotoRight: String = "Déplacer la photo à droite"
        override val propertyTitleRequired: String = "Le nom du bien est obligatoire."
        override val propertyStreetRequired: String = "L’adresse est obligatoire."
        override val propertyCityRequired: String = "La ville est obligatoire."
        override val propertyRegionRequired: String = "La région est obligatoire."
        override val propertyPostalRequired: String = "Le code postal est obligatoire."
        override val propertyAskingPriceInvalid: String = "Saisissez un prix demandé valide."
        override val propertyOwnerContactTitle: String = "Contact du propriétaire"
        override val propertyOwnerSelectContact: String = "Sélectionnez un contact existant comme propriétaire du bien."
        override val propertyOwnerSelected: String = "Propriétaire sélectionné"
        override val propertyOwnerNoContacts: String = "Aucun contact pour le moment. Ajoutez le propriétaire dans Contacts, puis sélectionnez-le ici."
        override val propertyOwnerChooseContact: String = "Choisir un contact"
        override val propertyOwnerChangeContact: String = "Changer de contact"
        override val propertyOwnerRemoveContact: String = "Retirer"
        override val propertyOwnerPickerTitle: String = "Choisir le propriétaire du bien"
        override val propertyOwnerSearchContact: String = "Rechercher des contacts"
        override val propertyOwnerSearchHint: String = "Commencez à saisir un nom, un e-mail ou un téléphone."
        override val propertyOwnerNoMatches: String = "Aucun contact correspondant."
        override val propertyOpeningsTitle: String = "Openings"
        override val propertyNoOpenings: String = "No openings scheduled for this property."
        override val teamAccessTitle: String = "Team access"
        override val onlyListingOwner: String = "Only the listing owner"
        override val assignTeam: String = "Assign team"
        override val assignPropertyTitle: String = "Assign property"
        override val assignPropertyBody: String = "Choose who can work this property. Select the whole team or specific agents."
        override val wholeTeam: String = "Whole team"
        override val leadsEyebrow: String = "Leads"
        override val leadFallback: String = "Lead"
        override val leadsSubtitle: String = "Search, filter, and qualify leads captured across every opening."
        override val leadDetailSubtitle: String = "Source, qualification, notes, and follow-up history for this opening lead."
        override val totalMetric: String = "Total"
        override val loggedMetric: String = "logged"
        override val searchLeads: String = "Search leads"
        override val searchLeadsPlaceholder: String = "Name, phone, or email"
        override val allProperties: String = "All properties"
        override val loadingLeads: String = "Loading opening leads"
        override val noLeadsFoundTitle: String = "Les leads apparaîtront ici lorsque des contacts s’enregistreront à une ouverture."
        override val noLeadsEmptyBody: String = "Utilisez le kiosque d’enregistrement ou ajoutez des contacts manuellement depuis une ouverture."
        override val noLeadsFilteredBody: String = "Try a different property, status, or search term."
        override val backToLeads: String = "Back to leads"
        override val leadUnavailableTitle: String = "Lead unavailable"
        override val leadUnavailableBody: String = "This lead is no longer available in the current lead list."
        override val leadTemperature: String = "Lead status"
        override val leadLabelSuffix: String = "Lead"
        override val greetingHi: String = "Bonjour"
        override val leadActionCall: String = "Appeler"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "E-mail"
        override val leadFollowUp: String = "Relance"
        override val leadNoFollowUpScheduled: String = "Aucune relance prévue"
        override val leadIntentScore: String = "Score d'intérêt"
        override val leadInterestedIn: String = "Intéressé par"
        override val leadGenericGreetingName: String = "bonjour"
        override val followUpMessageTypeThankYou: String = "Merci"
        override val followUpMessageTypePropertyInfo: String = "Info bien"
        override val followUpMessageTypeFollowUp: String = "Relance"
        override val followUpMessageTypeCheckIn: String = "Prendre des nouvelles"
        override val followUpMessageTypePriceUpdate: String = "Mise à jour du prix"
        override val followUpMessageTypePropertyBrochure: String = "Photos"
        override val followUpPreview: String = "Aperçu"
        override val followUpSubject: String = "Objet"
        override val followUpMessage: String = "Message"
        override val followUpSendViaEmail: String = "Envoyer par e-mail"
        override val followUpSendViaSms: String = "Envoyer par SMS"
        override val followUpAiAssistantTitle: String = "Assistant IA"
        override val followUpAiAssistantBody: String = "Générez un message personnalisé en quelques secondes."
        override val followUpGenerateWithAi: String = "Générer avec l'IA"
        override val followUpUpgradeForAi: String = "Débloquer l'IA"
        override val followUpDefaultSubject: String = "Relance au sujet de"
        override val privateAgentNotes: String = "Private agent notes"
        override val notes: String = "Notes"
        override val notesPlaceholder: String = "Motivation, preferences, objections, next move"
        override val saveNotes: String = "Save notes"
        override val followUpHistory: String = "Follow-up history"
        override val noFollowUpsLogged: String = "No follow-ups logged yet."
        override val openHousesEyebrow: String = "Showings"
        override val scheduleOpenHouse: String = "Créer une visite"
        override val openingDetails: String = "Détails de l’ouverture"
        override val editOpening: String = "Modifier l’ouverture"
        override val deleteOpening: String = "Supprimer l’ouverture"
        override val deleteOpeningBody: String = "Voulez-vous vraiment supprimer cette ouverture ? Cette action est irréversible."
        override val openingName: String = "Nom de l’ouverture"
        override val startsAt: String = "Début"
        override val endsAt: String = "Fin"
        override val chooseStartDateTime: String = "Choisir la date et l’heure de début"
        override val chooseEndDateTime: String = "Choisir la date et l’heure de fin"
        override val accessNotes: String = "Notes d’accès"
        override val privateNotes: String = "Notes privées"
        override val addPrivateNote: String = "Ajouter une note privée"
        override val liveDashboard: String = "Live dashboard"
        override val visitorKiosk: String = "Lead kiosk"
        override val openHousesSubtitle: String = "Create openings for properties, review leads, and launch kiosk sessions."
        override val liveMetric: String = "Live"
        override val upcomingMetric: String = "Upcoming"
        override val inProgressMetric: String = "in progress"
        override val scheduledMetric: String = "scheduled"
        override val loadingOpenHouses: String = "Loading openings"
        override val addPropertyFirstTitle: String = "Add a property first"
        override val addPropertyFirstBody: String = "Create an opening from a property to start collecting leads."
        override val noOpenHousesTitle: String = "No openings scheduled"
        override val noOpenHousesBody: String = "Create an opening from a property to start collecting leads."
        override val noSignInsTitle: String = "No sign-ins yet"
        override val noSignInsBody: String = "Leads checked in through kiosk mode will appear here in real time."
        override val dashboard: String = "Dashboard"
        override val start: String = "Start"
        override val end: String = "End"
        override val endOpenHouse: String = "End opening"
        override val reportsEyebrow: String = "Owners"
        override val sellerReportsTitle: String = "Seller reports"
        override val createReport: String = "Create report"
        override val reportPreview: String = "Property Report"
        override val reportsSubtitle: String = "Generate premium post-opening recaps with lead quality, buyer intent, and seller-ready narrative."
        override val reportsMetricSaved: String = "saved"
        override val reportedMetric: String = "reported"
        override val leadsMetric: String = "leads"
        override val createSellerReport: String = "Create seller report"
        override val attendance: String = "Attendance"
        override val savedReports: String = "saved reports"
        override val buyerHeat: String = "Buyer heat"
        override val hotLeads: String = "hot leads"
        override val loadingSellerReports: String = "Loading seller reports"
        override val noSellerReportsTitle: String = "No seller reports yet"
        override val noSellerReportsBody: String = "Choose an opening, add agent notes, preview an export-ready recap, then save it."
        override val chooseOpenHouse: String = "Choose opening"
        override val noOpenHousesAvailable: String = "No openings available yet."
        override val agentNotes: String = "Agent notes"
        override val notesForSeller: String = "Notes for seller"
        override val sellerNotesPlaceholder: String = "Buyer objections, pricing signals, showing feedback, recommended next move"
        override val generatePreview: String = "Generate preview"
        override val noPreviewReadyTitle: String = "No preview ready"
        override val noPreviewReadyBody: String = "Generate a seller report preview before saving."
        override val saveReport: String = "Save report"
        override val reportSaved: String = "Report saved"
        override val sellerOpenHouseReport: String = "Seller opening report"
        override val mostCommonBuyerInterest: String = "Most common buyer interest"
        override val followUpsSent: String = "Follow-ups sent"
        override val summary: String = "Summary"
        override val noPrivateNotesAdded: String = "No private notes added."
        override val openHouseReport: String = "Opening report"
        override val searchProperties: String = "Rechercher des biens"
        override val searchOpenings: String = "Rechercher des visites"
        override val noOpeningsFoundTitle: String = "No openings found"
        override val noOpeningsFoundBody: String = "Try another search or opening status filter."
        override val noMatchingPropertiesTitle: String = "No matching properties"
        override val noMatchingPropertiesBody: String = "Try another search or status filter."
        override val clientsTitle: String = "Contacts"
        override val clientFallback: String = "Contact"
        override val addClient: String = "Ajouter un contact"
        override val editClient: String = "Modifier le contact"
        override val newClient: String = "Nouveau contact"
        override val saveClient: String = "Enregistrer le contact"
        override val createClient: String = "Créer le contact"
        override val deleteClientTitle: String = "Delete contact?"
        override val deleteClientBody: String = "This will permanently delete the contact. This cannot be undone."
        override val firstName: String = "Prénom"
        override val lastName: String = "Nom"
        override val email: String = "E-mail"
        override val phone: String = "Téléphone"
        override val comments: String = "Commentaires"
        override val addPhoto: String = "Add photo"
        override val sendQr: String = "Send QR"
        override val photo: String = "Photo"
        override val clientDetailSubtitle: String = "QR identity, contact details, comments, and openings connected through leads."
        override val clientFormEditSubtitle: String = "Update contact details, delivery info, and comments."
        override val clientFormNewSubtitle: String = "Register a buyer/contact and generate a reusable QR identity for openings."
        override val searchClients: String = "Rechercher des contacts"
        override val noClientsYetTitle: String = "No contacts yet"
        override val noClientsYetBody: String = "Register contacts first, then send their QR code by email or SMS before an opening."
        override val noClientsFoundTitle: String = "No contacts found"
        override val noClientsFoundBody: String = "Try another name, phone, or email."
        override val clientUnavailableTitle: String = "Contact unavailable"
        override val clientUnavailableBody: String = "Refresh the contacts list and open this record again."
        override val noCommentsAdded: String = "No comments added."
        override val openingsTitle: String = "Visites"
        override val clientOpeningsEmpty: String = "No openings connected yet. Leads connect a contact to an opening."
        override val clientPassLabel: String = "Pass"
        override val clientNoEmail: String = "No email"
        override val visitorsBody: String = "Open kiosk mode, scan a contact QR, or add existing contacts as leads for this opening."
        override val openKiosk: String = "Ouvrir le kiosque"
        override val addQrClient: String = "Ajouter contact QR"
        override val addManually: String = "Ajouter manuellement"
        override val selectClients: String = "Sélectionner des contacts"
        override val selectClientsBody: String = "Choose contacts from your list. Each selected contact becomes a lead for this opening."
        override val kioskCheckIn: String = "Kiosk check-in"
        override val kioskCheckInBody: String = "Use the rear camera to scan the contact's HAVN Wallet QR. When the code is recognized, HAVN creates the lead for this opening automatically."
        override val scanWithCamera: String = "Scan with rear camera"
        override val clientQrImage: String = "Contact QR image"
        override val clientQrImageBody: String = "Keep the contact's QR inside the gold square. HAVN collects each scan below."
        override val scanMultipleQrBody: String = "Scan one or more HAVN contact QR codes, then tap Add QR contact."
        override val scannedQrReady: String = "contact QR ready to add"
        override val createLeadFromQr: String = "Create lead from QR"
        override val noClientsFoundShort: String = "No contacts found."
        override val remove: String = "Retirer"
    }

    private val czech: HavnStrings = object : HavnStrings {
        override val navToday: String = "Dnes"
        override val navProperties: String = "Nemovitosti"
        override val navLeads: String = "Leady"
        override val navReports: String = "Reporty"
        override val navSettings: String = "Nastaveni"
        override val navAuth: String = "Pristup agenta"
        override val navOpenHouses: String = "Prohlidky"
        override val navTours: String = "Prohlidky"
        override val navFollowUps: String = "Kontakty"
        override val navFollow: String = "Kontakty"
        override val back: String = "Zpet"
        override val settingsEyebrow: String = "Pracovni prostor"
        override val settingsTitle: String = "Nastaveni"
        override val settingsSubtitle: String = "Profil, jazyk, jednotky, prostredi a tymove moznosti."
        override val agentProfileTitle: String = "Profil agenta"
        override val agentPhoto: String = "Fotka agenta"
        override val uploading: String = "Nahrávám..."
        override val saving: String = "Ukládám..."
        override val validAgentPhotoRequired: String = "Vyberte platnou fotku agenta."
        override val signOut: String = "Odhlásit se"
        override val signOutQuestion: String = "Odhlásit se?"
        override val signOutConfirmation: String = "Opravdu se chcete odhlásit z HAVN?"
        override val upgrade: String = "Vylepšit"
        override val premiumThemesTitle: String = "Prémiová témata"
        override val premiumThemesUpgradePrompt: String = "Vylepšete na Pro a odemkněte prémiová témata."
        override val appearanceTitle: String = "Vzhled"
        override val appearanceBody: String = "Vyberte kurátorované téma HAVN. Prémiová témata odemkne Pro."
        override val previewComponents: String = "Ukázka komponent"
        override val themeShowcaseTitle: String = "Ukázka tématu"
        override val showcaseButtons: String = "Tlačítka"
        override val showcasePrimaryAction: String = "Hlavní akce"
        override val showcaseSecondaryAction: String = "Vedlejší akce"
        override val showcaseGhostAction: String = "Nenápadná akce"
        override val showcaseTextField: String = "Textové pole"
        override val showcaseFocusedBorder: String = "Zvýrazněný okraj"
        override val showcaseSearchPreview: String = "Ukázka vyhledávání"
        override val showcaseOpeningCheckedIn: String = "Dnešní příchod na prohlídku"
        override val showcaseSentAt: String = "Odesláno v 10:30"
        override val themeObsidianGoldName: String = "Obsidian Gold"
        override val themeObsidianGoldDescription: String = "Luxusní černá, grafit a teplé zlato."
        override val themeMidnightSapphireName: String = "Midnight Sapphire"
        override val themeMidnightSapphireDescription: String = "Hluboká námořnická modrá, safír a stříbrné akcenty."
        override val themeEmeraldEstateName: String = "Emerald Estate"
        override val themeEmeraldEstateDescription: String = "Tmavý smaragd, antracit a šampaňské zlato."
        override val themePlatinumStoneName: String = "Platinum Stone"
        override val themePlatinumStoneDescription: String = "Kamenná šedá, platina a jemná bílá."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Tmavé víno, grafit a měděné akcenty."
        override val commonChange: String = "Změnit"
        override val agentPlanTitle: String = "Plán agenta"
        override val agentPlanBody: String = "Vylepšete si práci. Vyberte plán, který nejlépe sedí vašemu způsobu prodeje."
        override val currentPlan: String = "Aktuální plán"
        override val transferPlan: String = "Přenést plán"
        override val restorePurchase: String = "Obnovit nákup"
        override val agencySettingsProBody: String = "Solo agency je aktivní ve výchozím nastavení. Pro umožňuje vytvořit nebo vybrat sdílenou agenturu."
        override val agencySettingsLockedBody: String = "Solo agency je aktivní. Změny agentury odemkne Pro."
        override val soloAgency: String = "Solo agency"
        override val defaultPrivateAgencyWorkspace: String = "Výchozí soukromá agentura"
        override val noAgenciesAvailableYet: String = "Zatím nejsou dostupné žádné pozvánky ani vlastněné agentury."
        override val oneOwnedAgencyHint: String = "Vaše agentura je uvedena výše. Jeden agent může vlastnit jednu agenturu."
        override val createAgency: String = "Vytvořit agenturu"
        override val createYourAgency: String = "Vytvořte svou agenturu"
        override val createAgencyBody: String = "Budujte tým, spravujte nemovitosti společně a rozvíjejte své podnikání."
        override val agencyName: String = "Název agentury"
        override val agencyEmail: String = "E-mail agentury"
        override val logoOptional: String = "Logo (volitelné)"
        override val upgradeExperienceTitle: String = "Vylepšete svůj zážitek"
        override val upgradeExperienceSubtitle: String = "Vyberte plán, který nejlépe sedí vašemu způsobu práce."
        override val soloAgentPlan: String = "Solo agent"
        override val proAgentPlan: String = "Pro agent"
        override val soloBenefitActiveProperties: String = "Až 5 aktivních nemovitostí"
        override val soloBenefitAiFollowUps: String = "AI připomínky (základní)"
        override val soloBenefitSellerReports: String = "Luxusní reporty pro prodávající (základní)"
        override val soloBenefitPersonalOnly: String = "Pouze osobní účet"
        override val proBenefitUnlimitedProperties: String = "Neomezené nemovitosti"
        override val proBenefitUnlimitedAi: String = "AI připomínky (neomezené)"
        override val proBenefitAdvancedReports: String = "Pokročilé reporty pro prodávající"
        override val proBenefitAgencyCreation: String = "Vytvoření a správa agentury"
        override val proBenefitInviteAgents: String = "Pozývání agentů a spolupráce"
        override val proBenefitSharedLeads: String = "Sdílené leady a týmové workflow"
        override val proBenefitAgencyBranding: String = "Branding agentury"
        override val proBenefitAdvancedAnalytics: String = "Pokročilá analytika"
        override val startFreeTrial7Day: String = "Předplatit nyní"
        override val restorePurchases: String = "Obnovit nákupy"
        override val comparePlans: String = "Porovnat plány"
        override val startFreeTrial: String = "Vybrat plán"
        override val noCommitmentCancelAnytime: String = "Bez závazku. Zrušit můžete kdykoli."
        override val monthly: String = "Monthly"
        override val yearly: String = "Yearly"
        override val yearlySave20: String = "Yearly - save 20%"
        override val yearlySavings20: String = "Yearly saves 20% compared to monthly."
        override val perYear: String = "/ year"
        override val loadingPlans: String = "Loading plans..."
        override val selectedPlanUnavailable: String = "This plan is not available yet. Check RevenueCat offerings and product identifiers."
        override val signInRequiredForPurchase: String = "Sign in before starting a purchase."
        override val compareActiveProperties: String = "Aktivní nemovitosti"
        override val compareAiFollowUps: String = "AI připomínky"
        override val compareSellerReports: String = "Reporty pro prodávající"
        override val compareAdvancedAnalytics: String = "Pokročilá analytika"
        override val compareAgencyCreation: String = "Vytvoření agentury"
        override val compareJoinAgencies: String = "Připojení k agenturám"
        override val compareInviteAgents: String = "Pozývání agentů"
        override val compareSharedLeads: String = "Sdílené leady"
        override val compareAgencyBranding: String = "Branding agentury"
        override val comparePrioritySupport: String = "Prioritní podpora"
        override val unlimited: String = "Neomezené"
        override val basic: String = "Základní"
        override val advanced: String = "Pokročilé"
        override val perMonth: String = "/ měsíc"
        override val members: String = "členů"
        override val upgradeToProForAgencyTools: String = "Vylepšete na Pro a používejte nástroje agentury"
        override val languageTitle: String = "Jazyk"
        override val languageBody: String = "Vyberte jazyk aplikace pro toto zarizeni."
        override val english: String = "English"
        override val slovak: String = "Slovak"
        override val unitsTitle: String = "Jednotky a mena"
        override val unitsBody: String = "Vyberte, jak se v aplikaci zobrazuji ceny a rozmery nemovitosti."
        override val measurementSystemTitle: String = "Mereni"
        override val metric: String = "Metricke"
        override val imperial: String = "Imperialni"
        override val currencyTitle: String = "Mena"
        override val notificationsTitle: String = "Notifications"
        override val notificationsBody: String = "Control push alerts, quiet hours, and the types of updates HAVN can send."
        override val notificationSettings: String = "Notification settings"
        override val notificationsSubtitle: String = "Only important updates, filtered by your preferences."
        override val quietHoursTitle: String = "Quiet hours"
        override val quietHoursBody: String = "HAVN skips non-critical pushes during quiet hours. Billing and account issues still stay concise."
        override val enableQuietHours: String = "Enable quiet hours"
        override val quietHoursStart: String = "Start"
        override val quietHoursEnd: String = "End"
        override val timezoneLabel: String = "Timezone"
        override val notificationTypesTitle: String = "Notification types"
        override val notificationNewLeadCapturedTitle: String = "New lead captured"
        override val notificationNewLeadCapturedBody: String = "When an opening or QR flow captures a lead."
        override val notificationHotLeadTitle: String = "Lead marked as hot"
        override val notificationHotLeadBody: String = "Only when a lead becomes high intent."
        override val notificationOpeningStartsSoonTitle: String = "Opening starts soon"
        override val notificationOpeningStartsSoonBody: String = "A single reminder 30 minutes before start."
        override val notificationOpeningSummaryReadyTitle: String = "Opening summary ready"
        override val notificationOpeningSummaryReadyBody: String = "When the post-event summary is ready."
        override val notificationSellerReportGeneratedTitle: String = "Seller report generated"
        override val notificationSellerReportGeneratedBody: String = "When a seller report has been created."
        override val notificationAiFollowUpReadyTitle: String = "AI follow-up ready"
        override val notificationAiFollowUpReadyBody: String = "When a follow-up draft is ready to review."
        override val notificationAgentInvitedTitle: String = "Agent invited to agency"
        override val notificationAgentInvitedBody: String = "Agency invitations and membership changes."
        override val notificationLeadAssignedTitle: String = "Lead assigned to you"
        override val notificationLeadAssignedBody: String = "When a teammate assigns a lead to you."
        override val notificationLeadTransferredTitle: String = "Lead transferred to you"
        override val notificationLeadTransferredBody: String = "When ownership of a lead moves to you."
        override val notificationSubscriptionIssueTitle: String = "Subscription issue"
        override val notificationSubscriptionIssueBody: String = "Renewal failures and billing problems."
        override val kioskSecurityTitle: String = "Kiosk security"
        override val kioskSecurityBody: String = "Use this PIN to leave kiosk mode and return to the agent app."
        override val kioskPinLabel: String = "Kiosk PIN"
        override val kioskFeaturedProperty: String = "Featured property"
        override val kioskPrivateShowing: String = "Private showing"
        override val kioskLuxuryListing: String = "Luxury listing"
        override val kioskFastCheckIn: String = "Fast check-in"
        override val kioskExitContentDescription: String = "Exit kiosk"
        override val kioskWelcome: String = "Welcome"
        override val kioskGladHere: String = "We’re glad you’re here."
        override val kioskScanToCheckIn: String = "Scan to check in"
        override val kioskReceivePropertyDetails: String = "and receive property details"
        override val kioskOr: String = "Or"
        override val kioskStartCheckInManually: String = "Start check-in manually"
        override val kioskSecureInfo: String = "Your information is secure and will never be shared."
        override val kioskExitTitle: String = "Exit kiosk"
        override val kioskExitBody: String = "Enter the kiosk PIN to return to the agent app."
        override val kioskIncorrectPin: String = "Incorrect PIN."
        override val kioskUnlock: String = "Unlock"
        override val kioskTellUsTitle: String = "Tell us about yourself"
        override val kioskTellUsBody: String = "Your information goes only to the hosting agent."
        override val kioskFullName: String = "Full name"
        override val kioskContinue: String = "Continue"
        override val kioskQuestionsTitle: String = "A couple quick questions"
        override val kioskQuestionsBody: String = "This helps the agent follow up with the right context."
        override val kioskWorkingWithAgentQuestion: String = "Are you working with an agent?"
        override val kioskYes: String = "Yes"
        override val kioskNo: String = "No"
        override val kioskInterestQuestion: String = "What are you interested in?"
        override val kioskInterestBuying: String = "Buying"
        override val kioskInterestInvesting: String = "Investing"
        override val kioskInterestBrowsing: String = "Just browsing"
        override val kioskInterestRelocating: String = "Relocating"
        override val kioskFinish: String = "Finish"
        override val kioskThankYou: String = "Thank you"
        override val kioskEnjoyVisitPrefix: String = "Enjoy your visit at"
        override val kioskResetAutomatically: String = "This kiosk will reset automatically."
        override val environmentTitle: String = "Environment"
        override val environmentBody: String = "Local Supabase is configured for development. Production values should move behind build-time configuration."
        override val secure: String = "Secure"
        override val brokerageProfileTitle: String = "Brokerage profile"
        override val brokerageProfileBody: String = "Team branding, agent invites, and notification preferences will live here."
        override val logout: String = "Odhlasit se"
        override val languageChanged: String = "Language changed"
        override val commonAdd: String = "Pridat"
        override val commonEdit: String = "Upravit"
        override val commonDelete: String = "Smazat"
        override val commonCancel: String = "Zrusit"
        override val commonSave: String = "Ulozit"
        override val commonCreate: String = "Vytvorit"
        override val commonDismiss: String = "Dismiss"
        override val commonAll: String = "Vše"
        override val commonDone: String = "Hotovo"
        override val commonTime: String = "Čas"
        override val commonHour: String = "Hodina"
        override val commonMinute: String = "Minuta"
        override val commonAgency: String = "Agentura"
        override val commonSettings: String = "Nastavení"
        override val commonOpening: String = "Prohlídka"
        override val commonPropertyName: String = "Nemovitost"
        override val commonToday: String = "Dnes"
        override val agencyToolsAvailable: String = "Nástroje agentury jsou dostupné."
        override val agencySetupSubtitle: String = "Každý účet HAVN má výchozí agenturu. Pro umožňuje spravovat pozvánky, sdílené leady a branding."
        override val agencyRecentActivity: String = "Recent activity"
        override val agencyActivityNewLead: String = "New lead added"
        override val agencyActivityInvitationAccepted: String = "Agent invitation accepted"
        override val agencyActivityAgentJoined: String = "Agent joined the agency"
        override val agencyActivitySellerReport: String = "Seller report created"
        override val agencyWorkspaceTitle: String = "Agency workspace"
        override val agencyWorkspaceBody: String = "Choose which agency you are working with."
        override val agencySoloActiveTitle: String = "Solo agency is active"
        override val agencyProRequiredTitle: String = "Pro plan required"
        override val agencyCreateOrAcceptInviteBody: String = "Create your agency workspace or accept an invite to collaborate with another agency."
        override val agencyProUnlockBody: String = "Agency changes, invites, shared leads, and shared branding unlock with Pro."
        override val realEstate: String = "Real estate"
        override val proAgency: String = "Pro agency"
        override val agencyBrandingTitle: String = "Agency branding"
        override val agencyBrandingBody: String = "Set the agency name and logo shown in the app, kiosk, and shared workspace."
        override val uploadLogo: String = "Upload logo"
        override val saveAgency: String = "Save agency"
        override val yourAgencyRole: String = "Your agency role"
        override val agencyAgentsTitle: String = "Agency agents"
        override val agencyAgentsBody: String = "People eligible to work with this agency."
        override val inviteAgent: String = "Invite agent"
        override val loadingAgents: String = "Loading agents..."
        override val noAgencyAgentsYet: String = "No agency agents yet."
        override val changeRole: String = "Change role"
        override val updating: String = "Updating..."
        override val deleting: String = "Deleting..."
        override val deleteInvite: String = "Delete invite"
        override val chooseAgencyRoleFor: String = "Choose the agency role for"
        override val removeAccess: String = "Remove access"
        override val inviteAgentBody: String = "Send an agency invitation by email. The agent accepts after signing in with the same email."
        override val agentEmail: String = "Agent email"
        override val role: String = "Role"
        override val inviting: String = "Inviting..."
        override val invite: String = "Invite"
        override val agents: String = "Agents"
        override val ok: String = "Ok"
        override val personalActivePropertyLimit: String = "Personal active property limit"
        override val personalAccountAgencyToolsLocked: String = "Personal account is active. Agency tools unlock with Pro."
        override val selected: String = "Selected"
        override val activeMembers: String = "active members"
        override val agencySharedWorkspaceBody: String = "Shared properties, contacts, openings, leads, follow-ups, and reports use this agency workspace."
        override val agencyRoleOwner: String = "Owner"
        override val agencyRoleAdmin: String = "Admin"
        override val agencyRoleAgent: String = "Agent"
        override val agencyRoleAssistant: String = "Assistant"
        override val agencyRoleViewer: String = "Viewer"
        override val agencyRoleOwnerDescription: String = "Full agency control, including members, branding, assignments, listings, leads, and reports."
        override val agencyRoleAdminDescription: String = "Full agency management except deleting the agency."
        override val agencyRoleAgentDescription: String = "Works assigned listings, openings, leads, follow-ups, notes, and seller reports."
        override val agencyRoleAssistantDescription: String = "Supports assigned listings by editing leads, preparing follow-ups, and drafting reports."
        override val agencyRoleViewerDescription: String = "Read-only access to dashboards and reports."
        override val agencyCapabilityInviteRemoveMembers: String = "Invite and remove members"
        override val agencyCapabilityChangeRoles: String = "Change member roles"
        override val agencyCapabilityManageAllProperties: String = "Create, edit, and delete all properties"
        override val agencyCapabilityAssignAgents: String = "Assign agents"
        override val agencyCapabilitySeeAllLeads: String = "See all leads"
        override val agencyCapabilityExportReports: String = "Export reports"
        override val agencyCapabilityChangeBranding: String = "Change agency branding and settings"
        override val agencyCapabilityDeleteAgency: String = "Delete agency"
        override val agencyCapabilityViewAssignedProperties: String = "View assigned properties"
        override val agencyCapabilityHostAssignedOpenings: String = "Host assigned openings"
        override val agencyCapabilitySeeAssignedLeads: String = "See leads from assigned properties and openings"
        override val agencyCapabilityAddNotes: String = "Add notes"
        override val agencyCapabilitySendFollowUps: String = "Send follow-ups"
        override val agencyCapabilityCreateSellerReports: String = "Create seller reports for assigned listings"
        override val agencyCapabilityEditAssignedLeads: String = "Edit assigned leads"
        override val agencyCapabilityPrepareFollowUps: String = "Prepare follow-ups"
        override val agencyCapabilityCreateDraftReports: String = "Create draft reports"
        override val agencyCapabilityCannotDeleteProperties: String = "Cannot delete properties"
        override val agencyCapabilityCannotInviteAgents: String = "Cannot invite agents unless allowed"
        override val agencyCapabilityViewDashboards: String = "View dashboards"
        override val agencyCapabilityViewReports: String = "View reports"
        override val agencyCapabilityCannotEdit: String = "Cannot edit anything"
        override val commonVisitors: String = "Leady"
        override val commonHot: String = "Hot"
        override val commonWarm: String = "Warm"
        override val commonCold: String = "Cold"
        override val commonActive: String = "Aktivni"
        override val commonPlanned: String = "Planovane"
        override val commonArchived: String = "Archivovane"
        override val commonPast: String = "Proběhlé"
        override val commonFollowUps: String = "Připomínky"
        override val commonProperty: String = "Nemovitost"
        override val commonAddress: String = "Adresa"
        override val commonOpenHouse: String = "Opening"
        override val commonCheckedIn: String = "Checked in"
        override val commonNotScheduled: String = "not scheduled"
        override val todayTitle: String = "Today"
        override val todaySubtitle: String = "Denní prostor pro prohlídky, leady, připomínky a podklady pro prodávajícího."
        override val todayOpenHousesMetric: String = "openings"
        override val capturedMetric: String = "captured"
        override val priorityMetric: String = "priority"
        override val noActivePropertiesTitle: String = "No active properties"
        override val noActivePropertiesBody: String = "Add or activate a property to make it appear on Today."
        override val checkIns: String = "Check-ins"
        override val allOpenHouses: String = "all openings"
        override val pendingDrafts: String = "pending drafts"
        override val priorityLead: String = "Priority lead"
        override val nextOpenHouseAt: String = "Next opening at"
        override val noOpenHouseScheduled: String = "No opening scheduled"
        override val personalAccount: String = "Osobní účet"
        override val accountReady: String = "Váš účet je připraven"
        override val realEstateApp: String = "Realitní aplikace"
        override val needHelp: String = "Potřebujete pomoc?"
        override val contactSupport: String = "Kontaktovat podporu"
        override val upgradePlan: String = "Vylepšit plán"
        override val planSuffix: String = "Plán"
        override val todayActionsTitle: String = "Dnešní priority"
        override val whatOpeningNext: String = "Která prohlídka je další?"
        override val whoCheckedIn: String = "Kdo se přihlásil?"
        override val whoNeedsFollowUp: String = "Kdo čeká na připomínku?"
        override val whatShouldIDoNow: String = "Co mám udělat teď?"
        override val noCheckInsYet: String = "Zatím se nepřihlásil žádný kontakt."
        override val noPendingFollowUps: String = "Momentálně nejsou žádné čekající připomínky."
        override val openKioskForNextOpening: String = "Otevřete kiosk pro nejbližší prohlídku."
        override val reviewNewLeads: String = "Zkontrolujte nové leady a odešlete připomínky."
        override val createOpeningToStart: String = "Vytvořte prohlídku z nemovitosti a začněte sbírat leady."
        override val addFirstPropertyToStart: String = "Začněte přidáním první nemovitosti."
        override val nextOpening: String = "Další prohlídka"
        override val quickSignIn: String = "Rychlé přihlášení"
        override val scanQrCode: String = "Skenovat QR kód"
        override val newLead: String = "Nový lead"
        override val myProperties: String = "Moje nemovitosti"
        override val manageListings: String = "Spravovat nabídky"
        override val todaysOverview: String = "Dnešní přehled"
        override val seeAll: String = "Zobrazit vše"
        override val propertiesEyebrow: String = "Portfólio"
        override val propertiesSubtitle: String = "Manage active, planned, and archived listings with Supabase-backed media and performance intelligence."
        override val propertiesLiveMetric: String = "live"
        override val propertiesPipelineMetric: String = "pipeline"
        override val propertiesAllTimeMetric: String = "all time"
        override val addProperty: String = "Pridat nemovitost"
        override val editProperty: String = "Upravit nemovitost"
        override val propertyFallback: String = "Property"
        override val propertyUnavailableTitle: String = "Nemovitost není dostupná"
        override val propertyUnavailableBody: String = "Refresh the portfolio to reload this listing."
        override val backToProperties: String = "Zpět na nemovitosti"
        override val deletePropertyTitle: String = "Smazat nemovitost?"
        override val deletePropertyBody: String = "This will permanently delete the property and its related local records. This cannot be undone."
        override val loadingProperties: String = "Načítám nemovitosti"
        override val noPropertiesTitle: String = "Zatím žádné nemovitosti"
        override val noPropertiesBody: String = "Add your first property, then create an opening to start collecting leads and seller-ready feedback."
        override val openHouseButton: String = "Vytvořit otevření"
        override val photosTitle: String = "Photos"
        override val photosBody: String = "The first photo is used as the main property image across Portfolio."
        override val uploadPhoto: String = "Nahrát fotku"
        override val noPhotosYet: String = "Zatím nejsou nahrané žádné fotky."
        override val mainPhoto: String = "Hlavní"
        override val propertyTitleLabel: String = "Název nemovitosti"
        override val propertyAddressLine1Label: String = "Ulice a číslo"
        override val propertyAddressLine2Label: String = "Doplnění adresy"
        override val propertyCityLabel: String = "Město"
        override val propertyRegionLabel: String = "Kraj"
        override val propertyPostalCodeLabel: String = "PSČ"
        override val propertyCountryLabel: String = "Země"
        override val propertyAskingPriceLabel: String = "Nabídková cena"
        override val propertyBedsLabel: String = "Pokoje"
        override val propertyBathsLabel: String = "Koupelny"
        override val propertyInteriorLabel: String = "Interiér"
        override val propertyDescriptionLabel: String = "Popis"
        override val createPropertyButton: String = "+ Vytvořit nemovitost"
        override val locateProperty: String = "Lokalizovat nemovitost"
        override val findLocation: String = "Najít polohu"
        override val find: String = "Najít"
        override val navigate: String = "Navigovat"
        override val propertyLocationMarkerTitle: String = "Poloha nemovitosti"
        override val mapKitJsMissingToken: String = "Přidejte HAVN_MAPKIT_JS_TOKEN do local.properties pro webovou mapu."
        override val mapKitJsLoading: String = "Načítá se MapKit JS..."
        override val generateSellerReport: String = "Vygenerovat report pro prodávajícího"
        override val deleteProperty: String = "Smazat nemovitost"
        override val conversionMetric: String = "Konverze"
        override val propertyPhotoContentDescription: String = "Fotka nemovitosti"
        override val deletePhoto: String = "Smazat fotku"
        override val movePhotoLeft: String = "Přesunout fotku doleva"
        override val movePhotoRight: String = "Přesunout fotku doprava"
        override val propertyTitleRequired: String = "Název nemovitosti je povinný."
        override val propertyStreetRequired: String = "Ulice a číslo jsou povinné."
        override val propertyCityRequired: String = "Město je povinné."
        override val propertyRegionRequired: String = "Kraj je povinný."
        override val propertyPostalRequired: String = "PSČ je povinné."
        override val propertyAskingPriceInvalid: String = "Zadejte platnou nabídkovou cenu."
        override val propertyOwnerContactTitle: String = "Kontakt na majitele nemovitosti"
        override val propertyOwnerSelectContact: String = "Vyberte existující kontakt jako majitele nemovitosti."
        override val propertyOwnerSelected: String = "Vybraný majitel"
        override val propertyOwnerNoContacts: String = "Zatím nemáte žádné kontakty. Přidejte majitele v Kontaktech a potom ho zde vyberte."
        override val propertyOwnerChooseContact: String = "Vybrat kontakt"
        override val propertyOwnerChangeContact: String = "Změnit kontakt"
        override val propertyOwnerRemoveContact: String = "Odebrat"
        override val propertyOwnerPickerTitle: String = "Vyberte majitele nemovitosti"
        override val propertyOwnerSearchContact: String = "Hledat kontakty"
        override val propertyOwnerSearchHint: String = "Začněte psát jméno, e-mail nebo telefon."
        override val propertyOwnerNoMatches: String = "Žádné odpovídající kontakty."
        override val propertyOpeningsTitle: String = "Openings"
        override val propertyNoOpenings: String = "No openings scheduled for this property."
        override val teamAccessTitle: String = "Team access"
        override val onlyListingOwner: String = "Only the listing owner"
        override val assignTeam: String = "Assign team"
        override val assignPropertyTitle: String = "Assign property"
        override val assignPropertyBody: String = "Choose who can work this property. Select the whole team or specific agents."
        override val wholeTeam: String = "Whole team"
        override val leadsEyebrow: String = "Leads"
        override val leadFallback: String = "Lead"
        override val leadsSubtitle: String = "Search, filter, and qualify leads captured across every opening."
        override val leadDetailSubtitle: String = "Zdroj, kvalifikace, poznámky a historie připomínek pro tento lead."
        override val totalMetric: String = "Total"
        override val loggedMetric: String = "logged"
        override val searchLeads: String = "Search leads"
        override val searchLeadsPlaceholder: String = "Name, phone, or email"
        override val allProperties: String = "All properties"
        override val loadingLeads: String = "Loading opening leads"
        override val noLeadsFoundTitle: String = "Leady se zobrazí zde, když se kontakty přihlásí na prohlídku."
        override val noLeadsEmptyBody: String = "Použijte kiosk pro přihlášení nebo přidejte kontakty ručně z prohlídky."
        override val noLeadsFilteredBody: String = "Try a different property, status, or search term."
        override val backToLeads: String = "Back to leads"
        override val leadUnavailableTitle: String = "Lead unavailable"
        override val leadUnavailableBody: String = "This lead is no longer available in the current lead list."
        override val leadTemperature: String = "Lead status"
        override val leadLabelSuffix: String = "Lead"
        override val greetingHi: String = "Dobrý den"
        override val leadActionCall: String = "Zavolat"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "E-mail"
        override val leadFollowUp: String = "Připomínka"
        override val leadNoFollowUpScheduled: String = "Připomínka není naplánovaná"
        override val leadIntentScore: String = "Skóre zájmu"
        override val leadInterestedIn: String = "Zájem o"
        override val leadGenericGreetingName: String = "vás"
        override val followUpMessageTypeThankYou: String = "Poděkování"
        override val followUpMessageTypePropertyInfo: String = "Info o nemovitosti"
        override val followUpMessageTypeFollowUp: String = "Připomínka"
        override val followUpMessageTypeCheckIn: String = "Ověření zájmu"
        override val followUpMessageTypePriceUpdate: String = "Změna ceny"
        override val followUpMessageTypePropertyBrochure: String = "Fotky"
        override val followUpPreview: String = "Náhled"
        override val followUpSubject: String = "Předmět"
        override val followUpMessage: String = "Zpráva"
        override val followUpSendViaEmail: String = "Odeslat e-mailem"
        override val followUpSendViaSms: String = "Odeslat SMS"
        override val followUpAiAssistantTitle: String = "AI asistent"
        override val followUpAiAssistantBody: String = "Vygenerujte osobní zprávu během několika sekund."
        override val followUpGenerateWithAi: String = "Vygenerovat pomocí AI"
        override val followUpUpgradeForAi: String = "Odemknout AI"
        override val followUpDefaultSubject: String = "Připomínka k nemovitosti"
        override val privateAgentNotes: String = "Private agent notes"
        override val notes: String = "Notes"
        override val notesPlaceholder: String = "Motivation, preferences, objections, next move"
        override val saveNotes: String = "Save notes"
        override val followUpHistory: String = "Historie připomínek"
        override val noFollowUpsLogged: String = "Zatím nejsou zapsané žádné připomínky."
        override val openHousesEyebrow: String = "Showings"
        override val scheduleOpenHouse: String = "Vytvořit prohlídku"
        override val openingDetails: String = "Detail prohlídky"
        override val editOpening: String = "Upravit prohlídku"
        override val deleteOpening: String = "Smazat prohlídku"
        override val deleteOpeningBody: String = "Opravdu chcete tuto prohlídku smazat? Tuto akci nelze vrátit zpět."
        override val openingName: String = "Název prohlídky"
        override val startsAt: String = "Začíná"
        override val endsAt: String = "Končí"
        override val chooseStartDateTime: String = "Vyberte datum a čas začátku"
        override val chooseEndDateTime: String = "Vyberte datum a čas konce"
        override val accessNotes: String = "Poznámky k přístupu"
        override val privateNotes: String = "Soukromé poznámky"
        override val addPrivateNote: String = "Přidat soukromou poznámku"
        override val liveDashboard: String = "Live dashboard"
        override val visitorKiosk: String = "Lead kiosk"
        override val openHousesSubtitle: String = "Create openings for properties, review leads, and launch kiosk sessions."
        override val liveMetric: String = "Live"
        override val upcomingMetric: String = "Upcoming"
        override val inProgressMetric: String = "in progress"
        override val scheduledMetric: String = "scheduled"
        override val loadingOpenHouses: String = "Loading openings"
        override val addPropertyFirstTitle: String = "Add a property first"
        override val addPropertyFirstBody: String = "Create an opening from a property to start collecting leads."
        override val noOpenHousesTitle: String = "No openings scheduled"
        override val noOpenHousesBody: String = "Create an opening from a property to start collecting leads."
        override val noSignInsTitle: String = "No sign-ins yet"
        override val noSignInsBody: String = "Leads checked in through kiosk mode will appear here in real time."
        override val dashboard: String = "Dashboard"
        override val start: String = "Start"
        override val end: String = "End"
        override val endOpenHouse: String = "End opening"
        override val reportsEyebrow: String = "Owners"
        override val sellerReportsTitle: String = "Seller reports"
        override val createReport: String = "Create report"
        override val reportPreview: String = "Property Report"
        override val reportsSubtitle: String = "Generate premium post-opening recaps with lead quality, buyer intent, and seller-ready narrative."
        override val reportsMetricSaved: String = "saved"
        override val reportedMetric: String = "reported"
        override val leadsMetric: String = "leads"
        override val createSellerReport: String = "Create seller report"
        override val attendance: String = "Attendance"
        override val savedReports: String = "saved reports"
        override val buyerHeat: String = "Buyer heat"
        override val hotLeads: String = "hot leads"
        override val loadingSellerReports: String = "Loading seller reports"
        override val noSellerReportsTitle: String = "No seller reports yet"
        override val noSellerReportsBody: String = "Choose an opening, add agent notes, preview an export-ready recap, then save it."
        override val chooseOpenHouse: String = "Choose opening"
        override val noOpenHousesAvailable: String = "No openings available yet."
        override val agentNotes: String = "Agent notes"
        override val notesForSeller: String = "Notes for seller"
        override val sellerNotesPlaceholder: String = "Buyer objections, pricing signals, showing feedback, recommended next move"
        override val generatePreview: String = "Generate preview"
        override val noPreviewReadyTitle: String = "No preview ready"
        override val noPreviewReadyBody: String = "Generate a seller report preview before saving."
        override val saveReport: String = "Save report"
        override val reportSaved: String = "Report saved"
        override val sellerOpenHouseReport: String = "Seller opening report"
        override val mostCommonBuyerInterest: String = "Most common buyer interest"
        override val followUpsSent: String = "Odeslané připomínky"
        override val summary: String = "Summary"
        override val noPrivateNotesAdded: String = "No private notes added."
        override val openHouseReport: String = "Opening report"
        override val searchProperties: String = "Hledat nemovitosti"
        override val searchOpenings: String = "Hledat prohlídky"
        override val noOpeningsFoundTitle: String = "No openings found"
        override val noOpeningsFoundBody: String = "Try another search or opening status filter."
        override val noMatchingPropertiesTitle: String = "No matching properties"
        override val noMatchingPropertiesBody: String = "Try another search or status filter."
        override val clientsTitle: String = "Kontakty"
        override val clientFallback: String = "Kontakt"
        override val addClient: String = "Přidat kontakt"
        override val editClient: String = "Upravit kontakt"
        override val newClient: String = "Nový kontakt"
        override val saveClient: String = "Uložit kontakt"
        override val createClient: String = "Vytvořit kontakt"
        override val deleteClientTitle: String = "Delete contact?"
        override val deleteClientBody: String = "This will permanently delete the contact. This cannot be undone."
        override val firstName: String = "Jméno"
        override val lastName: String = "Příjmení"
        override val email: String = "E-mail"
        override val phone: String = "Telefon"
        override val comments: String = "Komentáře"
        override val addPhoto: String = "Add photo"
        override val sendQr: String = "Send QR"
        override val photo: String = "Photo"
        override val clientDetailSubtitle: String = "QR identity, contact details, comments, and openings connected through leads."
        override val clientFormEditSubtitle: String = "Update contact details, delivery info, and comments."
        override val clientFormNewSubtitle: String = "Register a buyer/contact and generate a reusable QR identity for openings."
        override val searchClients: String = "Hledat kontakty"
        override val noClientsYetTitle: String = "No contacts yet"
        override val noClientsYetBody: String = "Register contacts first, then send their QR code by email or SMS before an opening."
        override val noClientsFoundTitle: String = "No contacts found"
        override val noClientsFoundBody: String = "Try another name, phone, or email."
        override val clientUnavailableTitle: String = "Contact unavailable"
        override val clientUnavailableBody: String = "Refresh the contacts list and open this record again."
        override val noCommentsAdded: String = "No comments added."
        override val openingsTitle: String = "Prohlídky"
        override val clientOpeningsEmpty: String = "No openings connected yet. Leads connect a contact to an opening."
        override val clientPassLabel: String = "Pass"
        override val clientNoEmail: String = "No email"
        override val visitorsBody: String = "Open kiosk mode, scan a contact QR, or add existing contacts as leads for this opening."
        override val openKiosk: String = "Otevřít kiosk"
        override val addQrClient: String = "Přidat QR kontakt"
        override val addManually: String = "Přidat ručně"
        override val selectClients: String = "Vybrat kontakty"
        override val selectClientsBody: String = "Choose contacts from your list. Each selected contact becomes a lead for this opening."
        override val kioskCheckIn: String = "Kiosk check-in"
        override val kioskCheckInBody: String = "Use the rear camera to scan the contact's HAVN Wallet QR. When the code is recognized, HAVN creates the lead for this opening automatically."
        override val scanWithCamera: String = "Scan with rear camera"
        override val clientQrImage: String = "Contact QR image"
        override val clientQrImageBody: String = "Keep the contact's QR inside the gold square. HAVN collects each scan below."
        override val scanMultipleQrBody: String = "Scan one or more HAVN contact QR codes, then tap Add QR contact."
        override val scannedQrReady: String = "contact QR ready to add"
        override val createLeadFromQr: String = "Create lead from QR"
        override val noClientsFoundShort: String = "No contacts found."
        override val remove: String = "Odebrat"
    }

    private val spanish: HavnStrings = object : HavnStrings {
        override val navToday: String = "Hoy"
        override val navProperties: String = "Propiedades"
        override val navLeads: String = "Leads"
        override val navReports: String = "Informes"
        override val navSettings: String = "Ajustes"
        override val navAuth: String = "Acceso agente"
        override val navOpenHouses: String = "Visitas"
        override val navTours: String = "Visitas"
        override val navFollowUps: String = "Contactos"
        override val navFollow: String = "Contactos"
        override val back: String = "Atras"
        override val settingsEyebrow: String = "Espacio de trabajo"
        override val settingsTitle: String = "Ajustes"
        override val settingsSubtitle: String = "Perfil, idioma, unidades, entorno y opciones de equipo."
        override val agentProfileTitle: String = "Perfil del agente"
        override val agentPhoto: String = "Foto del agente"
        override val uploading: String = "Subiendo..."
        override val saving: String = "Guardando..."
        override val validAgentPhotoRequired: String = "Elige una foto de agente válida."
        override val signOut: String = "Cerrar sesión"
        override val signOutQuestion: String = "¿Cerrar sesión?"
        override val signOutConfirmation: String = "¿Seguro que quieres cerrar sesión en HAVN?"
        override val upgrade: String = "Mejorar"
        override val premiumThemesTitle: String = "Temas premium"
        override val premiumThemesUpgradePrompt: String = "Mejora a Pro para desbloquear temas premium."
        override val appearanceTitle: String = "Apariencia"
        override val appearanceBody: String = "Elige un tema HAVN seleccionado. Los temas premium se desbloquean con Pro."
        override val previewComponents: String = "Vista previa de componentes"
        override val themeShowcaseTitle: String = "Vista previa del tema"
        override val showcaseButtons: String = "Botones"
        override val showcasePrimaryAction: String = "Acción principal"
        override val showcaseSecondaryAction: String = "Acción secundaria"
        override val showcaseGhostAction: String = "Acción discreta"
        override val showcaseTextField: String = "Campo de texto"
        override val showcaseFocusedBorder: String = "Borde de acento activo"
        override val showcaseSearchPreview: String = "Vista previa de búsqueda"
        override val showcaseOpeningCheckedIn: String = "Registro en una apertura hoy"
        override val showcaseSentAt: String = "Enviado a las 10:30"
        override val themeObsidianGoldName: String = "Obsidian Gold"
        override val themeObsidianGoldDescription: String = "Negro de lujo, grafito y oro cálido."
        override val themeMidnightSapphireName: String = "Midnight Sapphire"
        override val themeMidnightSapphireDescription: String = "Azul noche, zafiro y acentos plateados."
        override val themeEmeraldEstateName: String = "Emerald Estate"
        override val themeEmeraldEstateDescription: String = "Esmeralda oscuro, carbón y oro champán."
        override val themePlatinumStoneName: String = "Platinum Stone"
        override val themePlatinumStoneDescription: String = "Gris piedra, platino y blanco suave."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Vino oscuro, grafito y acentos de cobre."
        override val commonChange: String = "Cambiar"
        override val agentPlanTitle: String = "Plan del agente"
        override val agentPlanBody: String = "Mejora tu experiencia y elige el plan que encaja con tu forma de trabajar."
        override val currentPlan: String = "Plan actual"
        override val transferPlan: String = "Transferir plan"
        override val restorePurchase: String = "Restaurar compra"
        override val agencySettingsProBody: String = "Solo agency está activa por defecto. Pro permite crear o seleccionar una agencia compartida."
        override val agencySettingsLockedBody: String = "Solo agency está activa. Los cambios de agencia se desbloquean con Pro."
        override val soloAgency: String = "Solo agency"
        override val defaultPrivateAgencyWorkspace: String = "Agencia privada predeterminada"
        override val noAgenciesAvailableYet: String = "Todavía no hay invitaciones ni agencias propias disponibles."
        override val oneOwnedAgencyHint: String = "Tu agencia propia aparece arriba. Un agente solo puede tener una agencia."
        override val createAgency: String = "Crear agencia"
        override val createYourAgency: String = "Crea tu agencia"
        override val createAgencyBody: String = "Construye tu equipo, gestiona propiedades juntos y haz crecer tu negocio."
        override val agencyName: String = "Nombre de la agencia"
        override val agencyEmail: String = "Email de la agencia"
        override val logoOptional: String = "Logo (opcional)"
        override val upgradeExperienceTitle: String = "Mejora tu experiencia"
        override val upgradeExperienceSubtitle: String = "Elige el plan que encaja con tu forma de trabajar."
        override val soloAgentPlan: String = "Solo agent"
        override val proAgentPlan: String = "Pro agent"
        override val soloBenefitActiveProperties: String = "Hasta 5 propiedades activas"
        override val soloBenefitAiFollowUps: String = "Seguimientos con IA (básicos)"
        override val soloBenefitSellerReports: String = "Informes de vendedor premium (básicos)"
        override val soloBenefitPersonalOnly: String = "Solo cuenta personal"
        override val proBenefitUnlimitedProperties: String = "Propiedades ilimitadas"
        override val proBenefitUnlimitedAi: String = "Seguimientos con IA (ilimitados)"
        override val proBenefitAdvancedReports: String = "Informes avanzados para vendedores"
        override val proBenefitAgencyCreation: String = "Creación y gestión de agencias"
        override val proBenefitInviteAgents: String = "Invitar agentes y colaborar"
        override val proBenefitSharedLeads: String = "Leads compartidos y flujos de equipo"
        override val proBenefitAgencyBranding: String = "Branding de agencia"
        override val proBenefitAdvancedAnalytics: String = "Analítica avanzada"
        override val startFreeTrial7Day: String = "Suscribirse ahora"
        override val restorePurchases: String = "Restaurar compras"
        override val comparePlans: String = "Comparar planes"
        override val startFreeTrial: String = "Elegir plan"
        override val noCommitmentCancelAnytime: String = "Sin compromiso. Cancela cuando quieras."
        override val monthly: String = "Monthly"
        override val yearly: String = "Yearly"
        override val yearlySave20: String = "Yearly - save 20%"
        override val yearlySavings20: String = "Yearly saves 20% compared to monthly."
        override val perYear: String = "/ year"
        override val loadingPlans: String = "Loading plans..."
        override val selectedPlanUnavailable: String = "This plan is not available yet. Check RevenueCat offerings and product identifiers."
        override val signInRequiredForPurchase: String = "Sign in before starting a purchase."
        override val compareActiveProperties: String = "Propiedades activas"
        override val compareAiFollowUps: String = "Seguimientos con IA"
        override val compareSellerReports: String = "Informes de vendedor"
        override val compareAdvancedAnalytics: String = "Analítica avanzada"
        override val compareAgencyCreation: String = "Creación de agencia"
        override val compareJoinAgencies: String = "Unirse a agencias"
        override val compareInviteAgents: String = "Invitar agentes"
        override val compareSharedLeads: String = "Leads compartidos"
        override val compareAgencyBranding: String = "Branding de agencia"
        override val comparePrioritySupport: String = "Soporte prioritario"
        override val unlimited: String = "Ilimitado"
        override val basic: String = "Básico"
        override val advanced: String = "Avanzado"
        override val perMonth: String = "/ mes"
        override val members: String = "miembros"
        override val upgradeToProForAgencyTools: String = "Mejora a Pro para usar herramientas de agencia"
        override val languageTitle: String = "Idioma"
        override val languageBody: String = "Elige el idioma de la app para este dispositivo."
        override val english: String = "English"
        override val slovak: String = "Slovak"
        override val unitsTitle: String = "Unidades y moneda"
        override val unitsBody: String = "Elige como se muestran precios y superficies en la app."
        override val measurementSystemTitle: String = "Medicion"
        override val metric: String = "Metrico"
        override val imperial: String = "Imperial"
        override val currencyTitle: String = "Moneda"
        override val notificationsTitle: String = "Notifications"
        override val notificationsBody: String = "Control push alerts, quiet hours, and the types of updates HAVN can send."
        override val notificationSettings: String = "Notification settings"
        override val notificationsSubtitle: String = "Only important updates, filtered by your preferences."
        override val quietHoursTitle: String = "Quiet hours"
        override val quietHoursBody: String = "HAVN skips non-critical pushes during quiet hours. Billing and account issues still stay concise."
        override val enableQuietHours: String = "Enable quiet hours"
        override val quietHoursStart: String = "Start"
        override val quietHoursEnd: String = "End"
        override val timezoneLabel: String = "Timezone"
        override val notificationTypesTitle: String = "Notification types"
        override val notificationNewLeadCapturedTitle: String = "New lead captured"
        override val notificationNewLeadCapturedBody: String = "When an opening or QR flow captures a lead."
        override val notificationHotLeadTitle: String = "Lead marked as hot"
        override val notificationHotLeadBody: String = "Only when a lead becomes high intent."
        override val notificationOpeningStartsSoonTitle: String = "Opening starts soon"
        override val notificationOpeningStartsSoonBody: String = "A single reminder 30 minutes before start."
        override val notificationOpeningSummaryReadyTitle: String = "Opening summary ready"
        override val notificationOpeningSummaryReadyBody: String = "When the post-event summary is ready."
        override val notificationSellerReportGeneratedTitle: String = "Seller report generated"
        override val notificationSellerReportGeneratedBody: String = "When a seller report has been created."
        override val notificationAiFollowUpReadyTitle: String = "AI follow-up ready"
        override val notificationAiFollowUpReadyBody: String = "When a follow-up draft is ready to review."
        override val notificationAgentInvitedTitle: String = "Agent invited to agency"
        override val notificationAgentInvitedBody: String = "Agency invitations and membership changes."
        override val notificationLeadAssignedTitle: String = "Lead assigned to you"
        override val notificationLeadAssignedBody: String = "When a teammate assigns a lead to you."
        override val notificationLeadTransferredTitle: String = "Lead transferred to you"
        override val notificationLeadTransferredBody: String = "When ownership of a lead moves to you."
        override val notificationSubscriptionIssueTitle: String = "Subscription issue"
        override val notificationSubscriptionIssueBody: String = "Renewal failures and billing problems."
        override val kioskSecurityTitle: String = "Kiosk security"
        override val kioskSecurityBody: String = "Use this PIN to leave kiosk mode and return to the agent app."
        override val kioskPinLabel: String = "Kiosk PIN"
        override val kioskFeaturedProperty: String = "Featured property"
        override val kioskPrivateShowing: String = "Private showing"
        override val kioskLuxuryListing: String = "Luxury listing"
        override val kioskFastCheckIn: String = "Fast check-in"
        override val kioskExitContentDescription: String = "Exit kiosk"
        override val kioskWelcome: String = "Welcome"
        override val kioskGladHere: String = "We’re glad you’re here."
        override val kioskScanToCheckIn: String = "Scan to check in"
        override val kioskReceivePropertyDetails: String = "and receive property details"
        override val kioskOr: String = "Or"
        override val kioskStartCheckInManually: String = "Start check-in manually"
        override val kioskSecureInfo: String = "Your information is secure and will never be shared."
        override val kioskExitTitle: String = "Exit kiosk"
        override val kioskExitBody: String = "Enter the kiosk PIN to return to the agent app."
        override val kioskIncorrectPin: String = "Incorrect PIN."
        override val kioskUnlock: String = "Unlock"
        override val kioskTellUsTitle: String = "Tell us about yourself"
        override val kioskTellUsBody: String = "Your information goes only to the hosting agent."
        override val kioskFullName: String = "Full name"
        override val kioskContinue: String = "Continue"
        override val kioskQuestionsTitle: String = "A couple quick questions"
        override val kioskQuestionsBody: String = "This helps the agent follow up with the right context."
        override val kioskWorkingWithAgentQuestion: String = "Are you working with an agent?"
        override val kioskYes: String = "Yes"
        override val kioskNo: String = "No"
        override val kioskInterestQuestion: String = "What are you interested in?"
        override val kioskInterestBuying: String = "Buying"
        override val kioskInterestInvesting: String = "Investing"
        override val kioskInterestBrowsing: String = "Just browsing"
        override val kioskInterestRelocating: String = "Relocating"
        override val kioskFinish: String = "Finish"
        override val kioskThankYou: String = "Thank you"
        override val kioskEnjoyVisitPrefix: String = "Enjoy your visit at"
        override val kioskResetAutomatically: String = "This kiosk will reset automatically."
        override val environmentTitle: String = "Environment"
        override val environmentBody: String = "Local Supabase is configured for development. Production values should move behind build-time configuration."
        override val secure: String = "Secure"
        override val brokerageProfileTitle: String = "Brokerage profile"
        override val brokerageProfileBody: String = "Team branding, agent invites, and notification preferences will live here."
        override val logout: String = "Cerrar sesion"
        override val languageChanged: String = "Language changed"
        override val commonAdd: String = "Anadir"
        override val commonEdit: String = "Editar"
        override val commonDelete: String = "Eliminar"
        override val commonCancel: String = "Cancelar"
        override val commonSave: String = "Guardar"
        override val commonCreate: String = "Crear"
        override val commonDismiss: String = "Dismiss"
        override val commonAll: String = "Todo"
        override val commonDone: String = "Listo"
        override val commonTime: String = "Hora"
        override val commonHour: String = "Hora"
        override val commonMinute: String = "Minuto"
        override val commonAgency: String = "Agencia"
        override val commonSettings: String = "Ajustes"
        override val commonOpening: String = "Apertura"
        override val commonPropertyName: String = "Propiedad"
        override val commonToday: String = "Hoy"
        override val agencyToolsAvailable: String = "Las herramientas de agencia están disponibles."
        override val agencySetupSubtitle: String = "Cada cuenta HAVN tiene una agencia predeterminada. Pro permite gestionar invitaciones, leads compartidos y marca."
        override val agencyRecentActivity: String = "Recent activity"
        override val agencyActivityNewLead: String = "New lead added"
        override val agencyActivityInvitationAccepted: String = "Agent invitation accepted"
        override val agencyActivityAgentJoined: String = "Agent joined the agency"
        override val agencyActivitySellerReport: String = "Seller report created"
        override val agencyWorkspaceTitle: String = "Agency workspace"
        override val agencyWorkspaceBody: String = "Choose which agency you are working with."
        override val agencySoloActiveTitle: String = "Solo agency is active"
        override val agencyProRequiredTitle: String = "Pro plan required"
        override val agencyCreateOrAcceptInviteBody: String = "Create your agency workspace or accept an invite to collaborate with another agency."
        override val agencyProUnlockBody: String = "Agency changes, invites, shared leads, and shared branding unlock with Pro."
        override val realEstate: String = "Real estate"
        override val proAgency: String = "Pro agency"
        override val agencyBrandingTitle: String = "Agency branding"
        override val agencyBrandingBody: String = "Set the agency name and logo shown in the app, kiosk, and shared workspace."
        override val uploadLogo: String = "Upload logo"
        override val saveAgency: String = "Save agency"
        override val yourAgencyRole: String = "Your agency role"
        override val agencyAgentsTitle: String = "Agency agents"
        override val agencyAgentsBody: String = "People eligible to work with this agency."
        override val inviteAgent: String = "Invite agent"
        override val loadingAgents: String = "Loading agents..."
        override val noAgencyAgentsYet: String = "No agency agents yet."
        override val changeRole: String = "Change role"
        override val updating: String = "Updating..."
        override val deleting: String = "Deleting..."
        override val deleteInvite: String = "Delete invite"
        override val chooseAgencyRoleFor: String = "Choose the agency role for"
        override val removeAccess: String = "Remove access"
        override val inviteAgentBody: String = "Send an agency invitation by email. The agent accepts after signing in with the same email."
        override val agentEmail: String = "Agent email"
        override val role: String = "Role"
        override val inviting: String = "Inviting..."
        override val invite: String = "Invite"
        override val agents: String = "Agents"
        override val ok: String = "Ok"
        override val personalActivePropertyLimit: String = "Personal active property limit"
        override val personalAccountAgencyToolsLocked: String = "Personal account is active. Agency tools unlock with Pro."
        override val selected: String = "Selected"
        override val activeMembers: String = "active members"
        override val agencySharedWorkspaceBody: String = "Shared properties, contacts, openings, leads, follow-ups, and reports use this agency workspace."
        override val agencyRoleOwner: String = "Owner"
        override val agencyRoleAdmin: String = "Admin"
        override val agencyRoleAgent: String = "Agent"
        override val agencyRoleAssistant: String = "Assistant"
        override val agencyRoleViewer: String = "Viewer"
        override val agencyRoleOwnerDescription: String = "Full agency control, including members, branding, assignments, listings, leads, and reports."
        override val agencyRoleAdminDescription: String = "Full agency management except deleting the agency."
        override val agencyRoleAgentDescription: String = "Works assigned listings, openings, leads, follow-ups, notes, and seller reports."
        override val agencyRoleAssistantDescription: String = "Supports assigned listings by editing leads, preparing follow-ups, and drafting reports."
        override val agencyRoleViewerDescription: String = "Read-only access to dashboards and reports."
        override val agencyCapabilityInviteRemoveMembers: String = "Invite and remove members"
        override val agencyCapabilityChangeRoles: String = "Change member roles"
        override val agencyCapabilityManageAllProperties: String = "Create, edit, and delete all properties"
        override val agencyCapabilityAssignAgents: String = "Assign agents"
        override val agencyCapabilitySeeAllLeads: String = "See all leads"
        override val agencyCapabilityExportReports: String = "Export reports"
        override val agencyCapabilityChangeBranding: String = "Change agency branding and settings"
        override val agencyCapabilityDeleteAgency: String = "Delete agency"
        override val agencyCapabilityViewAssignedProperties: String = "View assigned properties"
        override val agencyCapabilityHostAssignedOpenings: String = "Host assigned openings"
        override val agencyCapabilitySeeAssignedLeads: String = "See leads from assigned properties and openings"
        override val agencyCapabilityAddNotes: String = "Add notes"
        override val agencyCapabilitySendFollowUps: String = "Send follow-ups"
        override val agencyCapabilityCreateSellerReports: String = "Create seller reports for assigned listings"
        override val agencyCapabilityEditAssignedLeads: String = "Edit assigned leads"
        override val agencyCapabilityPrepareFollowUps: String = "Prepare follow-ups"
        override val agencyCapabilityCreateDraftReports: String = "Create draft reports"
        override val agencyCapabilityCannotDeleteProperties: String = "Cannot delete properties"
        override val agencyCapabilityCannotInviteAgents: String = "Cannot invite agents unless allowed"
        override val agencyCapabilityViewDashboards: String = "View dashboards"
        override val agencyCapabilityViewReports: String = "View reports"
        override val agencyCapabilityCannotEdit: String = "Cannot edit anything"
        override val commonVisitors: String = "Leads"
        override val commonHot: String = "Hot"
        override val commonWarm: String = "Warm"
        override val commonCold: String = "Cold"
        override val commonActive: String = "Activo"
        override val commonPlanned: String = "Planificado"
        override val commonArchived: String = "Archivado"
        override val commonPast: String = "Pasadas"
        override val commonFollowUps: String = "Follow-ups"
        override val commonProperty: String = "Propiedad"
        override val commonAddress: String = "Dirección"
        override val commonOpenHouse: String = "Opening"
        override val commonCheckedIn: String = "Checked in"
        override val commonNotScheduled: String = "not scheduled"
        override val todayTitle: String = "Today"
        override val todaySubtitle: String = "Your daily workspace for openings, leads, follow-ups, and seller-ready momentum."
        override val todayOpenHousesMetric: String = "openings"
        override val capturedMetric: String = "captured"
        override val priorityMetric: String = "priority"
        override val noActivePropertiesTitle: String = "No active properties"
        override val noActivePropertiesBody: String = "Add or activate a property to make it appear on Today."
        override val checkIns: String = "Check-ins"
        override val allOpenHouses: String = "all openings"
        override val pendingDrafts: String = "pending drafts"
        override val priorityLead: String = "Priority lead"
        override val nextOpenHouseAt: String = "Next opening at"
        override val noOpenHouseScheduled: String = "No opening scheduled"
        override val personalAccount: String = "Cuenta personal"
        override val accountReady: String = "Tu cuenta está lista"
        override val realEstateApp: String = "App inmobiliaria"
        override val needHelp: String = "¿Necesitas ayuda?"
        override val contactSupport: String = "Contactar soporte"
        override val upgradePlan: String = "Mejorar plan"
        override val planSuffix: String = "Plan"
        override val todayActionsTitle: String = "Prioridades de hoy"
        override val whatOpeningNext: String = "¿Cuál es la próxima apertura?"
        override val whoCheckedIn: String = "¿Quién se registró?"
        override val whoNeedsFollowUp: String = "¿Quién necesita seguimiento?"
        override val whatShouldIDoNow: String = "¿Qué debo hacer ahora?"
        override val noCheckInsYet: String = "Todavía no se registró ningún contacto."
        override val noPendingFollowUps: String = "No hay seguimientos pendientes ahora."
        override val openKioskForNextOpening: String = "Abre el kiosco para la próxima apertura."
        override val reviewNewLeads: String = "Revisa nuevos leads y envía seguimientos."
        override val createOpeningToStart: String = "Crea una apertura desde una propiedad para empezar a captar leads."
        override val addFirstPropertyToStart: String = "Agrega tu primera propiedad para empezar."
        override val nextOpening: String = "Próxima apertura"
        override val quickSignIn: String = "Registro rápido"
        override val scanQrCode: String = "Escanear QR"
        override val newLead: String = "Nuevo lead"
        override val myProperties: String = "Mis propiedades"
        override val manageListings: String = "Gestionar anuncios"
        override val todaysOverview: String = "Resumen de hoy"
        override val seeAll: String = "Ver todo"
        override val propertiesEyebrow: String = "Portfólio"
        override val propertiesSubtitle: String = "Manage active, planned, and archived listings with Supabase-backed media and performance intelligence."
        override val propertiesLiveMetric: String = "live"
        override val propertiesPipelineMetric: String = "pipeline"
        override val propertiesAllTimeMetric: String = "all time"
        override val addProperty: String = "Anadir propiedad"
        override val editProperty: String = "Editar propiedad"
        override val propertyFallback: String = "Property"
        override val propertyUnavailableTitle: String = "Propiedad no disponible"
        override val propertyUnavailableBody: String = "Refresh the portfolio to reload this listing."
        override val backToProperties: String = "Volver a propiedades"
        override val deletePropertyTitle: String = "¿Eliminar propiedad?"
        override val deletePropertyBody: String = "This will permanently delete the property and its related local records. This cannot be undone."
        override val loadingProperties: String = "Cargando propiedades"
        override val noPropertiesTitle: String = "Aún no hay propiedades"
        override val noPropertiesBody: String = "Add your first property, then create an opening to start collecting leads and seller-ready feedback."
        override val openHouseButton: String = "Crear apertura"
        override val photosTitle: String = "Photos"
        override val photosBody: String = "The first photo is used as the main property image across Portfolio."
        override val uploadPhoto: String = "Subir foto"
        override val noPhotosYet: String = "Aún no se han subido fotos."
        override val mainPhoto: String = "Principal"
        override val propertyTitleLabel: String = "Nombre de la propiedad"
        override val propertyAddressLine1Label: String = "Dirección"
        override val propertyAddressLine2Label: String = "Dirección línea 2"
        override val propertyCityLabel: String = "Ciudad"
        override val propertyRegionLabel: String = "Región"
        override val propertyPostalCodeLabel: String = "Código postal"
        override val propertyCountryLabel: String = "País"
        override val propertyAskingPriceLabel: String = "Precio solicitado"
        override val propertyBedsLabel: String = "Habitaciones"
        override val propertyBathsLabel: String = "Baños"
        override val propertyInteriorLabel: String = "Interior"
        override val propertyDescriptionLabel: String = "Descripción"
        override val createPropertyButton: String = "+ Crear propiedad"
        override val locateProperty: String = "Localizar propiedad"
        override val findLocation: String = "Buscar ubicación"
        override val find: String = "Buscar"
        override val navigate: String = "Navegar"
        override val propertyLocationMarkerTitle: String = "Ubicación de la propiedad"
        override val mapKitJsMissingToken: String = "Añade HAVN_MAPKIT_JS_TOKEN a local.properties para el mapa web."
        override val mapKitJsLoading: String = "Cargando MapKit JS..."
        override val generateSellerReport: String = "Generar informe para vendedor"
        override val deleteProperty: String = "Eliminar propiedad"
        override val conversionMetric: String = "Conversión"
        override val propertyPhotoContentDescription: String = "Foto de la propiedad"
        override val deletePhoto: String = "Eliminar foto"
        override val movePhotoLeft: String = "Mover foto a la izquierda"
        override val movePhotoRight: String = "Mover foto a la derecha"
        override val propertyTitleRequired: String = "El nombre de la propiedad es obligatorio."
        override val propertyStreetRequired: String = "La dirección es obligatoria."
        override val propertyCityRequired: String = "La ciudad es obligatoria."
        override val propertyRegionRequired: String = "La región es obligatoria."
        override val propertyPostalRequired: String = "El código postal es obligatorio."
        override val propertyAskingPriceInvalid: String = "Introduce un precio solicitado válido."
        override val propertyOwnerContactTitle: String = "Contacto del propietario"
        override val propertyOwnerSelectContact: String = "Selecciona un contacto existente como propietario de la propiedad."
        override val propertyOwnerSelected: String = "Propietario seleccionado"
        override val propertyOwnerNoContacts: String = "Todavía no hay contactos. Añade el propietario en Contactos y selecciónalo aquí."
        override val propertyOwnerChooseContact: String = "Elegir contacto"
        override val propertyOwnerChangeContact: String = "Cambiar contacto"
        override val propertyOwnerRemoveContact: String = "Quitar"
        override val propertyOwnerPickerTitle: String = "Elegir propietario de la propiedad"
        override val propertyOwnerSearchContact: String = "Buscar contactos"
        override val propertyOwnerSearchHint: String = "Empieza a escribir un nombre, email o teléfono."
        override val propertyOwnerNoMatches: String = "No hay contactos coincidentes."
        override val propertyOpeningsTitle: String = "Openings"
        override val propertyNoOpenings: String = "No openings scheduled for this property."
        override val teamAccessTitle: String = "Team access"
        override val onlyListingOwner: String = "Only the listing owner"
        override val assignTeam: String = "Assign team"
        override val assignPropertyTitle: String = "Assign property"
        override val assignPropertyBody: String = "Choose who can work this property. Select the whole team or specific agents."
        override val wholeTeam: String = "Whole team"
        override val leadsEyebrow: String = "Leads"
        override val leadFallback: String = "Lead"
        override val leadsSubtitle: String = "Search, filter, and qualify leads captured across every opening."
        override val leadDetailSubtitle: String = "Source, qualification, notes, and follow-up history for this opening lead."
        override val totalMetric: String = "Total"
        override val loggedMetric: String = "logged"
        override val searchLeads: String = "Search leads"
        override val searchLeadsPlaceholder: String = "Name, phone, or email"
        override val allProperties: String = "All properties"
        override val loadingLeads: String = "Loading opening leads"
        override val noLeadsFoundTitle: String = "Los leads aparecerán aquí cuando los contactos se registren en una apertura."
        override val noLeadsEmptyBody: String = "Usa el registro del kiosco o agrega contactos manualmente desde una apertura."
        override val noLeadsFilteredBody: String = "Try a different property, status, or search term."
        override val backToLeads: String = "Back to leads"
        override val leadUnavailableTitle: String = "Lead unavailable"
        override val leadUnavailableBody: String = "This lead is no longer available in the current lead list."
        override val leadTemperature: String = "Lead status"
        override val leadLabelSuffix: String = "Lead"
        override val greetingHi: String = "Hola"
        override val leadActionCall: String = "Llamar"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "E-mail"
        override val leadFollowUp: String = "Seguimiento"
        override val leadNoFollowUpScheduled: String = "No hay seguimiento programado"
        override val leadIntentScore: String = "Puntuación de interés"
        override val leadInterestedIn: String = "Interés en"
        override val leadGenericGreetingName: String = "hola"
        override val followUpMessageTypeThankYou: String = "Gracias"
        override val followUpMessageTypePropertyInfo: String = "Info de propiedad"
        override val followUpMessageTypeFollowUp: String = "Seguimiento"
        override val followUpMessageTypeCheckIn: String = "Consultar interés"
        override val followUpMessageTypePriceUpdate: String = "Actualización de precio"
        override val followUpMessageTypePropertyBrochure: String = "Fotos"
        override val followUpPreview: String = "Vista previa"
        override val followUpSubject: String = "Asunto"
        override val followUpMessage: String = "Mensaje"
        override val followUpSendViaEmail: String = "Enviar por e-mail"
        override val followUpSendViaSms: String = "Enviar por SMS"
        override val followUpAiAssistantTitle: String = "Asistente IA"
        override val followUpAiAssistantBody: String = "Genera un mensaje personalizado en segundos."
        override val followUpGenerateWithAi: String = "Generar con IA"
        override val followUpUpgradeForAi: String = "Desbloquear IA"
        override val followUpDefaultSubject: String = "Seguimiento sobre"
        override val privateAgentNotes: String = "Private agent notes"
        override val notes: String = "Notes"
        override val notesPlaceholder: String = "Motivation, preferences, objections, next move"
        override val saveNotes: String = "Save notes"
        override val followUpHistory: String = "Follow-up history"
        override val noFollowUpsLogged: String = "No follow-ups logged yet."
        override val openHousesEyebrow: String = "Showings"
        override val scheduleOpenHouse: String = "Crear visita"
        override val openingDetails: String = "Detalles de apertura"
        override val editOpening: String = "Editar apertura"
        override val deleteOpening: String = "Eliminar apertura"
        override val deleteOpeningBody: String = "¿Seguro que quieres eliminar esta apertura? Esta acción no se puede deshacer."
        override val openingName: String = "Nombre de apertura"
        override val startsAt: String = "Empieza"
        override val endsAt: String = "Termina"
        override val chooseStartDateTime: String = "Elige fecha y hora de inicio"
        override val chooseEndDateTime: String = "Elige fecha y hora de fin"
        override val accessNotes: String = "Notas de acceso"
        override val privateNotes: String = "Notas privadas"
        override val addPrivateNote: String = "Agregar nota privada"
        override val liveDashboard: String = "Live dashboard"
        override val visitorKiosk: String = "Lead kiosk"
        override val openHousesSubtitle: String = "Create openings for properties, review leads, and launch kiosk sessions."
        override val liveMetric: String = "Live"
        override val upcomingMetric: String = "Upcoming"
        override val inProgressMetric: String = "in progress"
        override val scheduledMetric: String = "scheduled"
        override val loadingOpenHouses: String = "Loading openings"
        override val addPropertyFirstTitle: String = "Add a property first"
        override val addPropertyFirstBody: String = "Create an opening from a property to start collecting leads."
        override val noOpenHousesTitle: String = "No openings scheduled"
        override val noOpenHousesBody: String = "Create an opening from a property to start collecting leads."
        override val noSignInsTitle: String = "No sign-ins yet"
        override val noSignInsBody: String = "Leads checked in through kiosk mode will appear here in real time."
        override val dashboard: String = "Dashboard"
        override val start: String = "Start"
        override val end: String = "End"
        override val endOpenHouse: String = "End opening"
        override val reportsEyebrow: String = "Owners"
        override val sellerReportsTitle: String = "Seller reports"
        override val createReport: String = "Create report"
        override val reportPreview: String = "Property Report"
        override val reportsSubtitle: String = "Generate premium post-opening recaps with lead quality, buyer intent, and seller-ready narrative."
        override val reportsMetricSaved: String = "saved"
        override val reportedMetric: String = "reported"
        override val leadsMetric: String = "leads"
        override val createSellerReport: String = "Create seller report"
        override val attendance: String = "Attendance"
        override val savedReports: String = "saved reports"
        override val buyerHeat: String = "Buyer heat"
        override val hotLeads: String = "hot leads"
        override val loadingSellerReports: String = "Loading seller reports"
        override val noSellerReportsTitle: String = "No seller reports yet"
        override val noSellerReportsBody: String = "Choose an opening, add agent notes, preview an export-ready recap, then save it."
        override val chooseOpenHouse: String = "Choose opening"
        override val noOpenHousesAvailable: String = "No openings available yet."
        override val agentNotes: String = "Agent notes"
        override val notesForSeller: String = "Notes for seller"
        override val sellerNotesPlaceholder: String = "Buyer objections, pricing signals, showing feedback, recommended next move"
        override val generatePreview: String = "Generate preview"
        override val noPreviewReadyTitle: String = "No preview ready"
        override val noPreviewReadyBody: String = "Generate a seller report preview before saving."
        override val saveReport: String = "Save report"
        override val reportSaved: String = "Report saved"
        override val sellerOpenHouseReport: String = "Seller opening report"
        override val mostCommonBuyerInterest: String = "Most common buyer interest"
        override val followUpsSent: String = "Follow-ups sent"
        override val summary: String = "Summary"
        override val noPrivateNotesAdded: String = "No private notes added."
        override val openHouseReport: String = "Opening report"
        override val searchProperties: String = "Buscar propiedades"
        override val searchOpenings: String = "Buscar visitas"
        override val noOpeningsFoundTitle: String = "No openings found"
        override val noOpeningsFoundBody: String = "Try another search or opening status filter."
        override val noMatchingPropertiesTitle: String = "No matching properties"
        override val noMatchingPropertiesBody: String = "Try another search or status filter."
        override val clientsTitle: String = "Contactos"
        override val clientFallback: String = "Contatto"
        override val addClient: String = "Añadir contacto"
        override val editClient: String = "Editar contacto"
        override val newClient: String = "Nuevo contacto"
        override val saveClient: String = "Guardar contacto"
        override val createClient: String = "Crear contacto"
        override val deleteClientTitle: String = "Delete contact?"
        override val deleteClientBody: String = "This will permanently delete the contact. This cannot be undone."
        override val firstName: String = "Nombre"
        override val lastName: String = "Apellido"
        override val email: String = "Email"
        override val phone: String = "Teléfono"
        override val comments: String = "Comentarios"
        override val addPhoto: String = "Add photo"
        override val sendQr: String = "Send QR"
        override val photo: String = "Photo"
        override val clientDetailSubtitle: String = "QR identity, contact details, comments, and openings connected through leads."
        override val clientFormEditSubtitle: String = "Update contact details, delivery info, and comments."
        override val clientFormNewSubtitle: String = "Register a buyer/contact and generate a reusable QR identity for openings."
        override val searchClients: String = "Buscar contactos"
        override val noClientsYetTitle: String = "No contacts yet"
        override val noClientsYetBody: String = "Register contacts first, then send their QR code by email or SMS before an opening."
        override val noClientsFoundTitle: String = "No contacts found"
        override val noClientsFoundBody: String = "Try another name, phone, or email."
        override val clientUnavailableTitle: String = "Contact unavailable"
        override val clientUnavailableBody: String = "Refresh the contacts list and open this record again."
        override val noCommentsAdded: String = "No comments added."
        override val openingsTitle: String = "Visitas"
        override val clientOpeningsEmpty: String = "No openings connected yet. Leads connect a contact to an opening."
        override val clientPassLabel: String = "Pass"
        override val clientNoEmail: String = "No email"
        override val visitorsBody: String = "Open kiosk mode, scan a contact QR, or add existing contacts as leads for this opening."
        override val openKiosk: String = "Abrir kiosco"
        override val addQrClient: String = "Añadir contacto QR"
        override val addManually: String = "Añadir manualmente"
        override val selectClients: String = "Seleccionar contactos"
        override val selectClientsBody: String = "Choose contacts from your list. Each selected contact becomes a lead for this opening."
        override val kioskCheckIn: String = "Kiosk check-in"
        override val kioskCheckInBody: String = "Use the rear camera to scan the contact's HAVN Wallet QR. When the code is recognized, HAVN creates the lead for this opening automatically."
        override val scanWithCamera: String = "Scan with rear camera"
        override val clientQrImage: String = "Contact QR image"
        override val clientQrImageBody: String = "Keep the contact's QR inside the gold square. HAVN collects each scan below."
        override val scanMultipleQrBody: String = "Scan one or more HAVN contact QR codes, then tap Add QR contact."
        override val scannedQrReady: String = "contact QR ready to add"
        override val createLeadFromQr: String = "Create lead from QR"
        override val noClientsFoundShort: String = "No contacts found."
        override val remove: String = "Quitar"
    }

    private val italian: HavnStrings = object : HavnStrings {
        override val navToday: String = "Oggi"
        override val navProperties: String = "Immobili"
        override val navLeads: String = "Leads"
        override val navReports: String = "Report"
        override val navSettings: String = "Impostazioni"
        override val navAuth: String = "Accesso agente"
        override val navOpenHouses: String = "Visite"
        override val navTours: String = "Visite"
        override val navFollowUps: String = "Contatti"
        override val navFollow: String = "Contatti"
        override val back: String = "Indietro"
        override val settingsEyebrow: String = "Area di lavoro"
        override val settingsTitle: String = "Impostazioni"
        override val settingsSubtitle: String = "Profilo, lingua, unita, ambiente e opzioni del team."
        override val agentProfileTitle: String = "Profilo agente"
        override val agentPhoto: String = "Foto agente"
        override val uploading: String = "Caricamento..."
        override val saving: String = "Salvataggio..."
        override val validAgentPhotoRequired: String = "Scegli una foto agente valida."
        override val signOut: String = "Esci"
        override val signOutQuestion: String = "Uscire?"
        override val signOutConfirmation: String = "Vuoi davvero uscire da HAVN?"
        override val upgrade: String = "Upgrade"
        override val premiumThemesTitle: String = "Temi premium"
        override val premiumThemesUpgradePrompt: String = "Passa a Pro per sbloccare i temi premium."
        override val appearanceTitle: String = "Aspetto"
        override val appearanceBody: String = "Scegli un tema HAVN selezionato. I temi premium si sbloccano con Pro."
        override val previewComponents: String = "Anteprima componenti"
        override val themeShowcaseTitle: String = "Anteprima tema"
        override val showcaseButtons: String = "Pulsanti"
        override val showcasePrimaryAction: String = "Azione principale"
        override val showcaseSecondaryAction: String = "Azione secondaria"
        override val showcaseGhostAction: String = "Azione discreta"
        override val showcaseTextField: String = "Campo testo"
        override val showcaseFocusedBorder: String = "Bordo evidenziato"
        override val showcaseSearchPreview: String = "Anteprima ricerca"
        override val showcaseOpeningCheckedIn: String = "Check-in a un’apertura oggi"
        override val showcaseSentAt: String = "Inviato alle 10:30"
        override val themeObsidianGoldName: String = "Obsidian Gold"
        override val themeObsidianGoldDescription: String = "Nero di lusso, grafite e oro caldo."
        override val themeMidnightSapphireName: String = "Midnight Sapphire"
        override val themeMidnightSapphireDescription: String = "Blu notte, zaffiro e accenti argento."
        override val themeEmeraldEstateName: String = "Emerald Estate"
        override val themeEmeraldEstateDescription: String = "Smeraldo scuro, carbone e oro champagne."
        override val themePlatinumStoneName: String = "Platinum Stone"
        override val themePlatinumStoneDescription: String = "Grigio pietra, platino e bianco morbido."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Vino scuro, grafite e accenti rame."
        override val commonChange: String = "Cambia"
        override val agentPlanTitle: String = "Piano agente"
        override val agentPlanBody: String = "Migliora la tua esperienza e scegli il piano più adatto al tuo modo di lavorare."
        override val currentPlan: String = "Piano attuale"
        override val transferPlan: String = "Trasferisci piano"
        override val restorePurchase: String = "Ripristina acquisto"
        override val agencySettingsProBody: String = "Solo agency è attiva per impostazione predefinita. Pro permette di creare o selezionare un’agenzia condivisa."
        override val agencySettingsLockedBody: String = "Solo agency è attiva. Le modifiche all’agenzia si sbloccano con Pro."
        override val soloAgency: String = "Solo agency"
        override val defaultPrivateAgencyWorkspace: String = "Agenzia privata predefinita"
        override val noAgenciesAvailableYet: String = "Non ci sono ancora inviti o agenzie possedute disponibili."
        override val oneOwnedAgencyHint: String = "La tua agenzia è elencata sopra. Un agente può possedere una sola agenzia."
        override val createAgency: String = "Crea agenzia"
        override val createYourAgency: String = "Crea la tua agenzia"
        override val createAgencyBody: String = "Costruisci il tuo team, gestisci proprietà insieme e fai crescere il tuo business."
        override val agencyName: String = "Nome agenzia"
        override val agencyEmail: String = "Email agenzia"
        override val logoOptional: String = "Logo (opzionale)"
        override val upgradeExperienceTitle: String = "Migliora la tua esperienza"
        override val upgradeExperienceSubtitle: String = "Scegli il piano più adatto al tuo modo di lavorare."
        override val soloAgentPlan: String = "Solo agent"
        override val proAgentPlan: String = "Pro agent"
        override val soloBenefitActiveProperties: String = "Fino a 5 proprietà attive"
        override val soloBenefitAiFollowUps: String = "Follow-up AI (base)"
        override val soloBenefitSellerReports: String = "Report venditore luxury (base)"
        override val soloBenefitPersonalOnly: String = "Solo account personale"
        override val proBenefitUnlimitedProperties: String = "Proprietà illimitate"
        override val proBenefitUnlimitedAi: String = "Follow-up AI (illimitati)"
        override val proBenefitAdvancedReports: String = "Report venditore avanzati"
        override val proBenefitAgencyCreation: String = "Creazione e gestione agenzia"
        override val proBenefitInviteAgents: String = "Invita agenti e collabora"
        override val proBenefitSharedLeads: String = "Lead condivisi e workflow team"
        override val proBenefitAgencyBranding: String = "Branding agenzia"
        override val proBenefitAdvancedAnalytics: String = "Analisi avanzate"
        override val startFreeTrial7Day: String = "Abbonati ora"
        override val restorePurchases: String = "Ripristina acquisti"
        override val comparePlans: String = "Confronta piani"
        override val startFreeTrial: String = "Scegli piano"
        override val noCommitmentCancelAnytime: String = "Nessun impegno. Annulla quando vuoi."
        override val monthly: String = "Monthly"
        override val yearly: String = "Yearly"
        override val yearlySave20: String = "Yearly - save 20%"
        override val yearlySavings20: String = "Yearly saves 20% compared to monthly."
        override val perYear: String = "/ year"
        override val loadingPlans: String = "Loading plans..."
        override val selectedPlanUnavailable: String = "This plan is not available yet. Check RevenueCat offerings and product identifiers."
        override val signInRequiredForPurchase: String = "Sign in before starting a purchase."
        override val compareActiveProperties: String = "Proprietà attive"
        override val compareAiFollowUps: String = "Follow-up AI"
        override val compareSellerReports: String = "Report venditore"
        override val compareAdvancedAnalytics: String = "Analisi avanzate"
        override val compareAgencyCreation: String = "Creazione agenzia"
        override val compareJoinAgencies: String = "Unisciti ad agenzie"
        override val compareInviteAgents: String = "Invita agenti"
        override val compareSharedLeads: String = "Lead condivisi"
        override val compareAgencyBranding: String = "Branding agenzia"
        override val comparePrioritySupport: String = "Supporto prioritario"
        override val unlimited: String = "Illimitato"
        override val basic: String = "Base"
        override val advanced: String = "Avanzato"
        override val perMonth: String = "/ mese"
        override val members: String = "membri"
        override val upgradeToProForAgencyTools: String = "Passa a Pro per usare gli strumenti agenzia"
        override val languageTitle: String = "Lingua"
        override val languageBody: String = "Scegli la lingua dell'app per questo dispositivo."
        override val english: String = "English"
        override val slovak: String = "Slovak"
        override val unitsTitle: String = "Unita e valuta"
        override val unitsBody: String = "Scegli come mostrare prezzi e superfici nell'app."
        override val measurementSystemTitle: String = "Misura"
        override val metric: String = "Metrico"
        override val imperial: String = "Imperiale"
        override val currencyTitle: String = "Valuta"
        override val notificationsTitle: String = "Notifications"
        override val notificationsBody: String = "Control push alerts, quiet hours, and the types of updates HAVN can send."
        override val notificationSettings: String = "Notification settings"
        override val notificationsSubtitle: String = "Only important updates, filtered by your preferences."
        override val quietHoursTitle: String = "Quiet hours"
        override val quietHoursBody: String = "HAVN skips non-critical pushes during quiet hours. Billing and account issues still stay concise."
        override val enableQuietHours: String = "Enable quiet hours"
        override val quietHoursStart: String = "Start"
        override val quietHoursEnd: String = "End"
        override val timezoneLabel: String = "Timezone"
        override val notificationTypesTitle: String = "Notification types"
        override val notificationNewLeadCapturedTitle: String = "New lead captured"
        override val notificationNewLeadCapturedBody: String = "When an opening or QR flow captures a lead."
        override val notificationHotLeadTitle: String = "Lead marked as hot"
        override val notificationHotLeadBody: String = "Only when a lead becomes high intent."
        override val notificationOpeningStartsSoonTitle: String = "Opening starts soon"
        override val notificationOpeningStartsSoonBody: String = "A single reminder 30 minutes before start."
        override val notificationOpeningSummaryReadyTitle: String = "Opening summary ready"
        override val notificationOpeningSummaryReadyBody: String = "When the post-event summary is ready."
        override val notificationSellerReportGeneratedTitle: String = "Seller report generated"
        override val notificationSellerReportGeneratedBody: String = "When a seller report has been created."
        override val notificationAiFollowUpReadyTitle: String = "AI follow-up ready"
        override val notificationAiFollowUpReadyBody: String = "When a follow-up draft is ready to review."
        override val notificationAgentInvitedTitle: String = "Agent invited to agency"
        override val notificationAgentInvitedBody: String = "Agency invitations and membership changes."
        override val notificationLeadAssignedTitle: String = "Lead assigned to you"
        override val notificationLeadAssignedBody: String = "When a teammate assigns a lead to you."
        override val notificationLeadTransferredTitle: String = "Lead transferred to you"
        override val notificationLeadTransferredBody: String = "When ownership of a lead moves to you."
        override val notificationSubscriptionIssueTitle: String = "Subscription issue"
        override val notificationSubscriptionIssueBody: String = "Renewal failures and billing problems."
        override val kioskSecurityTitle: String = "Kiosk security"
        override val kioskSecurityBody: String = "Use this PIN to leave kiosk mode and return to the agent app."
        override val kioskPinLabel: String = "Kiosk PIN"
        override val kioskFeaturedProperty: String = "Featured property"
        override val kioskPrivateShowing: String = "Private showing"
        override val kioskLuxuryListing: String = "Luxury listing"
        override val kioskFastCheckIn: String = "Fast check-in"
        override val kioskExitContentDescription: String = "Exit kiosk"
        override val kioskWelcome: String = "Welcome"
        override val kioskGladHere: String = "We’re glad you’re here."
        override val kioskScanToCheckIn: String = "Scan to check in"
        override val kioskReceivePropertyDetails: String = "and receive property details"
        override val kioskOr: String = "Or"
        override val kioskStartCheckInManually: String = "Start check-in manually"
        override val kioskSecureInfo: String = "Your information is secure and will never be shared."
        override val kioskExitTitle: String = "Exit kiosk"
        override val kioskExitBody: String = "Enter the kiosk PIN to return to the agent app."
        override val kioskIncorrectPin: String = "Incorrect PIN."
        override val kioskUnlock: String = "Unlock"
        override val kioskTellUsTitle: String = "Tell us about yourself"
        override val kioskTellUsBody: String = "Your information goes only to the hosting agent."
        override val kioskFullName: String = "Full name"
        override val kioskContinue: String = "Continue"
        override val kioskQuestionsTitle: String = "A couple quick questions"
        override val kioskQuestionsBody: String = "This helps the agent follow up with the right context."
        override val kioskWorkingWithAgentQuestion: String = "Are you working with an agent?"
        override val kioskYes: String = "Yes"
        override val kioskNo: String = "No"
        override val kioskInterestQuestion: String = "What are you interested in?"
        override val kioskInterestBuying: String = "Buying"
        override val kioskInterestInvesting: String = "Investing"
        override val kioskInterestBrowsing: String = "Just browsing"
        override val kioskInterestRelocating: String = "Relocating"
        override val kioskFinish: String = "Finish"
        override val kioskThankYou: String = "Thank you"
        override val kioskEnjoyVisitPrefix: String = "Enjoy your visit at"
        override val kioskResetAutomatically: String = "This kiosk will reset automatically."
        override val environmentTitle: String = "Environment"
        override val environmentBody: String = "Local Supabase is configured for development. Production values should move behind build-time configuration."
        override val secure: String = "Secure"
        override val brokerageProfileTitle: String = "Brokerage profile"
        override val brokerageProfileBody: String = "Team branding, agent invites, and notification preferences will live here."
        override val logout: String = "Esci"
        override val languageChanged: String = "Language changed"
        override val commonAdd: String = "Aggiungi"
        override val commonEdit: String = "Modifica"
        override val commonDelete: String = "Elimina"
        override val commonCancel: String = "Annulla"
        override val commonSave: String = "Salva"
        override val commonCreate: String = "Crea"
        override val commonDismiss: String = "Dismiss"
        override val commonAll: String = "Tutto"
        override val commonDone: String = "Fatto"
        override val commonTime: String = "Ora"
        override val commonHour: String = "Ora"
        override val commonMinute: String = "Minuto"
        override val commonAgency: String = "Agenzia"
        override val commonSettings: String = "Impostazioni"
        override val commonOpening: String = "Apertura"
        override val commonPropertyName: String = "Immobile"
        override val commonToday: String = "Oggi"
        override val agencyToolsAvailable: String = "Gli strumenti agenzia sono disponibili."
        override val agencySetupSubtitle: String = "Ogni account HAVN ha un’agenzia predefinita. Pro consente di gestire inviti, lead condivisi e branding."
        override val agencyRecentActivity: String = "Recent activity"
        override val agencyActivityNewLead: String = "New lead added"
        override val agencyActivityInvitationAccepted: String = "Agent invitation accepted"
        override val agencyActivityAgentJoined: String = "Agent joined the agency"
        override val agencyActivitySellerReport: String = "Seller report created"
        override val agencyWorkspaceTitle: String = "Agency workspace"
        override val agencyWorkspaceBody: String = "Choose which agency you are working with."
        override val agencySoloActiveTitle: String = "Solo agency is active"
        override val agencyProRequiredTitle: String = "Pro plan required"
        override val agencyCreateOrAcceptInviteBody: String = "Create your agency workspace or accept an invite to collaborate with another agency."
        override val agencyProUnlockBody: String = "Agency changes, invites, shared leads, and shared branding unlock with Pro."
        override val realEstate: String = "Real estate"
        override val proAgency: String = "Pro agency"
        override val agencyBrandingTitle: String = "Agency branding"
        override val agencyBrandingBody: String = "Set the agency name and logo shown in the app, kiosk, and shared workspace."
        override val uploadLogo: String = "Upload logo"
        override val saveAgency: String = "Save agency"
        override val yourAgencyRole: String = "Your agency role"
        override val agencyAgentsTitle: String = "Agency agents"
        override val agencyAgentsBody: String = "People eligible to work with this agency."
        override val inviteAgent: String = "Invite agent"
        override val loadingAgents: String = "Loading agents..."
        override val noAgencyAgentsYet: String = "No agency agents yet."
        override val changeRole: String = "Change role"
        override val updating: String = "Updating..."
        override val deleting: String = "Deleting..."
        override val deleteInvite: String = "Delete invite"
        override val chooseAgencyRoleFor: String = "Choose the agency role for"
        override val removeAccess: String = "Remove access"
        override val inviteAgentBody: String = "Send an agency invitation by email. The agent accepts after signing in with the same email."
        override val agentEmail: String = "Agent email"
        override val role: String = "Role"
        override val inviting: String = "Inviting..."
        override val invite: String = "Invite"
        override val agents: String = "Agents"
        override val ok: String = "Ok"
        override val personalActivePropertyLimit: String = "Personal active property limit"
        override val personalAccountAgencyToolsLocked: String = "Personal account is active. Agency tools unlock with Pro."
        override val selected: String = "Selected"
        override val activeMembers: String = "active members"
        override val agencySharedWorkspaceBody: String = "Shared properties, contacts, openings, leads, follow-ups, and reports use this agency workspace."
        override val agencyRoleOwner: String = "Owner"
        override val agencyRoleAdmin: String = "Admin"
        override val agencyRoleAgent: String = "Agent"
        override val agencyRoleAssistant: String = "Assistant"
        override val agencyRoleViewer: String = "Viewer"
        override val agencyRoleOwnerDescription: String = "Full agency control, including members, branding, assignments, listings, leads, and reports."
        override val agencyRoleAdminDescription: String = "Full agency management except deleting the agency."
        override val agencyRoleAgentDescription: String = "Works assigned listings, openings, leads, follow-ups, notes, and seller reports."
        override val agencyRoleAssistantDescription: String = "Supports assigned listings by editing leads, preparing follow-ups, and drafting reports."
        override val agencyRoleViewerDescription: String = "Read-only access to dashboards and reports."
        override val agencyCapabilityInviteRemoveMembers: String = "Invite and remove members"
        override val agencyCapabilityChangeRoles: String = "Change member roles"
        override val agencyCapabilityManageAllProperties: String = "Create, edit, and delete all properties"
        override val agencyCapabilityAssignAgents: String = "Assign agents"
        override val agencyCapabilitySeeAllLeads: String = "See all leads"
        override val agencyCapabilityExportReports: String = "Export reports"
        override val agencyCapabilityChangeBranding: String = "Change agency branding and settings"
        override val agencyCapabilityDeleteAgency: String = "Delete agency"
        override val agencyCapabilityViewAssignedProperties: String = "View assigned properties"
        override val agencyCapabilityHostAssignedOpenings: String = "Host assigned openings"
        override val agencyCapabilitySeeAssignedLeads: String = "See leads from assigned properties and openings"
        override val agencyCapabilityAddNotes: String = "Add notes"
        override val agencyCapabilitySendFollowUps: String = "Send follow-ups"
        override val agencyCapabilityCreateSellerReports: String = "Create seller reports for assigned listings"
        override val agencyCapabilityEditAssignedLeads: String = "Edit assigned leads"
        override val agencyCapabilityPrepareFollowUps: String = "Prepare follow-ups"
        override val agencyCapabilityCreateDraftReports: String = "Create draft reports"
        override val agencyCapabilityCannotDeleteProperties: String = "Cannot delete properties"
        override val agencyCapabilityCannotInviteAgents: String = "Cannot invite agents unless allowed"
        override val agencyCapabilityViewDashboards: String = "View dashboards"
        override val agencyCapabilityViewReports: String = "View reports"
        override val agencyCapabilityCannotEdit: String = "Cannot edit anything"
        override val commonVisitors: String = "Lead"
        override val commonHot: String = "Hot"
        override val commonWarm: String = "Warm"
        override val commonCold: String = "Cold"
        override val commonActive: String = "Attivo"
        override val commonPlanned: String = "Pianificato"
        override val commonArchived: String = "Archiviato"
        override val commonPast: String = "Passate"
        override val commonFollowUps: String = "Follow-ups"
        override val commonProperty: String = "Immobile"
        override val commonAddress: String = "Indirizzo"
        override val commonOpenHouse: String = "Opening"
        override val commonCheckedIn: String = "Checked in"
        override val commonNotScheduled: String = "not scheduled"
        override val todayTitle: String = "Today"
        override val todaySubtitle: String = "Your daily workspace for openings, leads, follow-ups, and seller-ready momentum."
        override val todayOpenHousesMetric: String = "openings"
        override val capturedMetric: String = "captured"
        override val priorityMetric: String = "priority"
        override val noActivePropertiesTitle: String = "No active properties"
        override val noActivePropertiesBody: String = "Add or activate a property to make it appear on Today."
        override val checkIns: String = "Check-ins"
        override val allOpenHouses: String = "all openings"
        override val pendingDrafts: String = "pending drafts"
        override val priorityLead: String = "Priority lead"
        override val nextOpenHouseAt: String = "Next opening at"
        override val noOpenHouseScheduled: String = "No opening scheduled"
        override val personalAccount: String = "Account personale"
        override val accountReady: String = "Il tuo account è pronto"
        override val realEstateApp: String = "App immobiliare"
        override val needHelp: String = "Hai bisogno di aiuto?"
        override val contactSupport: String = "Contatta il supporto"
        override val upgradePlan: String = "Aggiorna piano"
        override val planSuffix: String = "Piano"
        override val todayActionsTitle: String = "Priorità di oggi"
        override val whatOpeningNext: String = "Qual è la prossima apertura?"
        override val whoCheckedIn: String = "Chi ha effettuato il check-in?"
        override val whoNeedsFollowUp: String = "Chi necessita di follow-up?"
        override val whatShouldIDoNow: String = "Cosa devo fare ora?"
        override val noCheckInsYet: String = "Nessun contatto ha ancora effettuato il check-in."
        override val noPendingFollowUps: String = "Nessun follow-up in sospeso al momento."
        override val openKioskForNextOpening: String = "Apri il kiosk per la prossima apertura."
        override val reviewNewLeads: String = "Controlla i nuovi lead e invia follow-up."
        override val createOpeningToStart: String = "Crea un’apertura da un immobile per iniziare a raccogliere lead."
        override val addFirstPropertyToStart: String = "Aggiungi il primo immobile per iniziare."
        override val nextOpening: String = "Prossima apertura"
        override val quickSignIn: String = "Check-in rapido"
        override val scanQrCode: String = "Scansiona QR"
        override val newLead: String = "Nuovo lead"
        override val myProperties: String = "I miei immobili"
        override val manageListings: String = "Gestisci annunci"
        override val todaysOverview: String = "Panoramica di oggi"
        override val seeAll: String = "Vedi tutto"
        override val propertiesEyebrow: String = "Portfólio"
        override val propertiesSubtitle: String = "Manage active, planned, and archived listings with Supabase-backed media and performance intelligence."
        override val propertiesLiveMetric: String = "live"
        override val propertiesPipelineMetric: String = "pipeline"
        override val propertiesAllTimeMetric: String = "all time"
        override val addProperty: String = "Aggiungi immobile"
        override val editProperty: String = "Modifica immobile"
        override val propertyFallback: String = "Property"
        override val propertyUnavailableTitle: String = "Immobile non disponibile"
        override val propertyUnavailableBody: String = "Refresh the portfolio to reload this listing."
        override val backToProperties: String = "Torna agli immobili"
        override val deletePropertyTitle: String = "Eliminare immobile?"
        override val deletePropertyBody: String = "This will permanently delete the property and its related local records. This cannot be undone."
        override val loadingProperties: String = "Caricamento immobili"
        override val noPropertiesTitle: String = "Nessun immobile per ora"
        override val noPropertiesBody: String = "Add your first property, then create an opening to start collecting leads and seller-ready feedback."
        override val openHouseButton: String = "Crea apertura"
        override val photosTitle: String = "Photos"
        override val photosBody: String = "The first photo is used as the main property image across Portfolio."
        override val uploadPhoto: String = "Carica foto"
        override val noPhotosYet: String = "Nessuna foto caricata."
        override val mainPhoto: String = "Principale"
        override val propertyTitleLabel: String = "Nome dell’immobile"
        override val propertyAddressLine1Label: String = "Indirizzo"
        override val propertyAddressLine2Label: String = "Indirizzo riga 2"
        override val propertyCityLabel: String = "Città"
        override val propertyRegionLabel: String = "Regione"
        override val propertyPostalCodeLabel: String = "CAP"
        override val propertyCountryLabel: String = "Paese"
        override val propertyAskingPriceLabel: String = "Prezzo richiesto"
        override val propertyBedsLabel: String = "Camere"
        override val propertyBathsLabel: String = "Bagni"
        override val propertyInteriorLabel: String = "Interni"
        override val propertyDescriptionLabel: String = "Descrizione"
        override val createPropertyButton: String = "+ Crea immobile"
        override val locateProperty: String = "Localizza immobile"
        override val findLocation: String = "Trova posizione"
        override val find: String = "Trova"
        override val navigate: String = "Naviga"
        override val propertyLocationMarkerTitle: String = "Posizione dell’immobile"
        override val mapKitJsMissingToken: String = "Aggiungi HAVN_MAPKIT_JS_TOKEN a local.properties per la mappa web."
        override val mapKitJsLoading: String = "Caricamento di MapKit JS..."
        override val generateSellerReport: String = "Genera report venditore"
        override val deleteProperty: String = "Elimina immobile"
        override val conversionMetric: String = "Conversione"
        override val propertyPhotoContentDescription: String = "Foto dell’immobile"
        override val deletePhoto: String = "Elimina foto"
        override val movePhotoLeft: String = "Sposta foto a sinistra"
        override val movePhotoRight: String = "Sposta foto a destra"
        override val propertyTitleRequired: String = "Il nome dell’immobile è obbligatorio."
        override val propertyStreetRequired: String = "L’indirizzo è obbligatorio."
        override val propertyCityRequired: String = "La città è obbligatoria."
        override val propertyRegionRequired: String = "La regione è obbligatoria."
        override val propertyPostalRequired: String = "Il CAP è obbligatorio."
        override val propertyAskingPriceInvalid: String = "Inserisci un prezzo richiesto valido."
        override val propertyOwnerContactTitle: String = "Contatto del proprietario"
        override val propertyOwnerSelectContact: String = "Seleziona un contatto esistente come proprietario della proprietà."
        override val propertyOwnerSelected: String = "Proprietario selezionato"
        override val propertyOwnerNoContacts: String = "Non ci sono ancora contatti. Aggiungi il proprietario in Contatti, poi selezionalo qui."
        override val propertyOwnerChooseContact: String = "Scegli contatto"
        override val propertyOwnerChangeContact: String = "Cambia contatto"
        override val propertyOwnerRemoveContact: String = "Rimuovi"
        override val propertyOwnerPickerTitle: String = "Scegli proprietario dell'immobile"
        override val propertyOwnerSearchContact: String = "Cerca contatti"
        override val propertyOwnerSearchHint: String = "Inizia a digitare nome, e-mail o telefono."
        override val propertyOwnerNoMatches: String = "Nessun contatto corrispondente."
        override val propertyOpeningsTitle: String = "Openings"
        override val propertyNoOpenings: String = "No openings scheduled for this property."
        override val teamAccessTitle: String = "Team access"
        override val onlyListingOwner: String = "Only the listing owner"
        override val assignTeam: String = "Assign team"
        override val assignPropertyTitle: String = "Assign property"
        override val assignPropertyBody: String = "Choose who can work this property. Select the whole team or specific agents."
        override val wholeTeam: String = "Whole team"
        override val leadsEyebrow: String = "Leads"
        override val leadFallback: String = "Lead"
        override val leadsSubtitle: String = "Search, filter, and qualify leads captured across every opening."
        override val leadDetailSubtitle: String = "Source, qualification, notes, and follow-up history for this opening lead."
        override val totalMetric: String = "Total"
        override val loggedMetric: String = "logged"
        override val searchLeads: String = "Search leads"
        override val searchLeadsPlaceholder: String = "Name, phone, or email"
        override val allProperties: String = "All properties"
        override val loadingLeads: String = "Loading opening leads"
        override val noLeadsFoundTitle: String = "I lead appariranno qui quando i contatti faranno check-in a un’apertura."
        override val noLeadsEmptyBody: String = "Usa il check-in kiosk o aggiungi contatti manualmente da un’apertura."
        override val noLeadsFilteredBody: String = "Try a different property, status, or search term."
        override val backToLeads: String = "Back to leads"
        override val leadUnavailableTitle: String = "Lead unavailable"
        override val leadUnavailableBody: String = "This lead is no longer available in the current lead list."
        override val leadTemperature: String = "Lead status"
        override val leadLabelSuffix: String = "Lead"
        override val greetingHi: String = "Ciao"
        override val leadActionCall: String = "Chiama"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "E-mail"
        override val leadFollowUp: String = "Follow-up"
        override val leadNoFollowUpScheduled: String = "Nessun follow-up programmato"
        override val leadIntentScore: String = "Punteggio interesse"
        override val leadInterestedIn: String = "Interessato a"
        override val leadGenericGreetingName: String = "ciao"
        override val followUpMessageTypeThankYou: String = "Grazie"
        override val followUpMessageTypePropertyInfo: String = "Info immobile"
        override val followUpMessageTypeFollowUp: String = "Follow-up"
        override val followUpMessageTypeCheckIn: String = "Verifica interesse"
        override val followUpMessageTypePriceUpdate: String = "Aggiornamento prezzo"
        override val followUpMessageTypePropertyBrochure: String = "Foto"
        override val followUpPreview: String = "Anteprima"
        override val followUpSubject: String = "Oggetto"
        override val followUpMessage: String = "Messaggio"
        override val followUpSendViaEmail: String = "Invia via e-mail"
        override val followUpSendViaSms: String = "Invia via SMS"
        override val followUpAiAssistantTitle: String = "Assistente AI"
        override val followUpAiAssistantBody: String = "Genera un messaggio personalizzato in pochi secondi."
        override val followUpGenerateWithAi: String = "Genera con AI"
        override val followUpUpgradeForAi: String = "Sblocca AI"
        override val followUpDefaultSubject: String = "Follow-up su"
        override val privateAgentNotes: String = "Private agent notes"
        override val notes: String = "Notes"
        override val notesPlaceholder: String = "Motivation, preferences, objections, next move"
        override val saveNotes: String = "Save notes"
        override val followUpHistory: String = "Follow-up history"
        override val noFollowUpsLogged: String = "No follow-ups logged yet."
        override val openHousesEyebrow: String = "Showings"
        override val scheduleOpenHouse: String = "Crea visita"
        override val openingDetails: String = "Dettagli apertura"
        override val editOpening: String = "Modifica apertura"
        override val deleteOpening: String = "Elimina apertura"
        override val deleteOpeningBody: String = "Vuoi davvero eliminare questa apertura? L’azione non può essere annullata."
        override val openingName: String = "Nome apertura"
        override val startsAt: String = "Inizia"
        override val endsAt: String = "Finisce"
        override val chooseStartDateTime: String = "Scegli data e ora di inizio"
        override val chooseEndDateTime: String = "Scegli data e ora di fine"
        override val accessNotes: String = "Note di accesso"
        override val privateNotes: String = "Note private"
        override val addPrivateNote: String = "Aggiungi nota privata"
        override val liveDashboard: String = "Live dashboard"
        override val visitorKiosk: String = "Lead kiosk"
        override val openHousesSubtitle: String = "Create openings for properties, review leads, and launch kiosk sessions."
        override val liveMetric: String = "Live"
        override val upcomingMetric: String = "Upcoming"
        override val inProgressMetric: String = "in progress"
        override val scheduledMetric: String = "scheduled"
        override val loadingOpenHouses: String = "Loading openings"
        override val addPropertyFirstTitle: String = "Add a property first"
        override val addPropertyFirstBody: String = "Create an opening from a property to start collecting leads."
        override val noOpenHousesTitle: String = "No openings scheduled"
        override val noOpenHousesBody: String = "Create an opening from a property to start collecting leads."
        override val noSignInsTitle: String = "No sign-ins yet"
        override val noSignInsBody: String = "Leads checked in through kiosk mode will appear here in real time."
        override val dashboard: String = "Dashboard"
        override val start: String = "Start"
        override val end: String = "End"
        override val endOpenHouse: String = "End opening"
        override val reportsEyebrow: String = "Owners"
        override val sellerReportsTitle: String = "Seller reports"
        override val createReport: String = "Create report"
        override val reportPreview: String = "Property Report"
        override val reportsSubtitle: String = "Generate premium post-opening recaps with lead quality, buyer intent, and seller-ready narrative."
        override val reportsMetricSaved: String = "saved"
        override val reportedMetric: String = "reported"
        override val leadsMetric: String = "leads"
        override val createSellerReport: String = "Create seller report"
        override val attendance: String = "Attendance"
        override val savedReports: String = "saved reports"
        override val buyerHeat: String = "Buyer heat"
        override val hotLeads: String = "hot leads"
        override val loadingSellerReports: String = "Loading seller reports"
        override val noSellerReportsTitle: String = "No seller reports yet"
        override val noSellerReportsBody: String = "Choose an opening, add agent notes, preview an export-ready recap, then save it."
        override val chooseOpenHouse: String = "Choose opening"
        override val noOpenHousesAvailable: String = "No openings available yet."
        override val agentNotes: String = "Agent notes"
        override val notesForSeller: String = "Notes for seller"
        override val sellerNotesPlaceholder: String = "Buyer objections, pricing signals, showing feedback, recommended next move"
        override val generatePreview: String = "Generate preview"
        override val noPreviewReadyTitle: String = "No preview ready"
        override val noPreviewReadyBody: String = "Generate a seller report preview before saving."
        override val saveReport: String = "Save report"
        override val reportSaved: String = "Report saved"
        override val sellerOpenHouseReport: String = "Seller opening report"
        override val mostCommonBuyerInterest: String = "Most common buyer interest"
        override val followUpsSent: String = "Follow-ups sent"
        override val summary: String = "Summary"
        override val noPrivateNotesAdded: String = "No private notes added."
        override val openHouseReport: String = "Opening report"
        override val searchProperties: String = "Cerca immobili"
        override val searchOpenings: String = "Cerca visite"
        override val noOpeningsFoundTitle: String = "No openings found"
        override val noOpeningsFoundBody: String = "Try another search or opening status filter."
        override val noMatchingPropertiesTitle: String = "No matching properties"
        override val noMatchingPropertiesBody: String = "Try another search or status filter."
        override val clientsTitle: String = "Contatti"
        override val clientFallback: String = "Contacto"
        override val addClient: String = "Aggiungi contatto"
        override val editClient: String = "Modifica contatto"
        override val newClient: String = "Nuovo contatto"
        override val saveClient: String = "Salva contatto"
        override val createClient: String = "Crea contatto"
        override val deleteClientTitle: String = "Delete contact?"
        override val deleteClientBody: String = "This will permanently delete the contact. This cannot be undone."
        override val firstName: String = "Nome"
        override val lastName: String = "Cognome"
        override val email: String = "Email"
        override val phone: String = "Telefono"
        override val comments: String = "Commenti"
        override val addPhoto: String = "Add photo"
        override val sendQr: String = "Send QR"
        override val photo: String = "Photo"
        override val clientDetailSubtitle: String = "QR identity, contact details, comments, and openings connected through leads."
        override val clientFormEditSubtitle: String = "Update contact details, delivery info, and comments."
        override val clientFormNewSubtitle: String = "Register a buyer/contact and generate a reusable QR identity for openings."
        override val searchClients: String = "Cerca contatti"
        override val noClientsYetTitle: String = "No contacts yet"
        override val noClientsYetBody: String = "Register contacts first, then send their QR code by email or SMS before an opening."
        override val noClientsFoundTitle: String = "No contacts found"
        override val noClientsFoundBody: String = "Try another name, phone, or email."
        override val clientUnavailableTitle: String = "Contact unavailable"
        override val clientUnavailableBody: String = "Refresh the contacts list and open this record again."
        override val noCommentsAdded: String = "No comments added."
        override val openingsTitle: String = "Visite"
        override val clientOpeningsEmpty: String = "No openings connected yet. Leads connect a contact to an opening."
        override val clientPassLabel: String = "Pass"
        override val clientNoEmail: String = "No email"
        override val visitorsBody: String = "Open kiosk mode, scan a contact QR, or add existing contacts as leads for this opening."
        override val openKiosk: String = "Apri kiosk"
        override val addQrClient: String = "Aggiungi contatto QR"
        override val addManually: String = "Aggiungi manualmente"
        override val selectClients: String = "Seleziona contatti"
        override val selectClientsBody: String = "Choose contacts from your list. Each selected contact becomes a lead for this opening."
        override val kioskCheckIn: String = "Kiosk check-in"
        override val kioskCheckInBody: String = "Use the rear camera to scan the contact's HAVN Wallet QR. When the code is recognized, HAVN creates the lead for this opening automatically."
        override val scanWithCamera: String = "Scan with rear camera"
        override val clientQrImage: String = "Contact QR image"
        override val clientQrImageBody: String = "Keep the contact's QR inside the gold square. HAVN collects each scan below."
        override val scanMultipleQrBody: String = "Scan one or more HAVN contact QR codes, then tap Add QR contact."
        override val scannedQrReady: String = "contact QR ready to add"
        override val createLeadFromQr: String = "Create lead from QR"
        override val noClientsFoundShort: String = "No contacts found."
        override val remove: String = "Rimuovi"
    }
}
